const it = {
  _name: 'Italiano',
  _flag: '\u{1F1EE}\u{1F1F9}',

    'comm.anonymousVisitor': 'Visitatore anonimo',
  'comm.deletedVisitor': 'Visitatore eliminato',
'notifAuto.timezone': 'Fuso orario',
  'notifAuto.timezoneHint': 'Determina quando vengono inviati i promemoria',
  'notifAuto.tzKyiv': 'Kiev (UTC+2/+3)',
  'notifAuto.tzWarsaw': 'Varsavia (UTC+1/+2)',
  'notifAuto.tzBerlin': 'Berlino (UTC+1/+2)',
  'notifAuto.tzParis': 'Parigi (UTC+1/+2)',
  'notifAuto.tzLondon': 'Londra (UTC+0/+1)',
  'notifAuto.tzMadrid': 'Madrid (UTC+1/+2)',
  'notifAuto.tzRome': 'Roma (UTC+1/+2)',
  'notifAuto.tzNewYork': 'New York (UTC-5/-4)',

  'errors.rateLimited': 'Troppe richieste. Riprova tra {seconds} s 🙂',
  'errors.serverError': 'Errore del server. Riprova tra un momento',
  'errors.networkError': 'Nessuna connessione. Controlla la tua rete',

  // ── Navigation sections ──
  'nav.businessMonitor': 'Monitor Business',
  'nav.dashboard': 'Pannello',
  'nav.clients': 'Clienti',
  'nav.communication': 'Comunicazione',
  'nav.staff': 'Personale',
  'nav.inventory': 'Magazzino',
  'nav.salary': 'Stipendi',
  'nav.finances': 'Finanze',
  'nav.system': 'Sistema',
  'nav.integrations': 'Integrazioni',
  'nav.sales': 'Vendite',

  // ── Navigation items ──
  'nav.pos': 'Negozio',
  'nav.salesProducts': 'Spedizione magazzino',
  'nav.salesServices': 'Prenota servizi',
  'nav.clientsBase': 'Base clienti',
  'nav.categories': 'Categorie clienti',
  'nav.messages': 'Messaggi',
  'nav.employees': 'Dipendenti',
  'nav.schedule': 'Orario di lavoro',
  'nav.scheduleTemplates': 'Modelli di orario',
  'nav.services': 'Servizi',
  'nav.tariffPlans': 'Piani tariffari',
  'nav.products': 'Prodotti',
  'nav.stock': 'Giacenze',
  'nav.purchases': 'Acquisti',
  'nav.movements': 'Movimenti di magazzino',
  'nav.orders': 'Ordini',
  'nav.salaryCalc': 'Calcolo',
  'nav.salarySchemes': 'Schemi di motivazione',
  'nav.financialOps': 'Operazioni finanziarie',
  'nav.cashRegister': 'Cassa',
  'nav.reports': 'Report',
  'nav.financialResult': 'Risultato finanziario',
  'nav.users': 'Utenti',
  'nav.roles': 'Ruoli',
  'nav.checkbox': 'Checkbox POS',
  'nav.telegram': 'Promemoria Telegram',
  'nav.sms': 'Invio SMS',
  'nav.email': 'Invio Email',
  'nav.novaPoshta': 'Nova Poshta',
  'nav.meestExpress': 'Meest Express',
  'nav.olx': 'OLX',
  'olx.tagline': 'Messaggi degli annunci + sincronizzazione catalogo',
  'olx.connected': 'Connesso',
  'olx.notConnected': 'Non connesso',
  'olx.connectIntro': 'Connetti il tuo account OLX tramite OAuth per ricevere i messaggi degli annunci nel CRM e pubblicare prodotti come annunci.',
  'olx.connectBtn': 'Connetti OLX',
  'olx.tabOpened': 'OLX aperto in una nuova scheda. Autorizza e torna qui.',
  'olx.connectFailed': 'Connessione fallita:',
  'olx.connectedToast': 'OLX connesso',
  'olx.confirmDisconnect': 'Disconnettere l\'integrazione OLX?',
  'olx.disconnected': 'OLX disconnesso',
  'olx.disconnectBtn': 'Disconnetti',
  'olx.testBtn': 'Prova connessione',
  'olx.testOk': 'Connesso come: {name} (ID {id})',
  'olx.testFailed': 'Prova fallita',
  'olx.accountId': 'OLX ID',
  'olx.scope': 'Permessi',
  'olx.connectedAt': 'Connesso il',
  'olx.reconnectRequired': 'Ri-autorizzazione richiesta',
  'olx.reconnectExplain': 'OLX ha revocato i nostri token (di solito dopo 30 giorni di inattività o un cambio password). Clicca su «Connetti OLX» per riprendere a ricevere messaggi.',
  'olx.refreshBtn': 'Cerca nuovi messaggi',
  'olx.refreshFound': '{n} nuovi messaggi — guarda in Comunicazioni',
  'olx.refreshNoNew': 'Nessun nuovo messaggio',
  'olx.refreshFailed': 'Aggiornamento fallito',
  'comm.olxThreadMissing': 'Impossibile determinare il thread OLX',
  'olx.howItWorks': 'Come funziona',
  'olx.step1': 'Clicca «Connetti OLX» — l\'autorizzazione OLX si apre in una nuova scheda.',
  'olx.step2': 'Accedi al tuo account OLX e concedi l\'accesso all\'app.',
  'olx.step3': 'Torna qui — lo stato si aggiornerà automaticamente; verifica con «Prova connessione».',
  'olx.capabilities': 'Cosa sblocca l\'integrazione',
  'olx.capInboxTitle': 'Chat degli annunci — dentro il CRM',
  'olx.capInboxText': 'Ogni messaggio dell\'acquirente sui tuoi annunci OLX appare in Sidebar → Comunicazioni. Controllo ogni 10 min; usa «Cerca nuovi messaggi» sopra per un fetch immediato.',
  'olx.capOutboundTitle': 'Rispondi dal CRM direttamente nella chat OLX',
  'olx.capOutboundText': 'Apri un thread in Comunicazioni, scegli il canale OLX — il tuo testo arriva nella chat OLX dell\'acquirente come se l\'avessi scritto su olx.ua.',
  'olx.capPublishTitle': 'Pubblica prodotti come annunci OLX',
  'olx.capPublishText': 'Sidebar → Inventario → apri un prodotto → «Pubblica su OLX». Titolo, descrizione, prezzo e foto sono pre-compilati — scegli categoria, città, contatto e l\'annuncio va in moderazione OLX.',
  'olx.limitations': 'Limitazioni',
  'olx.limitationsText': 'Gli ordini OLX Delivery non sono ancora esposti dall\'API partner. Gestiscili su olx.ua per ora.',
  'nav.locations': 'Sedi',
  'nav.myPlan': 'Il Mio Piano',
  'nav.onlineBooking': 'Prenotazione online',
  'nav.help': 'Aiuto',
  'booking.title': 'Prenotazione online',
  'booking.subtitle': 'Configura la pagina pubblica di prenotazione per i tuoi clienti',
  'booking.enable': 'Attiva prenotazione online',
  'booking.yourLink': 'Il tuo link',
  'booking.copy': 'Copia',
  'booking.urlCopied': 'Link copiato',
  'booking.linkHint': 'Condividi questo link con i tuoi clienti — su Instagram, Telegram, il tuo sito',
  'booking.businessInfo': 'Informazioni sull\'attività',
  'booking.businessName': 'Nome dell\'attività',
  'booking.businessNameHint': 'Come ti vedranno i clienti',
  'booking.slug': 'Identificatore URL',
  'booking.slugHint': 'Lettere latine, numeri, trattini. Es: mio-salone',
  'booking.description': 'Descrizione',
  'booking.descriptionHint': 'Breve descrizione della tua attività',
  'booking.themeColor': 'Colore del tema',
  'booking.locale': 'Lingua della pagina',
  'booking.rules': 'Regole di prenotazione',
  'booking.minHours': 'Preavviso minimo',
  'booking.hours': 'ore',
  'booking.minHoursHint': 'Con quante ore di anticipo si può prenotare',
  'booking.maxDays': 'Profondità max.',
  'booking.days': 'giorni',
  'booking.maxDaysHint': 'Quanti giorni in anticipo è disponibile la prenotazione',
  'booking.allowedServices': 'Servizi per prenotazione online',
  'booking.allowedServicesHint': 'Seleziona i servizi disponibili online. Se nessuno selezionato — tutti disponibili.',
  'booking.allowedStaff': 'Specialisti per prenotazione online',
  'booking.allowedStaffHint': 'Seleziona gli specialisti disponibili online. Se nessuno selezionato — tutti disponibili.',
  'booking.selectAll': 'Seleziona tutto',
  'booking.deselectAll': 'Deseleziona tutto',
  'booking.tabGeneral': 'Generale',
  'booking.tabServices': 'Servizi',
  'booking.tabProducts': 'Prodotti',
  'booking.tabAfter': 'Dopo',
  'booking.serviceCategories': 'Categorie servizi',
  'booking.serviceCategoriesHint': 'Seleziona le categorie per la prenotazione. Se nessuna — tutte disponibili.',
  'booking.productCategories': 'Categorie prodotti',
  'booking.productCategoriesHint': 'Seleziona le categorie per la vendita. Se nessuna — tutte disponibili.',
  'booking.noCategoriesYet': 'Nessuna categoria. Creale nella sezione corrispondente.',
  'booking.mode': 'Modalità',
  'booking.modeServices': 'Servizi',
  'booking.modeShop': 'Negozio',
  'booking.modeBoth': 'Entrambi',
  'booking.modeHint': 'Servizi — prenotazione. Negozio — ordini online. Entrambi — servizi e prodotti.',
  'booking.shopSettings': 'Impostazioni negozio',
  'booking.shopMinOrder': 'Ordine minimo',
  'booking.shopShowOutOfStock': 'Esauriti',
  'booking.shopShowOutOfStockLabel': 'Mostra prodotti esauriti',
  'booking.shopDelivery': 'Metodi di consegna',
  'booking.deliveryPickup': 'Ritiro',
  'booking.deliveryNP': 'Nova Poshta',
  'booking.deliveryMeest': 'Meest Express',
  'booking.deliveryCourier': 'Corriere',
  'booking.gallery': 'Galleria',
  'booking.galleryHint': 'Foto di lavori, interni, prodotti — fino a 10 immagini',
  'booking.galleryCount': 'foto',
  'booking.promo': 'Banner promozionale',
  'booking.promoEnable': 'Mostra banner',
  'booking.promoText': 'Testo promo',
  'booking.promoPlaceholder': 'Es.: -20% sulla prima visita',
  'booking.promoColor': 'Colore',
  'booking.colorScheme': 'Schema colori',
  'booking.bgColor': 'Colore sfondo',
  'booking.presetLight': 'Chiaro',
  'booking.presetDark': 'Scuro',
  'booking.presetWarm': 'Caldo',
  'booking.presetFresh': 'Fresco',
  'booking.presetRose': 'Rosa',
  'booking.presetPurple': 'Viola',
  'booking.branding': 'Branding',
  'booking.logo': 'Logo',
  'booking.uploadLogo': 'Carica logo',
  'booking.changeLogo': 'Cambia logo',
  'booking.headerImage': 'Immagine di intestazione',
  'booking.uploadImage': 'Carica foto',
  'booking.changeImage': 'Cambia foto',
  'booking.logoTooLarge': 'Il logo è troppo grande. Massimo 1 MB.',
  'booking.imageTooLarge': 'L\'immagine è troppo grande. Massimo 5 MB.',
  'booking.headerImageHint': 'Foto della tua attività — salone, studio, negozio',
  'booking.contacts': 'Contatti',
  'booking.contactsHint': 'Indirizzo e orario sono presi dalle impostazioni della sede',
  'booking.address': 'Indirizzo',
  'booking.addressHint': 'Via, numero, città',
  'booking.businessPhone': 'Telefono',
  'booking.website': 'Sito web',
  'booking.workingHours': 'Orario di lavoro',
  'booking.workingHoursHint': 'Lun-Ven 9:00-18:00',
  'booking.afterBooking': 'Dopo la prenotazione',
  'booking.successMsg': 'Messaggio di conferma',
  'booking.successMsgHint': 'Es: Vi aspettiamo! Non dimenticate il documento.',
  'booking.cancelPolicy': 'Politica di cancellazione',
  'booking.cancelPolicyHint': 'Es: Cancellazione possibile fino a 24 ore prima',
  'booking.disableTitle': 'Disattivare la prenotazione online?',
  'booking.disableText': 'I clienti non potranno più prenotare online. Puoi riattivarlo in qualsiasi momento.',
  'booking.disableConfirm': 'Disattiva',

  // ── Calendar months & days ──
  'months.0': 'Gennaio', 'months.1': 'Febbraio', 'months.2': 'Marzo',
  'months.3': 'Aprile', 'months.4': 'Maggio', 'months.5': 'Giugno',
  'months.6': 'Luglio', 'months.7': 'Agosto', 'months.8': 'Settembre',
  'months.9': 'Ottobre', 'months.10': 'Novembre', 'months.11': 'Dicembre',
  'dow.0': 'Lu', 'dow.1': 'Ma', 'dow.2': 'Me',
  'dow.3': 'Gi', 'dow.4': 'Ve', 'dow.5': 'Sa', 'dow.6': 'Do',

  // ── Common UI ──
  'common.save': 'Salva',
  'common.saving': 'Salvataggio...',
  'common.saved': 'Salvato',
  'common.cancel': 'Annulla',
  'common.delete': 'Elimina',
  'common.edit': 'Modifica',
  'common.add': 'Aggiungi',
  'common.search': 'Cerca',
  'onboarding.title': 'Configura la tua attività',
  'onboarding.subtitle': '{done} di {total} passaggi completati',
  'onboarding.allDone': 'Tutto configurato!',
  'onboarding.allDoneHint': 'Sei pronto per lavorare 💪',
  'onboarding.stepBusiness': 'Tipo di attività selezionato',
  'onboarding.stepStaff': 'Aggiungi il primo dipendente',
  'onboarding.stepService': 'Aggiungi il primo servizio',
  'onboarding.stepAppointment': 'Crea il primo appuntamento',
  'onboarding.stepClient': 'Aggiungi il primo cliente',
  'onboarding.noStaffYet': 'Nessun dipendente',
  'onboarding.noStaffHint': 'Aggiungi il primo dipendente per iniziare ad accettare appuntamenti',
  'onboarding.goAddStaff': '+ Aggiungi dipendente',
  'gsearch.placeholder': 'Cerca clienti, appuntamenti, personale...',
  'gsearch.quickActions': 'Azioni rapide',
  'gsearch.customers': 'Clienti',
  'gsearch.staff': 'Personale',
  'gsearch.appointments': 'Appuntamenti',
  'gsearch.noResults': 'Nessun risultato',
  'gsearch.goCalendar': 'Calendario — oggi',
  'gsearch.goClients': 'Base clienti',
  'gsearch.goFinances': 'Finanze',
  'gsearch.goDashboard': 'Dashboard',
  'gsearch.newClient': 'Nuovo cliente',
  'common.close': 'Chiudi',
  'common.loading': 'Caricamento...',
  'common.yes': 'S\u00ec',
  'common.no': 'No',
  'common.and': 'e',
  'common.confirm': 'Conferma',
  'common.back': 'Indietro',
  'common.next': 'Avanti',
  'common.create': 'Crea',
  'common.actions': 'Azioni',
  'common.name': 'Nome',
  'common.phone': 'Telefono',
  'common.email': 'Email',
  'common.date': 'Data',
  'common.time': 'Ora',
  'common.status': 'Stato',
  'common.total': 'Totale',
  'common.price': 'Prezzo',
  'common.quantity': 'Quantit\u00e0',
  'common.note': 'Nota',
  'common.all': 'Tutti',
  'common.filter': 'Filtro',
  'common.export': 'Esporta',
  'common.shown': 'Mostrato',
  'common.of': 'di',
  'common.logout': 'Esci',
  'common.profile': 'Profilo',
  'common.settings': 'Impostazioni',
  'common.language': 'Lingua',

  // ── Clients page ──
  'clients.title': 'Base clienti',
  'clients.subtitle': 'Gestione schede clienti',
  'clients.addClient': 'Aggiungi cliente',
  'clients.import': 'Importa',
  'import.title': 'Importa clienti',
  'import.uploadHint': 'Carica un file con il tuo database clienti. Sono supportati Excel e CSV.',
  'import.maxRows': 'massimo {max} righe',
  'import.tooManyRowsTitle': 'File troppo grande',
  'import.tooManyRowsBody': 'Il file ha {count} righe — il massimo per importazione è {max}. Dividi il file in parti più piccole o contatta il supporto.',
  'import.selectFile': 'Seleziona file',
  'import.downloadTemplate': 'Scarica modello',
  'import.or': 'o',
  'import.rows': 'righe',
  'import.fieldName': 'Nome',
  'import.fieldLastName': 'Cognome',
  'import.fieldFirstName': 'Nome',
  'import.fieldPhone': 'Telefono',
  'import.fieldAdditionalPhone': 'Tel. aggiuntivo',
  'import.fieldEmail': 'Email',
  'import.fieldGender': 'Genere',
  'import.fieldBirthday': 'Data di nascita',
  'import.fieldCategory': 'Categoria',
  'import.fieldCardNumber': 'Nº tessera',
  'import.fieldNote': 'Nota',

  'importProducts.btn': 'Importa',
  'importProducts.btnTitle': 'Importazione in blocco di prodotti da Excel/CSV',
  'importProducts.title': 'Importa prodotti',
  'importProducts.uploadHint': 'Carica un file Excel o CSV con i tuoi prodotti. Campi obbligatori: nome e prezzo di vendita.',
  'importProducts.maxRows': 'massimo {max} righe',
  'importProducts.tooManyRowsTitle': 'File troppo grande',
  'importProducts.tooManyRowsBody': 'Il file ha {count} righe — il massimo per importazione è {max}. Suddividilo in file più piccoli.',
  'importProducts.selectFile': 'Seleziona file',
  'importProducts.downloadTemplate': 'Scarica modello',
  'importProducts.or': 'o',
  'importProducts.rows': 'righe',
  'importProducts.fieldName': 'Nome',
  'importProducts.fieldSku': 'SKU',
  'importProducts.fieldCategory': 'Categoria',
  'importProducts.fieldUnit': 'Unità',
  'importProducts.fieldMinStock': 'Stock min.',
  'importProducts.fieldSellPrice': 'Prezzo di vendita',
  'importProducts.statusCol': 'Stato',
  'importProducts.mapHint': 'Abbina le colonne del file ai campi prodotto. I campi obbligatori sono contrassegnati con un asterisco.',
  'importProducts.notMapped': 'non selezionato',
  'importProducts.back': 'Indietro',
  'importProducts.next': 'Avanti',
  'importProducts.startOver': 'Altro file',
  'importProducts.willImport': 'verranno importati',
  'importProducts.willSkip': 'verranno saltati',
  'importProducts.newCategories': 'nuove categorie',
  'importProducts.newCategoriesWarning': 'Il file menziona categorie non ancora esistenti — verranno create automaticamente durante l\'importazione.',
  'importProducts.errMissingName': 'Nome vuoto',
  'importProducts.errInvalidPrice': 'Prezzo non valido',
  'importProducts.errInvalidMinStock': 'Stock min. non valido',
  'importProducts.errSkuExisting': 'SKU già esistente',
  'importProducts.previewTruncated': 'Mostrate le prime 100 di {count}',
  'importProducts.importing': 'Importazione...',
  'importProducts.importBtn': 'Importa {count}',
  'importProducts.doneTitle': 'Importati {count} prodotti',
  'importProducts.doneNewCategories': 'Create {count} nuove categorie',
  'importProducts.doneSkipped': 'Saltate {count} righe',
  'importProducts.close': 'Chiudi',
  'importProducts.toastSuccess': 'Prodotti importati',

  'importServices.btn': 'Importa',
  'importServices.btnTitle': 'Importazione in blocco di servizi da Excel/CSV',
  'importServices.title': 'Importa servizi',
  'importServices.uploadHint': 'Carica un file Excel o CSV con i tuoi servizi. Richiesti: nome e prezzo. Durata predefinita: 30 min.',
  'importServices.maxRows': 'massimo {max} righe',
  'importServices.tooManyRowsTitle': 'File troppo grande',
  'importServices.tooManyRowsBody': 'Il file ha {count} righe — il massimo per importazione è {max}.',
  'importServices.selectFile': 'Seleziona file',
  'importServices.downloadTemplate': 'Scarica modello',
  'importServices.or': 'o',
  'importServices.rows': 'righe',
  'importServices.fieldName': 'Nome',
  'importServices.fieldGroup': 'Gruppo',
  'importServices.fieldPrice': 'Prezzo',
  'importServices.fieldDuration': 'Durata (min)',
  'importServices.statusCol': 'Stato',
  'importServices.mapHint': 'Abbina le colonne del file ai campi servizio. I campi obbligatori sono contrassegnati con un asterisco.',
  'importServices.notMapped': 'non selezionato',
  'importServices.back': 'Indietro',
  'importServices.next': 'Avanti',
  'importServices.startOver': 'Altro file',
  'importServices.willImport': 'verranno importati',
  'importServices.willSkip': 'verranno saltati',
  'importServices.newGroups': 'nuovi gruppi',
  'importServices.newGroupsWarning': 'Il file menziona gruppi non ancora esistenti — verranno creati automaticamente.',
  'importServices.errMissingName': 'Nome vuoto',
  'importServices.errInvalidPrice': 'Prezzo non valido',
  'importServices.errInvalidDuration': 'Durata non valida (1-1440 min)',
  'importServices.errNameExisting': 'Il servizio esiste già',
  'importServices.previewTruncated': 'Mostrate le prime 100 di {count}',
  'importServices.importing': 'Importazione...',
  'importServices.importBtn': 'Importa {count}',
  'importServices.doneTitle': 'Importati {count} servizi',
  'importServices.doneNewGroups': 'Creati {count} nuovi gruppi',
  'importServices.doneSkipped': 'Saltate {count} righe',
  'importServices.close': 'Chiudi',
  'importServices.toastSuccess': 'Servizi importati',

  'import.skip': 'salta',
  'import.phoneRequired': 'Il campo "Telefono" è obbligatorio',
  'import.preview': 'Anteprima',
  'import.back': 'Indietro',
  'import.adjustColumns': 'Regola colonne',
  'import.newClients': 'Nuovi clienti',
  'import.duplicates': 'Duplicati (saltati)',
  'import.duplicate': 'duplicato',
  'import.new': 'nuovo',
  'import.status': 'Stato',
  'import.andMore': '...e altri {count}',
  'import.importing': 'Importazione...',
  'import.importBtn': 'Importa ({count})',
  'import.success': '{count} clienti importati!',
  'import.skippedDuplicates': '{count} duplicati saltati',
  'import.error': 'Errore di importazione',
  'import.close': 'Chiudi',
  'helpPage.title': 'Help',
  'helpPage.subtitle': 'Guides and instructions for Systemic CRM',
  'clients.searchPlaceholder': 'Cerca per nome, telefono, email, numero tessera...',
  'clients.allCategories': 'Tutte le categorie',
  'clients.clientsCount': 'Clienti',
  'clients.grid': 'Griglia',
  'clients.list': 'Elenco',
  'clients.deleteTitle': 'Eliminare il cliente?',
  'clients.deleteMessage': 'Stai per eliminare la scheda del cliente',
  'clients.cannotDeleteTitle': 'Impossibile eliminare',
  'clients.cannotDeleteMessage': 'Il cliente ha appuntamenti o storico finanziario e non pu\u00f2 essere eliminato',
  'clients.duplicatePhone': 'Un cliente con questo numero di telefono esiste già',
  'clients.duplicatePhoneWithName': 'Un cliente con questo telefono esiste già: {name}',
  'clients.openExisting': 'Apri cliente',
  'clients.understood': 'Capito',
  'clients.deleteWarning': 'Questa azione \u00e8 irreversibile. Tutti i dati del cliente saranno persi.',

  // ── Delete modal ──
  'delete.title': 'Conferma eliminazione',
  'delete.message': 'Stai per eliminare un record',
  'delete.confirm': 'S\u00ec, elimina',
  'delete.warning': 'Questa azione \u00e8 irreversibile. Tutti i dati saranno persi.',

  // ── Sidebar ──
  'sidebar.crmSystem': 'Sistema CRM',
  'sidebar.version': 'v1.0',

  // ── Login ──
  'login.title': 'Accesso',
  'login.setupTitle': 'Configurazione del sistema',
  'login.setupSubtitle': 'Crea un account amministratore',
  'login.subtitle': 'Inserisci le tue credenziali',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.submit': 'Accedi',
  'login.setupSubmit': 'Crea amministratore',
  'login.wait': 'Attendere\u2026',
  'login.forgotPassword': 'Password dimenticata?',
  'login.resetTitle': 'Reimposta password',
  'login.resetSubtitle': 'Inserisci email — ti invieremo le istruzioni',
  'login.resetSend': 'Invia',
  'login.resetSentHint': 'Controlla la tua email — abbiamo inviato le istruzioni',
  'login.backToLogin': 'Torna al login',
  'login.nameLabel': 'Nome',
  'login.namePlaceholder': 'Il tuo nome',
  'login.businessLabel': "Nome dell'attività",
  'login.businessPlaceholder': 'Il mio salone / negozio / studio',
  'login.errorEnterBusiness': "Inserisci il nome dell'attività",
  'login.businessTypeLabel': "Tipo di attività",
  'login.businessTypePlaceholder': "Seleziona il tipo di attività...",
  'login.errorSelectBusinessType': "Seleziona il tipo di attività",
  'login.showPassword': 'Mostra password',
  'login.hidePassword': 'Nascondi password',
  'login.errorInvalidCreds': 'Email o password non validi',
  'login.errorTooMany': 'Troppi tentativi. Riprova pi\u00f9 tardi.',
  'login.errorGeneric': 'Errore di accesso: ',
  'login.errorEnterName': 'Inserisci il tuo nome',
  'login.errorEnterEmail': 'Inserisci email',
  'login.errorMinPassword': 'La password deve avere almeno 6 caratteri',
  'login.errorSetup': 'Errore: ',
  'login.tabLogin': 'Accedi',
  'login.tabRegister': 'Registrati',
  'login.registerTitle': 'Crea account',
  'login.registerSubtitle': '7 giorni gratis, tutti i moduli inclusi',
  'login.registerSubmit': 'Registrati',
  'login.registerSuccess': 'Account creato! Accesso in corso...',
  'login.errorEmailExists': 'Questa email è già registrata',
  'login.errorRegister': 'Errore di registrazione: ',
  'login.confirmPassword': 'Conferma password',
  'login.errorPasswordMismatch': 'Le password non corrispondono',
  'login.agreeTerms': 'Registrandoti, accetti i',
  'login.agreeCheckbox': 'Accetto i',
  'login.errorAgreeTerms': 'Devi accettare i termini di servizio',
  'login.terms': 'Termini di servizio',
  'login.privacy': 'Informativa sulla privacy',

  // ── Blocked ──
  'blocked.title': 'Account bloccato',
  'blocked.desc': "Contattare l'amministratore per ripristinare l'accesso",
  'blocked.trialExpired': 'Periodo di prova terminato',
  'blocked.trialExpiredDesc': 'Scegli un piano per continuare',
  'blocked.paymentOverdue': 'Abbonamento scaduto',
  'blocked.paymentOverdueDesc': 'Il tuo abbonamento è scaduto. Rinnovalo per continuare a lavorare.',
  'blocked.subscriptionExpiredDesc': 'Il tuo abbonamento è scaduto. Rinnovalo per continuare a lavorare.',
  'blocked.contact': 'Contatta il supporto',
  'blocked.logout': 'Esci',

  // ── My Plan ──
  'myPlan.title': 'Il Mio Piano',
  'myPlan.subtitle': 'Gestione abbonamento',
  'myPlan.loadError': 'Impossibile caricare i dati del piano',
  'myPlan.trial': 'Prova',
  'myPlan.active': 'Attivo',
  'myPlan.trialExpired': 'Prova scaduta',
  'myPlan.blocked': 'Bloccato',
  'myPlan.daysLeft': 'giorni rimasti',
  'myPlan.month': 'mese',
  'myPlan.year': 'anno',
  'myPlan.orYearly': 'o',
  'myPlan.chooseBillingPeriod': 'scegli periodo di pagamento',
  'myPlan.periodMonthly': 'Mensile',
  'myPlan.periodYearly': 'Annuale',
  'myPlan.yearlySaving': 'risparmi {n} ₴ vs mensile',
  'myPlan.monthlyTotal': '{n} ₴/anno',
  'myPlan.proceedToPayment': 'Procedi al pagamento',
  'myPlan.cancel': 'Annulla',
  'myPlan.oldRateTitle': 'Hai una tariffa precedente',
  'myPlan.oldRateText': 'Attualmente paghi {old} ₴; la tariffa attuale per {plan} è {new} ₴. Puoi mantenere la tariffa precedente a tempo indeterminato o passare a quella nuova.',
  'myPlan.upgradeRate': 'Passa alla nuova tariffa',
  'myPlan.users': 'Utenti',
  'myPlan.locations': 'Sedi',
  'myPlan.availablePlans': 'Piani disponibili',
  'myPlan.popular': 'Popolare',
  'myPlan.usersIncl': 'utenti',
  'myPlan.locationsIncl': 'sedi',
  'myPlan.allModules': 'Tutti i 46 moduli',
  'myPlan.trialActive': 'Prova attiva',
  'myPlan.currentPlan': 'Piano attuale',
  'myPlan.upgrade': 'Scegli piano',
  'myPlan.changePlan': 'Cambia piano',
  'myPlan.trialHint': 'Dopo il periodo di prova, scegli un piano per continuare. Tutti i tuoi dati saranno conservati.',
  'myPlan.limitUsers': 'Limite utenti raggiunto. Aggiorna il piano per aggiungerne altri.',
  'myPlan.limitLocations': 'Limite sedi raggiunto. Aggiorna il piano per aggiungerne altre.',
  'myPlan.cancelSubscription': 'Annulla abbonamento',
  'myPlan.cancelledNotice': 'Abbonamento annullato. Il piano rimane attivo fino alla fine del periodo pagato.',
  'myPlan.cancelTitle': 'Annullare l\'abbonamento?',
  'myPlan.cancelDescription': 'Il piano rimarrà attivo fino alla fine del periodo pagato. Successivamente, il tuo account sarà declassato al piano di prova.',
  'myPlan.cancelReasonLabel': 'Motivo dell\'annullamento (facoltativo)',
  'myPlan.cancelReasonPlaceholder': 'Raccontaci perché hai deciso di annullare...',
  'myPlan.confirmCancel': 'Sì, annulla',
  'myPlan.keepSubscription': 'Mantieni abbonamento',
  'myPlan.cancelError': 'Errore di annullamento',
  'myPlan.subscriptionExpired': 'scaduto',

  // ── Checkout (post-registration) ──
  'checkout.title': 'Il tuo account è pronto!',
  'checkout.subtitle': 'Scegli come iniziare con Systemic CRM',
  'checkout.recommended': 'Consigliato',
  'checkout.payNow': 'Paga e inizia',
  'checkout.trialTitle': 'Prova gratuita',
  'checkout.days': 'giorni',
  'checkout.trialFeature1': 'Accesso completo a tutte le funzionalità',
  'checkout.trialFeature2': 'Senza impegno',
  'checkout.trialFeature3': 'I tuoi dati vengono conservati dopo il pagamento',
  'checkout.tryFree': 'Prova gratis',

  // ── Dashboard ──
  'dash.title': 'Pannello',
  'dash.myOffice': 'Il mio ufficio',
  'dash.subtitle': 'Schermata principale',
  'dash.personalStats': 'Statistiche personali',
  'dash.todayAppointments': 'Appuntamenti oggi',
  'dash.completed': 'completati',
  'dash.todayRevenue': 'Ricavi di oggi',
  'dash.clientsCount': 'Clienti',
  'dash.newThisMonth': 'questo mese',
  'dash.unread': 'Non letti',
  'dash.todaySchedule': 'Programma di oggi',
  'dash.allAppointments': 'Tutti gli appuntamenti',
  'dash.noAppointmentsToday': 'Nessun appuntamento oggi',
  'dash.moreAppointments': 'appuntamenti',
  'dash.weekRevenue': 'Ricavi settimanali',
  'dash.needsAttention': 'Richiede attenzione',
  'dash.unreadMessages': 'messaggi non letti',
  'dash.lowStock': 'scorte basse',
  'dash.topClients': 'Top clienti (mese)',
  'dash.noPaymentsThisMonth': 'Nessun pagamento questo mese',
  'dash.birthdays': 'Compleanni',
  'dash.noBirthdaysThisWeek': 'Nessun compleanno questa settimana',
  'dash.today': 'Oggi!',
  'dash.tomorrow': 'Domani',
  'dash.inDays': 'Tra {n} gg.',
  'dash.congratulate': 'Augurare',
  'dash.atRisk': 'A rischio di perdita',
  'dash.allClientsActive': 'Tutti i clienti sono attivi',
  'dash.daysWithoutVisit': 'giorni senza visita',
  'dash.write': 'Scrivi',
  'dash.todayOrderSales': 'Vendite prodotti',
  'dash.serviceSales': 'Vendite servizi',
  'dash.appointmentsToday': 'appuntamenti oggi',
  'dash.ordersToday': 'ordini oggi',
  'dash.activeOrders': 'attivi',
  'dash.recentOrders': 'Ordini recenti',
  'dash.allOrders': 'Tutti gli ordini',
  'dash.items': 'articoli',
  'dash.statusWaiting': 'In attesa',
  'dash.statusConfirmed': 'Completato',
  'dash.statusArrived': 'Arrivato',
  'dash.statusNoShow': 'Assente',
  'dash.dowSun': 'Do', 'dash.dowMon': 'Lu', 'dash.dowTue': 'Ma',
  'dash.dowWed': 'Me', 'dash.dowThu': 'Gi', 'dash.dowFri': 'Ve', 'dash.dowSat': 'Sa',

  // ── Profile modal ──
  'profile.title': 'Profilo',
  'profile.name': 'Nome',
  'profile.namePlaceholder': 'Il tuo nome',
  'profile.email': 'Email',
  'profile.changePassword': 'Cambia password',
  'profile.passwordHint': 'Lascia i campi vuoti se non vuoi cambiare la password',
  'profile.currentPassword': 'Password attuale',
  'profile.newPassword': 'Nuova password',
  'profile.newPasswordPlaceholder': 'Almeno 6 caratteri',
  'profile.confirmPassword': 'Conferma password',
  'profile.confirmPasswordPlaceholder': 'Ripeti la nuova password',
  'profile.saved': 'Salvato!',
  'profile.passwordChanged': 'Password cambiata',
  'profile.homePage': 'Pagina iniziale',
  'profile.startingLocation': 'Sede iniziale',
  'profile.startingLocationAuto': 'Automatico (predefinito)',
  'profile.homeBizMonitor': 'Monitor Business',
  'profile.homeDashboard': 'Pannello',
  'profile.homeCalendar': 'Calendario',
  'profile.homeClients': 'Clienti',
  'profile.homePos': 'Negozio',
  'profile.homeOrders': 'Ordini',
  'profile.homeFinances': 'Finanze',
  'profile.homeCommunication': 'Messaggi',
  'profile.homeStaff': 'Personale',
  'profile.homeStock': 'Magazzino',
  'profile.homePurchases': 'Acquisti',
  'profile.homeProduction': 'Produzione',
  'profile.homeSalary': 'Stipendi',
  'profile.homeCashRegister': 'Cassa',
  'profile.homeReports': 'Report',
  'profile.homeFinResult': 'Risultato finanziario',
  'profile.profileUpdated': 'Profilo aggiornato',
  'profile.errorEnterName': 'Inserisci il tuo nome',
  'profile.errorEnterCurrentPassword': 'Inserisci la password attuale',
  'profile.errorMinPassword': 'La nuova password deve avere almeno 6 caratteri',
  'profile.errorPasswordMismatch': 'Le password non corrispondono',
  'profile.errorWrongPassword': 'Password attuale errata',
  'profile.errorTooMany': 'Troppi tentativi. Riprova pi\u00f9 tardi.',
  'profile.errorGeneric': 'Errore: ',

  // ── Calendar page ──
  'cal.monthGen.0': 'gennaio', 'cal.monthGen.1': 'febbraio', 'cal.monthGen.2': 'marzo',
  'cal.monthGen.3': 'aprile', 'cal.monthGen.4': 'maggio', 'cal.monthGen.5': 'giugno',
  'cal.monthGen.6': 'luglio', 'cal.monthGen.7': 'agosto', 'cal.monthGen.8': 'settembre',
  'cal.monthGen.9': 'ottobre', 'cal.monthGen.10': 'novembre', 'cal.monthGen.11': 'dicembre',
  'cal.weekday.0': 'Domenica', 'cal.weekday.1': 'Luned\u00ec', 'cal.weekday.2': 'Marted\u00ec',
  'cal.weekday.3': 'Mercoled\u00ec', 'cal.weekday.4': 'Gioved\u00ec', 'cal.weekday.5': 'Venerd\u00ec', 'cal.weekday.6': 'Sabato',
  'cal.today': 'Oggi',
  'cal.daySchedule': 'Programma del giorno',
  'cal.appointments': 'appuntamenti',
  'cal.working': 'Lavora',
  'cal.dayOff': 'Giorno libero',
  'cal.noStaffWorking': 'Nessun dipendente lavora in questo giorno',
  'cal.clickToAdd': "Clicca sull'orario per aggiungere un appuntamento",
  'cal.service': 'Servizio',
  'cal.paid': 'Pagato',
  'cal.unpaid': 'Non pagato',
  'cal.batchBooking': 'Prenotazione multipla',
  'cal.batchCreated': 'Appuntamenti creati',
  'cal.fiscalReceiptCreated': 'Scontrino fiscale creato',
  'cal.fiscalReceiptError': 'Errore di fiscalizzazione',
  'cal.refundRecorded': 'Rimborso registrato',
  'cal.cannotDeletePaid': 'Impossibile eliminare un appuntamento pagato. Prima effettua un rimborso.',

  // ── Appointment modal ──
  'apt.newTitle': 'Nuovo appuntamento',
  'apt.editTitle': 'Modifica appuntamento',
  'apt.closeEsc': 'Chiudi (Esc)',
  'apt.client': 'Cliente',
  'apt.nameOrPhone': 'Nome o telefono',
  'apt.startTyping': 'Inizia a digitare...',
  'apt.phone': 'Telefono',
  'apt.viewProfile': 'Vai al profilo',
  'apt.dateAndTime': 'Data e ora',
  'apt.date': 'Data',
  'apt.startTime': 'Inizio',
  'apt.endTime': 'Fine',
  'apt.servicesAndPayment': 'Servizi e pagamento',
  'apt.pricelist': 'Listino',
  'apt.addService': 'Aggiungi servizio',
  'apt.standardPrice': 'Prezzo standard',
  'apt.tariffPlan': 'Piano tariffario',
  'apt.min': 'min',
  'apt.discount': 'Sconto',
  'apt.uah': 'UAH',
  'apt.total': 'Totale',
  'apt.toPay': 'Da pagare',
  'apt.paymentMethod': 'Metodo di pagamento',
  'apt.cash': 'Contanti',
  'apt.terminal': 'Terminale',
  'apt.transfer': 'Bonifico',
  'apt.paid': 'Pagato',
  'apt.clientGave': 'Il cliente ha dato',
  'apt.change': 'Resto',
  'apt.note': 'Nota',
  'apt.author': 'Autore',
  'apt.notePlaceholder': 'Commento all\'appuntamento...',
  'apt.notesPlaceholder': 'Commento all\'appuntamento...',
  'apt.book': 'Prenota',
  'apt.saveChanges': 'Salva modifiche',
  'apt.cancel': 'Annulla',
  'apt.delete': 'Elimina',
  'apt.printBill': 'Preventivo',
  'apt.deleteTitle': 'Eliminare l\'appuntamento?',
  'apt.deleteMessage': 'Stai per eliminare questo appuntamento. Questa azione \u00e8 irreversibile.',
  'apt.payBtn': 'Paga',
  'apt.confirmPayment': 'Confermare il pagamento?',
  'apt.refund': 'Rimborso',
  'apt.refundTitle': 'Rimborso',
  'apt.refundMessage': 'Sei sicuro di voler rimborsare questo appuntamento?',
  'apt.refundWarning': 'Questa azione \u00e8 irreversibile.',
  'apt.confirmRefund': 'Conferma rimborso',
  'apt.refunded': 'Rimborsato',
  'apt.back': 'Indietro',
  'apt.batchBooking': 'Prenotazione multipla',
  'apt.createMultiple': 'Crea multipli',
  'apt.materials': 'Materiali',
  'apt.product': 'Prodotto',
  'apt.qty': 'Qt\u00e0',
  'apt.pcs': 'pz',
  'apt.add': 'Aggiungi',
  'apt.noProductsAdded': 'Nessun prodotto aggiunto',
  'apt.noProductsInStock': 'Nessun prodotto in magazzino',
  'apt.notEnough': 'Insufficiente',
  'apt.notEnoughInStock': 'Insufficiente in magazzino',
  'apt.notEnoughStock': 'Giacenza insufficiente',
  'apt.appointmentNote': 'Nota dell\'appuntamento',
  'apt.clientDocs': 'Documenti del cliente',
  'apt.addDocument': 'Aggiungi documento',
  'apt.docName': 'Nome documento',
  'apt.docNamePlaceholder': 'Inserisci il nome...',
  'apt.docText': 'Testo del documento',
  'apt.noDocsYet': 'Nessun documento ancora',
  'apt.attachFile': 'Allega file',
  'apt.maxFileSize': 'Dim. max file: 2 MB',
  'apt.errClientName': 'Inserisci il nome del cliente',
  'apt.errClientPhone': 'Inserisci il telefono del cliente',
  'apt.errDate': 'Seleziona una data',
  'apt.errDiscount': 'Lo sconto non può superare l\'importo',
  'apt.errDayOff': 'Lo specialista non lavora in questo giorno',
  'apt.errOutsideWorkingHours': 'L\'orario è fuori dall\'orario di lavoro ({start} – {end})',
  'apt.errOverlap': 'L\'orario si sovrappone all\'appuntamento {start}–{end} ({client})',
  'apt.workingHoursHint': 'Orario di lavoro: {start} – {end}',
  'apt.statusWaiting': 'In attesa',
  'apt.statusConfirmed': 'Completato',
  'apt.statusArrived': 'Arrivato',
  'apt.statusNoShow': 'Assente',

  // ── Batch appointment modal ──
  'batchApt.title': 'Prenotazione multipla',
  'batchApt.subtitle': 'Creazione di pi\u00f9 appuntamenti contemporaneamente',
  'batchApt.closeEsc': 'Chiudi (Esc)',
  'batchApt.client': 'Cliente',
  'batchApt.nameOrPhone': 'Nome o telefono',
  'batchApt.phone': 'Telefono',
  'batchApt.staffMember': 'Operatore',
  'batchApt.service': 'Servizio',
  'batchApt.discount': 'Sconto',
  'batchApt.uah': 'UAH',
  'batchApt.addDate': 'Aggiungi data',
  'batchApt.delete': 'Elimina',
  'batchApt.entries': 'appuntamenti',
  'batchApt.entrySingle': 'appuntamento',
  'batchApt.entryPlural': 'appuntamenti',
  'batchApt.create': 'Crea',
  'batchApt.cancel': 'Annulla',
  'batchApt.errClientName': 'Inserisci il nome del cliente',
  'batchApt.errClientPhone': 'Inserisci il telefono del cliente',
  'batchApt.errDiscount': 'Lo sconto non pu\u00f2 superare l\'importo',
  'batchApt.errNoRows': 'Aggiungi almeno un appuntamento',

  // ── Customer card ──
  'custCard.edit': 'Modifica',
  'custCard.delete': 'Elimina',
  'custCard.book': 'Prenota',
  'custCard.order': 'Ordine',
  'custCard.sell': 'Vendere',
  'custCard.sellProduct': 'Prodotto',
  'custCard.sellService': 'Servizio',
  'custCard.sellSubscription': 'Abbonamento',
  'custCard.openFinances': 'Finanze',
  'custCard.paid': 'Pagato',
  'custCard.sold': 'Venduto',
  'custCard.balance': 'Saldo',
  'custCard.importance': 'Importanza',
  'custCard.forbidOnlineBooking': 'Prenotazione online vietata',

  // ── Customer grid ──
  'custGrid.noCustomersFound': 'Nessun cliente trovato',
  'custGrid.tryChangeSearch': 'Prova a modificare la ricerca o il filtro per categoria',

  // ── Customer modal ──
  'custModal.newCustomer': 'Nuovo cliente',
  'custModal.editCustomer': 'Modifica cliente',
  'custModal.closeEsc': 'Chiudi (Esc)',
  'custModal.tabMain': 'Principale',
  'custModal.tabDetails': 'Dettagli',
  'custModal.tabVisits': 'Visite',
  'custModal.tabFinancial': 'Finanze',
  'custModal.tabAnalytics': 'Analitica',
  'custModal.tabNotes': 'Note',
  'custModal.tabDocuments': 'Documenti',
  'custModal.personalData': 'Dati personali',
  'custModal.fullName': 'Nome e cognome',
  'custModal.fullNamePlaceholder': 'Inserisci nome completo',
  'custModal.mobilePhone': 'Cellulare',
  'custModal.additionalPhone': 'Telefono aggiuntivo',
  'custModal.birthDate': 'Data di nascita',
  'custModal.day': 'Giorno',
  'custModal.month': 'Mese',
  'custModal.year': 'Anno',
  'custModal.gender': 'Sesso',
  'custModal.genderMale': 'Maschile',
  'custModal.genderFemale': 'Femminile',
  'custModal.genderOther': 'Altro',
  'custModal.cardNumber': 'Numero tessera',
  'custModal.profilePhoto': 'Foto profilo',
  'custModal.uploadPhoto': 'Carica foto',
  'custModal.changePhoto': 'Cambia foto',
  'custModal.deletePhoto': 'Elimina foto',
  'custModal.avatar': 'Avatar',
  'custModal.categoryAndClassification': 'Categoria e classificazione',
  'custModal.category': 'Categoria',
  'custModal.importanceLabel': 'Importanza',
  'custModal.discountLabel': 'Sconto',
  'custModal.discountRange': '0\u2013100%',
    'custModal.referral': 'Referral program',
  'custModal.referredBy': 'Referred by',
  'custModal.referredByHint': 'Select the client who referred this person',
'custModal.restrictions': 'Restrizioni',
  'custModal.forbidOnlineBooking': 'Vietare prenotazione online',
  'custModal.forbidOnlineBookingDesc': 'Il cliente non potr\u00e0 prenotare autonomamente',
  'custModal.telegramReminders': 'Promemoria Telegram',
  'custModal.telegramConnected': 'Telegram connesso',
  'custModal.setupTelegramBot': 'Configura il bot Telegram',
  'custModal.sendLinkToCustomer': 'Invia link al cliente',
  'custModal.send': 'Invia',
  'custModal.sending': 'Invio...',
  'custModal.specifyPhoneFirst': 'Specifica prima il telefono',
  'custModal.save': 'Salva',
  'custModal.cancel': 'Annulla',
  'custModal.close': 'Chiudi',
  'custModal.editBtn': 'Modifica',
  'custModal.viewCustomer': 'Scheda cliente',
  'custModal.back': 'Indietro',
  'custModal.next': 'Avanti',
  'custModal.nameRequired': 'Il nome \u00e8 obbligatorio',
  'custModal.phoneRequired': 'Il telefono \u00e8 obbligatorio',
  'custModal.nameDuplicate': 'Un cliente con questo nome esiste già',
  'custModal.phoneDuplicate': 'Un cliente con questo numero di telefono esiste già',
  'custModal.note': 'Nota',
  'custModal.notePlaceholder': 'Aggiungi nota...',
  'custModal.comments': 'Commenti',
  'custModal.commentsPlaceholder': 'Scrivi un commento...',
  'custModal.writeMessagePlaceholder': 'Scrivi un messaggio...',
  // Customer modal — visits tab
  'custModal.visitHistory': 'Storico visite',
  'custModal.totalVisits': 'Visite totali',
  'custModal.lastVisit': 'Ultima visita',
  'custModal.visitFrequency': 'Frequenza visite',
  'custModal.days': 'gg.',
  'custModal.visitsByMonth': 'Visite per mese',
  'custModal.noVisitsYet': 'Nessuna visita ancora',
  'custModal.tabOrders': 'Acquisti',
  'custModal.orderHistory': 'Cronologia ordini',
  'custModal.ordersTotal': 'Ordini',
  'custModal.ordersDelivered': 'Consegnati',
  'custModal.ordersPaid': 'Pagato',
  'custModal.noOrdersYet': 'Nessun acquisto ancora',
  'custModal.posSalesCount': 'Vendite',
  'custModal.orderStatusNew': 'Nuovo',
  'custModal.orderStatusConfirmed': 'Confermato',
  'custModal.orderStatusPacked': 'Imballato',
  'custModal.orderStatusShipped': 'Spedito',
  'custModal.orderStatusDelivered': 'Consegnato',
  'custModal.orderStatusCancelled': 'Annullato',
  'custModal.posCompleted': 'Completato',
  'custModal.posSourceLabel': 'Negozio',
  'custModal.orderSourceLabel': 'Ordine',
  'custModal.subscriptionsLabel': 'Abbonamenti',
  'custModal.completed': 'Completato',
  'custModal.noShow': 'Assente',
  'custModal.statusWaiting': 'In attesa',
  'custModal.statusConfirmed': 'Completato',
  'custModal.statusArrived': 'Arrivato',
  'custModal.statusNoShow': 'Assente',
  // Customer modal — financial tab
  'custModal.financialIndicators': 'Indicatori finanziari',
  'custModal.finPaid': 'Pagato',
  'custModal.finBalance': 'Saldo',
  'custModal.avgCheck': 'Scontrino medio',
  'custModal.ltv': 'LTV',
  'custModal.charges': 'Addebiti',
  'custModal.noChargesYet': 'Nessun addebito ancora',
  'custModal.noPaymentsYet': 'Nessun pagamento ancora',
  'custModal.date': 'Data',
  'custModal.dateTime': 'Data/ora',
  'custModal.service': 'Servizio',
  'custModal.serviceLabel': 'Servizio',
  'custModal.price': 'Prezzo',
  'custModal.discount': 'Sconto',
  'custModal.total': 'Totale',
  'custModal.paidLabel': 'Pagamento',
  'custModal.payment': 'Pagamento',
  'custModal.paymentMethod': 'Metodo di pagamento',
  'custModal.amount': 'Importo',
  'custModal.totalAmount': 'Importo totale',
  'custModal.methodCash': 'Contanti',
  'custModal.methodCard': 'Carta',
  'custModal.methodTransfer': 'Bonifico',
  'custModal.cash': 'Contanti',
  'custModal.terminal': 'Terminale',
  'custModal.transfer': 'Bonifico',
  'custModal.online': 'Online',
  'custModal.refund': 'Rimborso',
  'custModal.sold': 'Venduto',
  'custModal.finCharged': 'Addebitato',
  'custModal.serviceCharges': 'Addebiti servizi',
  'custModal.productCharges': 'Addebiti prodotti',
  'custModal.productLabel': 'Prodotto',
  'custModal.noProductChargesYet': 'Nessuna vendita di prodotti ancora',
  'custModal.time': 'Ora',
  'custModal.unknown': 'Sconosciuto',
  // Customer modal — analytics tab
  'custModal.favoriteMaster': 'Operatore preferito',
  'custModal.favoriteService': 'Servizio preferito',
  'custModal.favoriteProduct': 'Prodotto preferito',
  'custModal.lastActivity': 'Ultima attività',
  'custModal.spendingBreakdown': 'Ripartizione spese',
  'custModal.purchasesByMonth': 'Acquisti per mese',
  'custModal.churn_low': 'Cliente attivo',
  'custModal.churn_medium': 'Rischio abbandono — non si vede da un po\'',
  'custModal.churn_high': 'Alto rischio abbandono — contatto necessario',
  // Customer modal — documents tab
  'custModal.customerDocuments': 'Documenti del cliente',
  'custModal.addDocument': 'Aggiungi documento',
  'custModal.addDoc': 'Aggiungi',
  'custModal.addBtn': 'Aggiungi',
  'custModal.noDocumentsYet': 'Nessun documento ancora',
  'custModal.docName': 'Nome documento',
  'custModal.docNamePlaceholder': 'Inserisci il nome...',
  'custModal.docNameRequired': 'Inserisci il nome del documento',
  'custModal.docText': 'Testo del documento',
  'custModal.docTextPlaceholder': 'Inserisci il testo...',
  'custModal.attachFile': 'Allega file',
  'custModal.fileUpTo2MB': 'File fino a 2 MB',
  'custModal.fileTooLarge': 'File troppo grande (max 2 MB)',
  'custModal.emptyDocument': 'Documento vuoto',
  'custModal.deleteDoc': 'Elimina documento',
  'custModal.deleteThisDoc': 'Eliminare questo documento?',
  'custModal.deleteBtn': 'Elimina',
  'custModal.download': 'Scarica',
  'custModal.copy': 'Copia',
  'custModal.specifyPhoneForDocs': 'Specifica il telefono per i documenti',
  'custModal.loading': 'Caricamento...',
  'custModal.error': 'Errore',
  // Customer modal — month abbreviations
  'custModal.monthJan': 'Gennaio', 'custModal.monthFeb': 'Febbraio', 'custModal.monthMar': 'Marzo',
  'custModal.monthApr': 'Aprile', 'custModal.monthMay': 'Maggio', 'custModal.monthJun': 'Giugno',
  'custModal.monthJul': 'Luglio', 'custModal.monthAug': 'Agosto', 'custModal.monthSep': 'Settembre',
  'custModal.monthOct': 'Ottobre', 'custModal.monthNov': 'Novembre', 'custModal.monthDec': 'Dicembre',
  'custModal.monthAbbrJan': 'Gen', 'custModal.monthAbbrFeb': 'Feb', 'custModal.monthAbbrMar': 'Mar',
  'custModal.monthAbbrApr': 'Apr', 'custModal.monthAbbrMay': 'Mag', 'custModal.monthAbbrJun': 'Giu',
  'custModal.monthAbbrJul': 'Lug', 'custModal.monthAbbrAug': 'Ago', 'custModal.monthAbbrSep': 'Set',
  'custModal.monthAbbrOct': 'Ott', 'custModal.monthAbbrNov': 'Nov', 'custModal.monthAbbrDec': 'Dic',
  'custModal.monthShortJan': 'Gen', 'custModal.monthShortFeb': 'Feb', 'custModal.monthShortMar': 'Mar',
  'custModal.monthShortApr': 'Apr', 'custModal.monthShortMay': 'Mag', 'custModal.monthShortJun': 'Giu',
  'custModal.monthShortJul': 'Lug', 'custModal.monthShortAug': 'Ago', 'custModal.monthShortSep': 'Set',
  'custModal.monthShortOct': 'Ott', 'custModal.monthShortNov': 'Nov', 'custModal.monthShortDec': 'Dic',

  // ── Categories page ──
  'categories.title': 'Categorie clienti',
  'categories.subtitle': 'Gestione categorie e livelli di importanza',
  'categories.categoriesTab': 'Categorie',
  'categories.importanceTab': 'Importanza',
  'categories.categoriesDesc': 'Raggruppa i clienti per tipo',
  'categories.importanceDesc': 'Definisci i livelli di importanza dei clienti',
  'categories.addCategory': 'Aggiungi categoria',
  'categories.newCategory': 'Nuova categoria',
  'categories.editCategory': 'Modifica categoria',
  'categories.noCategories': 'Nessuna categoria ancora',
  'categories.categoryName': 'Nome categoria',
  'categories.name': 'Nome',
  'categories.namePlaceholder': 'Inserisci il nome...',
  'categories.nameDuplicate': 'Una categoria con questo nome esiste già',
  'categories.importanceDuplicate': 'Un livello di importanza con questo nome esiste già',
  'categories.icon': 'Icona',
  'categories.changeIcon': 'Cambia icona',
  'categories.chooseIcon': 'Scegli un\'icona',
  'categories.color': 'Colore',
  'categories.bgColor': 'Colore sfondo',
  'categories.textColor': 'Colore testo',
  'categories.borderColor': 'Colore bordo',
  'categories.indicatorColor': 'Colore indicatore',
  'categories.preview': 'Anteprima',
  'categories.save': 'Salva',
  'categories.cancel': 'Annulla',
  'categories.delete': 'Elimina',
  'categories.edit': 'Modifica',
  'categories.add': 'Aggiungi',
  'categories.confirmDelete': 'Sei sicuro di voler eliminare?',
  'categories.hasCustomersBlocked': 'Questa categoria ha clienti e non pu\u00f2 essere eliminata',
  'categories.yes': 'S\u00ec',
  'categories.no': 'No',
  'categories.addLevel': 'Aggiungi livello',
  'categories.newImportanceLevel': 'Nuovo livello di importanza',
  'categories.editLevel': 'Modifica livello',
  'categories.noImportanceLevels': 'Nessun livello di importanza ancora',
  'categories.levelName': 'Nome livello',
  'categories.levelPlaceholder': 'Inserisci il nome del livello...',
  'categories.iconBusiness': 'Business',
  'categories.iconClients': 'Clienti',
  'categories.iconNature': 'Natura',
  'categories.iconOther': 'Altro',
  'categories.iconStatus': 'Stato',
  'categories.iconSymbols': 'Simboli',

  // ── Staff page ──
  'staff.title': 'Dipendenti',
  'staff.subtitle': 'Gestione del personale',
  'staff.addStaff': 'Aggiungi dipendente',
  'staff.searchPlaceholder': 'Cerca per nome, posizione, telefono...',
  'staff.activeStaff': 'Attivi',
  'staff.activeStaffDesc': 'dipendenti',
  'staff.statusActive': 'Attivo (mostra nel calendario)',
  'staff.statusActiveHidden': 'Attivo (nascondi dal calendario)',
  'staff.statusDismissed': 'Licenziato',
  'staff.shown': 'Mostrato',
  'staff.of': 'di',
  'staff.total': 'totale',
  'staff.notFound': 'Nessun dipendente trovato',
  'staff.notFoundHint': 'Prova a modificare la ricerca',
  'staff.newStaff': 'Nuovo dipendente',
  'staff.editStaff': 'Modifica dipendente',
  'staff.closeEsc': 'Chiudi (Esc)',
  'staff.tabMain': 'Principale',
  'staff.tabDetails': 'Dettagli',
  'staff.tabServices': 'Servizi',
  'staff.tabSchedule': 'Orario',
  'staff.personalData': 'Dati personali',
  'staff.fullName': 'Nome completo',
  'staff.fullNamePlaceholder': 'Inserisci nome completo',
  'staff.nameRequired': 'Il nome \u00e8 obbligatorio',
  'staff.nameDuplicate': 'Un dipendente con questo nome esiste già',
  'staff.phoneDuplicate': 'Un dipendente con questo numero di telefono esiste già',
  'staff.phone': 'Telefono',
  'staff.position': 'Posizione',
  'staff.positionPlaceholder': 'Inserisci la posizione...',
  'staff.status': 'Stato',
  'staff.active': 'Attivo',
  'staff.profilePhoto': 'Foto profilo',
  'staff.uploadPhoto': 'Carica foto',
  'staff.changePhoto': 'Cambia foto',
  'staff.avatar': 'Avatar',
  'staff.avatarColor': 'Colore avatar',
  'staff.birthDate': 'Data di nascita',
  'staff.day': 'Giorno',
  'staff.month': 'Mese',
  'staff.year': 'Anno',
  'staff.address': 'Indirizzo',
  'staff.addressPlaceholder': 'Inserisci indirizzo...',
  'staff.note': 'Nota',
  'staff.notePlaceholder': 'Aggiungi nota...',
  'staff.salaryScheme': 'Schema retributivo',
  'staff.notSelected': 'Non selezionato',
  'staff.locations': 'Sedi',
  'staff.servicesEmpty': 'Nessun servizio assegnato',
  'staff.servicesHint': 'Seleziona i servizi offerti da questo dipendente',
  'staff.priceUah': 'Prezzo (UAH)',
  'staff.uah': 'UAH',
  'staff.min': 'min',
  'staff.mins': 'min',
  'staff.workSchedule': 'Orario di lavoro',
  'staff.dayOff': 'Giorno libero',
  'staff.save': 'Salva',
  'staff.saveChanges': 'Salva modifiche',
  'staff.cancel': 'Annulla',
  'staff.back': 'Indietro',
  'staff.next': 'Avanti',
  'staff.add': 'Aggiungi',
  'staff.edit': 'Modifica',
  'staff.delete': 'Elimina',
  'staff.deleteConfirmTitle': 'Eliminare il dipendente?',
  'staff.deleteForever': 'Elimina definitivamente',
  'staff.hasAppointments': 'Il dipendente ha appuntamenti e non pu\u00f2 essere eliminato',
  'staff.understood': 'Capito',
  'staff.scheduleConflict': 'Conflitto di orario',
  'staff.dayMon': 'Lu', 'staff.dayTue': 'Ma', 'staff.dayWed': 'Me',
  'staff.dayThu': 'Gi', 'staff.dayFri': 'Ve', 'staff.daySat': 'Sa', 'staff.daySun': 'Do',
  'staff.monthJan': 'Gennaio', 'staff.monthFeb': 'Febbraio', 'staff.monthMar': 'Marzo',
  'staff.monthApr': 'Aprile', 'staff.monthMay': 'Maggio', 'staff.monthJun': 'Giugno',
  'staff.monthJul': 'Luglio', 'staff.monthAug': 'Agosto', 'staff.monthSep': 'Settembre',
  'staff.monthOct': 'Ottobre', 'staff.monthNov': 'Novembre', 'staff.monthDec': 'Dicembre',

  // ── Schedule page ──
  'schedule.title': 'Orario di lavoro',
  'schedule.subtitle': 'Gestione orari di lavoro dei dipendenti',
  'schedule.active': 'Attivi',
  'schedule.inactive': 'Inattivi',
  'schedule.staffMember': 'Dipendente',
  'schedule.hrsPerWeek': 'Ore/sett',
  'schedule.prevWeek': '\u2190 Settimana precedente',
  'schedule.nextWeek': 'Settimana successiva \u2192',
  'schedule.current': 'Corrente',
  'schedule.working': 'Lavora',
  'schedule.dayOff': 'Giorno libero',
  'schedule.noActiveStaff': 'Nessun dipendente attivo',
  'schedule.noActiveStaffHint': 'Aggiungi dipendenti nella sezione "Personale"',
  'schedule.scheduleSettings': 'Impostazioni orario',
  'schedule.dayType': 'Tipo di giorno',
  'schedule.workDay': 'Giorno lavorativo',
  'schedule.workHours': 'Ore lavorative',
  'schedule.breaks': 'Pause',
  'schedule.noBreaks': 'Nessuna pausa',
  'schedule.oneBreak': '1 pausa',
  'schedule.nBreaks': 'pause',
  'schedule.addBreak': 'Aggiungi pausa',
  'schedule.deleteBreak': 'Elimina pausa',
  'schedule.save': 'Salva',
  'schedule.cancel': 'Annulla',
  'schedule.apply': 'Applica',
  'schedule.vacation': 'Ferie',
  'schedule.sickLeave': 'Malattia',
  'schedule.repeat1': '2 settimane (1 ciclo)',
  'schedule.repeatN': '{n} settimane',
  'schedule.repeatWeekly': 'Settimanale (anno)',
  'schedule.templateAppliedWeeks': 'Modello applicato per {n} settimane',
  'schedule.scheduleTemplate': 'Modello di orario',
  'schedule.noTemplate': 'Senza modello',
  'schedule.saveTwoWeeksTemplate': 'Salva come modello (2 settimane)',
  'schedule.templateDuplicate': 'A template with this name already exists',
  'schedule.templateNamePlaceholder': 'Nome del modello...',
  'schedule.scheduleConflict': 'Conflitto di orario',
  'schedule.appointmentConflict': 'Impossibile modificare l\'orario: appuntamento alle {time} ({count} totali) fuori dal nuovo orario di lavoro',
  'schedule.h': 'ore',
  'schedule.hrs': 'ore',
  'schedule.min': 'min',
  'schedule.dayMonFull': 'Luned\u00ec', 'schedule.dayTueFull': 'Marted\u00ec', 'schedule.dayWedFull': 'Mercoled\u00ec',
  'schedule.dayThuFull': 'Gioved\u00ec', 'schedule.dayFriFull': 'Venerd\u00ec', 'schedule.daySatFull': 'Sabato', 'schedule.daySunFull': 'Domenica',
  'schedule.dayMon': 'Lu', 'schedule.dayTue': 'Ma', 'schedule.dayWed': 'Me',
  'schedule.dayThu': 'Gi', 'schedule.dayFri': 'Ve', 'schedule.daySat': 'Sa', 'schedule.daySun': 'Do',

  // ── Schedule templates page ──
  'schedTpl.title': 'Modelli di orario',
  'schedTpl.subtitle': 'Crea e gestisci modelli di orario di lavoro',
  'schedTpl.templates': 'Modelli',
  'schedTpl.newTemplate': 'Nuovo modello',
  'schedTpl.noTemplates': 'Nessun modello ancora',
  'schedTpl.noTemplatesHint': 'Crea un modello di orario per un\'applicazione rapida',
  'schedTpl.templateSettings': 'Impostazioni modello',
  'schedTpl.templateNamePlaceholder': 'Nome del modello...',
  'schedTpl.dayType': 'Tipo di giorno',
  'schedTpl.workDay': 'Giorno lavorativo',
  'schedTpl.dayOff': 'Giorno libero',
  'schedTpl.vacation': 'Ferie',
  'schedTpl.sickLeave': 'Malattia',
  'schedTpl.workHours': 'Ore lavorative',
  'schedTpl.breaks': 'Pause',
  'schedTpl.noBreaks': 'Nessuna pausa',
  'schedTpl.addBreak': 'Aggiungi pausa',
  'schedTpl.save': 'Salva',
  'schedTpl.cancel': 'Annulla',
  'schedTpl.create': 'Crea',
  'schedTpl.delete': 'Elimina',
  'schedTpl.rename': 'Rinomina',
  'schedTpl.deleteTitle': 'Eliminare il modello?',
  'schedTpl.deleteMessage': 'Stai per eliminare questo modello. Questa azione \u00e8 irreversibile.',
  'schedTpl.hPerWeek': 'ore/sett',
  'schedTpl.hrs': 'ore',
  'schedTpl.min': 'min',
  'schedTpl.workShort': 'Lav',
  'schedTpl.offShort': 'Lib',
  'schedTpl.week1': 'Settimana 1',
  'schedTpl.week2': 'Settimana 2',
  'schedTpl.dayMonFull': 'Luned\u00ec', 'schedTpl.dayTueFull': 'Marted\u00ec', 'schedTpl.dayWedFull': 'Mercoled\u00ec',
  'schedTpl.dayThuFull': 'Gioved\u00ec', 'schedTpl.dayFriFull': 'Venerd\u00ec', 'schedTpl.daySatFull': 'Sabato', 'schedTpl.daySunFull': 'Domenica',
  'schedTpl.dayMon': 'Lu', 'schedTpl.dayTue': 'Ma', 'schedTpl.dayWed': 'Me',
  'schedTpl.dayThu': 'Gi', 'schedTpl.dayFri': 'Ve', 'schedTpl.daySat': 'Sa', 'schedTpl.daySun': 'Do',

  // ── Services page ──
  'services.title': 'Servizi',
  'services.subtitle': 'Catalogo servizi',
  'services.servicesCount': 'Servizi',
  'services.groups': 'Gruppi',
  'services.addService': 'Aggiungi servizio',
  'services.newGroup': 'Nuovo gruppo',
  'services.emptyCatalog': 'Il catalogo servizi \u00e8 vuoto',
  'services.emptyCatalogHint': 'Aggiungi un gruppo e dei servizi',
  'services.noServicesInGroup': 'Nessun servizio in questo gruppo',
  'services.serviceName': 'Nome servizio',
  'services.durationMin': 'Durata (min)',
  'services.durationMinError': 'La durata deve essere maggiore di 0',
  'services.priceUah': 'Prezzo (UAH)',
  'services.priceNegativeError': 'Il prezzo non pu\u00f2 essere negativo',
  'services.nameDuplicate': 'Un servizio con questo nome esiste già',
  'services.groupDuplicate': 'Un gruppo con questo nome esiste già',
  'services.min': 'min',
  'services.uah': 'UAH',
  'services.save': 'Salva',
  'services.cancel': 'Annulla',
  'services.edit': 'Modifica',
  'services.delete': 'Elimina',
  'services.renameGroup': 'Rinomina gruppo',
  'services.deleteGroup': 'Elimina gruppo',
  'services.deleteGroupTitle': 'Eliminare il gruppo?',
  'services.deleteGroupMessage': 'Tutti i servizi in questo gruppo saranno eliminati.',
  'services.deleteServiceTitle': 'Eliminare il servizio?',
  'services.deleteServiceMessage': 'Questa azione \u00e8 irreversibile.',
  'services.cannotDelete': 'Impossibile eliminare',
  'services.serviceHasAppointments': 'Questo servizio ha appuntamenti e non pu\u00f2 essere eliminato',
  'services.groupHasAppointments': 'Questo gruppo ha servizi con appuntamenti e non pu\u00f2 essere eliminato',
  'services.cannotDeleteGroupHasServices': 'Prima sposta o elimina i servizi di questo gruppo',
  'services.deleteError': 'Eliminazione fallita',
  'services.understood': 'Capito',

  // ── Tariff plans page ──
  'tariffs.title': 'Piani tariffari',
  'tariffs.subtitle': 'Gestione piani tariffari',
  'tariffs.tariffsCount': 'Tariffe',
  'tariffs.addTariff': 'Aggiungi tariffa',
  'tariffs.noTariffs': 'Nessun piano tariffario',
  'tariffs.newTariffPlan': 'Nuovo piano tariffario',
  'tariffs.editTariff': 'Modifica tariffa',
  'tariffs.tariffName': 'Nome tariffa',
  'tariffs.tariffNamePlaceholder': 'Inserisci il nome della tariffa...',
  'tariffs.nameDuplicate': 'Una tariffa con questo nome esiste già',
  'tariffs.tariffType': 'Tipo tariffa',
  'tariffs.discount': 'Sconto',
  'tariffs.surcharge': 'Maggiorazione',
  'tariffs.noChange': 'Nessuna modifica',
  'tariffs.priceModifierPercent': 'Modificatore prezzo (%)',
  'tariffs.percentModifier': '% modificatore',
  'tariffs.modifier': 'Modificatore',
  'tariffs.modifierHint': 'Valore negativo \u2014 sconto, positivo \u2014 maggiorazione',
  'tariffs.modifierPlaceholder': 'Es: -10 o +15',
  'tariffs.activeCheckbox': 'Attivo',
  'tariffs.active': 'Attivo',
  'tariffs.inactive': 'Inattivo',
  'tariffs.tabServices': 'Servizi',
  'tariffs.tabProducts': 'Prodotti',
  'tariffs.servicePrices': 'Prezzi dei servizi',
  'tariffs.customPriceServices': 'Prezzi personalizzati per i servizi',
  'tariffs.customPriceProducts': 'Prezzi personalizzati per i prodotti: {n}',
  'tariffs.productPrices': 'Prezzi dei prodotti',
  'tariffs.productPricesHint': 'Cerca e aggiungi prodotti per impostare prezzi promozionali',
  'tariffs.searchProduct': 'Cerca prodotto per nome o codice...',
  'tariffs.noCategory': 'Senza categoria',
  'tariffs.priceList': 'Listino prezzi',
  'tariffs.leaveEmptyDefault': 'Lascia vuoto per il prezzo standard',
  'tariffs.uah': 'UAH',
  'tariffs.save': 'Salva',
  'tariffs.create': 'Crea',
  'tariffs.cancel': 'Annulla',
  'tariffs.edit': 'Modifica',
  'tariffs.delete': 'Elimina',
  'tariffs.deleteConfirm': 'Sei sicuro di voler eliminare questa tariffa?',
  'tariffs.cannotDelete': 'Impossibile eliminare la tariffa',
  'tariffs.appointmentsCount': 'appuntamenti',
  'tariffs.ordersCount': 'ordini',
  'tariffs.yes': 'S\u00ec',
  'tariffs.no': 'No',

  // ── Finances page ──
  'fin.title': 'Operazioni finanziarie',
  'fin.subtitle': 'Registro pagamenti e rimborsi',
  'fin.searchPlaceholder': 'Cerca per cliente, telefono, servizio...',
  'fin.period': 'Periodo',
  'fin.today': 'Oggi',
  'fin.week': 'Settimana',
  'fin.month': 'Mese',
  'fin.from': 'dal',
  'fin.to': 'al',
  'fin.allTime': 'Tutto il periodo',
  'fin.typeLabel': 'Tipo',
  'fin.all': 'Tutti',
  'fin.payments': 'Pagamenti',
  'fin.refunds': 'Rimborsi',
  'fin.type_all': 'Tutti',
  'fin.type_payment': 'Pagamento',
  'fin.type_refund': 'Rimborso',
  'fin.type_product_sale': 'Vendita prodotto',
  'fin.methodLabel': 'Metodo di pagamento',
  'fin.cash': 'Contanti',
  'fin.terminal': 'Terminale',
  'fin.transfer': 'Bonifico',
  'fin.online': 'Online',
  'fin.total': 'Totale',
  'fin.uah': 'UAH',
  'fin.exportExcel': 'Esporta Excel',
  'fin.exportFileName': 'Operazioni_finanziarie',
  'fin.noOperations': 'Nessuna operazione',
  'fin.noOperationsHint': 'Prova a modificare i filtri o il periodo',
  'fin.colDate': 'Data',
  'fin.colClient': 'Cliente',
  'fin.colPhone': 'Telefono',
  'fin.colService': 'Servizio',
  'fin.colMaster': 'Operatore',
  'fin.colType': 'Tipo',
  'fin.colPayMethod': 'Metodo di pagamento',
  'fin.colMethod': 'Metodo',
  'fin.colAmount': 'Importo',
  'fin.colSum': 'Importo',
  'fin.colAuthor': 'Autore',
  'fin.colReceipt': 'Scontrino',
  'fin.service': 'Servizio',
  'fin.receipt': 'Scontrino',
  'fin.receiptNum': 'Scontrino n.',
  'fin.receiptSubtitle': 'Scontrino fiscale',
  'fin.receiptDate': 'Data',
  'fin.receiptClient': 'Cliente',
  'fin.receiptPhone': 'Telefono',
  'fin.receiptMaster': 'Operatore',
  'fin.receiptMethod': 'Metodo di pagamento',
  'fin.receiptTotal': 'Importo',
  'fin.receiptThanks': 'Grazie per la visita!',
  'fin.printReceipt': 'Stampa scontrino',
  'fin.fiscalCode': 'Codice fiscale',
  'fin.noFiscal': 'Senza fiscalizzazione',
  'fin.retryFiscal': 'Ripeti fiscalizzazione',
  'fin.fiscalRetrySuccess': 'Fiscalizzazione ripetuta con successo',
  'fin.fiscalRetryError': 'Errore nella ripetizione della fiscalizzazione',

  // ── Cash register page ──
  'cashReg.title': 'Cassa',
  'cashReg.subtitle': 'Gestione turni di cassa',
  'cashReg.currentShift': 'Turno corrente',
  'cashReg.openNewShift': 'Apri nuovo turno',
  'cashReg.openNewShiftHint': 'Turno non aperto. Apri un turno per accettare pagamenti.',
  'cashReg.openingBalance': 'Saldo iniziale',
  'cashReg.openingBalanceLabel': 'Saldo iniziale di cassa',
  'cashReg.openShift': 'Apri turno',
  'cashReg.closeShift': 'Chiudi turno',
  'cashReg.prro': 'POS',
  'cashReg.processing': 'Elaborazione...',
  'cashReg.opened': 'Aperto',
  'cashReg.closed': 'Chiuso',
  'cashReg.openedAt': 'Aperto alle',
  'cashReg.openBal': 'Saldo apertura',
  'cashReg.closeBal': 'Saldo chiusura',
  'cashReg.revenue': 'Ricavi',
  'cashReg.totalRevenue': 'Ricavi totali',
  'cashReg.operations': 'Operazioni',
  'cashReg.inRegister': 'In cassa',
  'cashReg.cash': 'Contanti',
  'cashReg.terminal': 'Terminale',
  'cashReg.transfer': 'Bonifico',
  'cashReg.uah': 'UAH',
  'cashReg.shift': 'Turno',
  'cashReg.shiftLog': 'Registro turni',
  'cashReg.historyEmpty': 'Nessuno storico turni',
  'cashReg.historyEmptyHint': 'Qui appariranno i turni chiusi',
  'cashReg.shiftOpened': 'Turno aperto',
  'cashReg.shiftClosed': 'Turno chiuso',
  'cashReg.checkboxNotConfigured': 'Per utilizzare la cassa, configurare la connessione Checkbox ПРРО in Impostazioni → Checkbox ПРРО',

  // ── Reports page ──
  'reports.reportType_cash_day': 'Ricavi per periodo',
  'reports.reportType_work_hours': 'Ore di lavoro',
  'reports.reportType_services_sales': 'Vendite servizi',
  'reports.reportType_mutual': 'Regolamenti con i clienti',
  'reports.reportType_inventory_flow': 'Flusso inventario',
  'reports.reportType_client_analytics': 'Analisi clienti',
  'reports.reportType_staff_revenue': 'Ricavi per dipendente',
  'reports.reportType_service_profitability': 'Redditività dei servizi',
  'reports.reportType_abc_analysis': 'Analisi ABC dei prodotti',
  'reports.reportType_revenue_dynamics': 'Dinamica dei ricavi',
  'reports.reportType_discount_analytics': 'Analisi degli sconti',
  'reports.reportType_purchases_by_supplier': 'Acquisti per fornitore',
  'reports.reportType_purchase_dynamics': 'Dinamica degli acquisti',
  'reports.reportType_top_purchased_products': 'Top prodotti acquistati',
  'reports.reportType_supplier_price_compare': 'Confronto prezzi fornitori',
  'reports.reportType_product_turnover': 'Rotazione dei prodotti',
  'reports.reportType_subscriptions': 'Abbonamenti',
  'reports.subsEmpty': 'Nessun abbonamento nel periodo selezionato',
  'reports.subsAll': 'Tutti',
  'reports.subsActive': 'Attivi',
  'reports.subsNearExpiry': 'In scadenza',
  'reports.subsNearExpiryHint': 'scadono in <14 giorni',
  'reports.subsExpired': 'Scaduti',
  'reports.subsUsedUp': 'Usati',
  'reports.subsRefunded': 'Rimborsati',
  'reports.subsRevenue': 'Ricavi',
  'reports.subsSold': 'venduti',
  'reports.subsUnusedVisits': 'Visite non utilizzate',
  'reports.subsUnusedHint': 'in attivi + scaduti',
  'reports.subsPurchaseDate': 'Data acquisto',
  'reports.subsPlan': 'Piano',
  'reports.subsBoughtVisits': 'Acquistati',
  'reports.subsUsage': 'Utilizzo',
  'reports.subsPaid': 'Pagato',
  'reports.subsValidUntil': 'Valido fino',
  'reports.subsStatus': 'Stato',
  'reports.reportType_no_shows': 'Analisi assenze',
  'reports.nsEmpty': 'Nessun appuntamento nel periodo selezionato',
  'reports.nsTotal': 'Totale appuntamenti',
  'reports.nsNoShow': 'Assenza',
  'reports.nsCancelled': 'Cancellati',
  'reports.nsLostRevenue': 'Ricavi persi',
  'reports.nsRepeatOffenders': 'Recidivi (≥2 assenze)',
  'reports.nsByStaff': 'Per personale',
  'reports.nsByService': 'Per servizio (top-15 problematici)',
  'reports.nsNoShowPct': '% Assenza',
  'reports.nsCancelPct': '% Cancellazione',
  'reports.nsRepeatOffendersTitle': 'Clienti recidivi',
  'reports.nsRepeatOffendersHint': '≥2 assenze nel periodo',
  'reports.nsLastNoShow': 'Ultima assenza',
  'reports.reportType_service_profitability': 'Redditività dei servizi',
  'reports.reportType_payment_methods': 'Metodi di pagamento',
  'reports.reportType_sales_by_channel': 'Vendite per canale',
  'reports.reportType_customer_ltv': 'LTV / Clienti VIP',
  'reports.profitEmpty': 'Nessun servizio nel periodo',
  'reports.profitRevenue': 'Ricavi',
  'reports.profitCost': 'Costo',
  'reports.profitGross': 'Profitto',
  'reports.profitMargin': 'Margine',
  'reports.profitVisits': 'Visite',
  'reports.group': 'Gruppo',
  'reports.visits': 'Visite',
  'reports.pmEmpty': 'Nessuna transazione nel periodo',
  'reports.tryChangeDate': 'Prova a cambiare il periodo',
  'reports.pmMethod': 'Metodo',
  'reports.pmCount': 'Transazioni',
  'reports.pmAmount': 'Importo',
  'reports.pmShare': 'Quota',
  'reports.pmTotalTx': 'Transazioni',
  'reports.pmMethodsCount': 'Metodi usati',
  'reports.pmCash': 'Contanti',
  'reports.pmTerminal': 'Terminale',
  'reports.pmOnline': 'Online',
  'reports.pmTransfer': 'Bonifico',
  'reports.pmSubscription': 'Abbonamento',
  'reports.pmGiftCard': 'Carta regalo',
  'reports.pmPoints': 'Punti fedeltà',
  'reports.pmUnknown': 'Non specificato',
  'reports.ltvEmpty': 'Nessun cliente nel periodo',
  'reports.ltvCustomers': 'Clienti',
  'reports.ltvTotalRevenue': 'Ricavi totali',
  'reports.ltvAvgTicket': 'Scontrino medio',
  'reports.ltvVip': 'Clienti VIP (top 20%)',
  'reports.ltvSleepingVip': 'VIP dormienti',
  'reports.ltvSleepingHint': '>60 giorni senza visita',
  'reports.ltvTotal': 'Totale',
  'reports.ltvLastVisit': 'Ultima visita',
  'reports.ltvSleepingBadge': '😴 VIP dormiente',
  'reports.ltvVipBadge': '👑 VIP',
  'reports.reportType_salary_archive': 'Archivio stipendi',
  'reports.reportType_salary_efficiency': 'Efficienza del personale (ROI)',
  'reports.reportType_salary_ratio': 'Rapporto stipendi / ricavi',
  'reports.salaryArchiveEmpty': 'Nessun record di stipendio salvato',
  'reports.salaryArchiveEmptyHint': 'Calcola lo stipendio nella pagina "Calcolo stipendi" — apparirà qui.',
  'reports.salaryArchiveMonth': 'Mese',
  'reports.salaryArchiveSavedAt': 'Salvato',
  'reports.salaryFund': 'Fondo totale',
  'reports.salaryStaffCount': 'Personale',
  'reports.salaryAvg': 'Media',
  'reports.salaryRevenue': 'Ricavi del mese',
  'reports.salaryScheme': 'Schema',
  'reports.salaryByRules': 'Per regole',
  'reports.salaryAdjustments': 'Aggiustamenti',
  'reports.salaryEffEmpty': 'Nessuno stipendio calcolato nel periodo',
  'reports.salaryEffEmptyHint': 'Prova un periodo dove gli stipendi sono già calcolati.',
  'reports.salaryEffRevenue': 'Ricavi',
  'reports.salaryEffSalary': 'Stipendio',
  'reports.salaryEffProfit': 'Margine',
  'reports.salaryEffAvgRoi': 'ROI medio',
  'reports.salaryEffRoiHint': '>3 sano, <1.5 problema',
  'reports.salaryRatioEmpty': 'Nessuno storico stipendi',
  'reports.salaryRatioCurrent': 'Rapporto attuale',
  'reports.salaryRatioAvg': 'Media del periodo',
  'reports.salaryRatioTrend': 'Variazione vs mese precedente',
  'reports.salaryRatioHealthy': 'Intervallo sano',
  'reports.salaryRatioHealthyHint': 'per settore beauty',
  'reports.salaryRatioPct': 'Rapporto',
  'reports.loading': 'Caricamento…',
  'reports.reportType_sales_managers': 'Responsabili vendite',
  'reports.smEmpty': 'Nessun ordine nel periodo selezionato',
  'reports.smUnknown': '— Non specificato',
  'reports.smManagersCount': 'Responsabili',
  'reports.smOrdersCreated': 'Ordini creati',
  'reports.smDelivered': 'Consegnati',
  'reports.smNetRevenue': 'Ricavi netti',
  'reports.smAvgCheck': 'Scontrino medio',
  'reports.smManager': 'Responsabile',
  'reports.smCreated': 'Creati',
  'reports.smCancelled': 'Cancellati',
  'reports.smReturned': 'Resi',
  'reports.smCancelRate': '% Cancellazione',
  'reports.smReturnRate': '% Reso',
  'reports.smAvgTime': 'Giorni a consegna',
  'reports.reportType_admin_activity': 'Attività amministratori',
  'reports.aaEmpty': 'Nessuna attività createdBy nel periodo',
  'reports.aaAdmins': 'Admin attivi',
  'reports.aaTotalApts': 'Appuntamenti creati',
  'reports.aaTotalProcessed': 'Denaro elaborato',
  'reports.aaSubsRevenue': 'Ricavi abbonamenti',
  'reports.aaAdmin': 'Admin',
  'reports.aaApts': 'Appunt.',
  'reports.aaConfirmed': 'Confer.',
  'reports.aaNoShowPct': '% Assenza',
  'reports.aaTx': 'Tx',
  'reports.aaProcessed': 'Importo',
  'reports.aaSubsSold': 'Abbon.',
  'reports.aaSubsRev': 'Abbon. ₴',
  'reports.aaDiscounts': 'Sconti ₴',
  'reports.groupSales': 'Ricavi e vendite',
  'reports.groupCustomers': 'Clienti',
  'reports.groupStaff': 'Personale e stipendi',
  'reports.groupLoyalty': 'Fedeltà e promo',
  'reports.groupInventory': 'Magazzino',
  'reports.groupProcurement': 'Acquisti',
  'reports.reportType_loyalty_points': 'Punti fedeltà',
  'reports.reportType_coupons': 'Coupon',
  'reports.lpEmpty': 'Nessuna attività fedeltà nel periodo',
  'reports.lpEarned': 'Accumulati',
  'reports.lpRedeemed': 'Utilizzati',
  'reports.lpReversed': 'Storni',
  'reports.lpReversedHint': 'rimborsi / cancellazioni',
  'reports.lpNet': 'Netto del periodo',
  'reports.lpSourcesTitle': 'Origine dei punti',
  'reports.lpSource': 'Origine',
  'reports.lpPoints': 'Punti',
  'reports.lpShare': 'Quota',
  'reports.lpRefService': 'Servizi',
  'reports.lpRefProduct': 'Prodotti',
  'reports.lpRefOrder': 'Ordini',
  'reports.lpRefReferral': 'Referral',
  'reports.lpRefBirthday': 'Compleanno',
  'reports.lpRefManual': 'Manuale',
  'reports.lpRefSubscription': 'Abbonamento',
  'reports.lpRefOther': 'Altro',
  'reports.cpEmpty': 'Non hai ancora coupon',
  'reports.cpEmptyHint': 'Aggiungi coupon in Fedeltà per vedere le statistiche.',
  'reports.cpTotal': 'Totale coupon',
  'reports.cpUsedInPeriod': 'Usati nel periodo',
  'reports.cpDiscount': 'Sconto dato',
  'reports.cpOrderAmount': 'Ricavi con coupon',
  'reports.cpCode': 'Codice',
  'reports.cpType': 'Tipo',
  'reports.cpValue': 'Valore',
  'reports.cpUsage': 'Usati',
  'reports.cpInPeriod': 'Nel periodo',
  'reports.cpOrderSum': 'Ricavi ₴',
  'reports.cpStatus': 'Stato',
  'reports.cpStatusActive': 'Attivo',
  'reports.cpStatusExpired': 'Scaduto',
  'reports.cpStatusExhausted': 'Esaurito',
  'reports.cpStatusDisabled': 'Disattivato',
  'reports.reportType_production_runs': 'Produzione',
  'reports.reportType_cash_shifts_report': 'Turni di cassa',
  'reports.reportType_heatmap_dow_hour': 'Mappa calore giorno × ora',
  'reports.prEmpty': 'Nessuna produzione nel periodo',
  'reports.prRuns': 'Lotti',
  'reports.prCancelled': 'cancellati',
  'reports.prOutputQty': 'Quantità prodotta',
  'reports.prInputCost': 'Costo materiali',
  'reports.prAvgUnitCost': 'Costo medio unità',
  'reports.prRecipe': 'Ricetta',
  'reports.csEmpty': 'Nessun turno di cassa nel periodo',
  'reports.csEmptyHint': 'I turni si sincronizzano con Checkbox.',
  'reports.csShifts': 'Turni',
  'reports.csCash': 'Contanti',
  'reports.csCard': 'Carta',
  'reports.csAvgDuration': 'Durata media',
  'reports.csDiscrep': 'Con discrepanza',
  'reports.csOpened': 'Aperto',
  'reports.csClosed': 'Chiuso',
  'reports.csLocation': 'Sede',
  'reports.csOpenBal': 'Inizio ₴',
  'reports.csCloseBal': 'Fine ₴',
  'reports.csDiff': 'Δ',
  'reports.csOpen': 'Aperto',
  'reports.hmEmpty': 'Nessun appuntamento nel periodo',
  'reports.hmTotal': 'Totale appuntamenti',
  'reports.hmPeak': 'Ora di punta',
  'reports.hmTopDay': 'Giorno top',
  'reports.hmRecords': 'appuntamenti',
  'reports.hmLow': 'Basso',
  'reports.hmMedium': 'Medio',
  'reports.hmHigh': 'Alto',
  'reports.hmPeakLegend': 'Picco',
  'reports.dowMon': 'Lun',
  'reports.dowTue': 'Mar',
  'reports.dowWed': 'Mer',
  'reports.dowThu': 'Gio',
  'reports.dowFri': 'Ven',
  'reports.dowSat': 'Sab',
  'reports.dowSun': 'Dom',
  'reports.period_day': 'Giorno',
  'reports.period_week': 'Settimana',
  'reports.period_month': 'Mese',
  'reports.period_year': 'Anno',
  'reports.period_custom': 'Personalizzato',
  'period.today': 'Oggi',
  'period.yesterday': 'Ieri',
  'period.thisWeek': 'Questa settimana',
  'period.lastWeek': 'Settimana scorsa',
  'period.thisMonth': 'Questo mese',
  'period.lastMonth': 'Mese scorso',
  'period.thisQuarter': 'Questo trimestre',
  'period.thisYear': "Quest'anno",
  'period.last30': 'Ultimi 30 giorni',
  'period.last90': 'Ultimi 90 giorni',
  'period.custom': 'Personalizzato',
  'reports.title': 'Report',
  'reports.subtitle': 'Analitica e reportistica',
  'reports.allStaff': 'Tutti i dipendenti',
  'reports.allClients': 'Tutti i clienti',
  'reports.allCategories': 'Tutte le categorie',
  'reports.allProducts': 'Tutti i prodotti',
  'reports.allLocations': 'Tutte le sedi',
  'reports.appointments': 'Appuntamenti',
  'reports.clients': 'Clienti',
  'reports.masters': 'Operatori',
  'reports.revenue': 'Ricavi',
  'reports.service': 'Servizio',
  'reports.serviceOrProduct': 'Prodotto/Servizio',
  'reports.client': 'Cliente',
  'reports.master': 'Operatore',
  'reports.date': 'Data',
  'reports.dateTime': 'Data/ora',
  'reports.time': 'Ora',
  'reports.duration': 'Durata',
  'reports.price': 'Prezzo',
  'reports.discount': 'Sconto',
  'reports.paid': 'Pagato',
  'reports.payment': 'Pagamento',
  'reports.method': 'Metodo',
  'reports.cash': 'Contanti',
  'reports.online': 'Online',
  'reports.total': 'Totale',
  'reports.grandTotal': 'Totale generale',
  'reports.sum': 'Importo',
  'reports.position': 'Posizione',
  'reports.positions': 'posizioni',
  'reports.product': 'Prodotto',
  'reports.category': 'Categoria',
  'reports.qty': 'Qt\u00e0',
  'reports.pcs': 'pz',
  'reports.cost': 'Costo',
  'reports.balance': 'Saldo',
  'reports.debt': 'Debito',
  'reports.charges': 'Addebiti',
  'reports.productCharges': 'Addebiti prodotti',
  'reports.serviceRefunds': 'Rimborsi servizi',
  'reports.subscriptionVisit': 'Visita da abbonamento',
  'reports.charged': 'Addebitato',
  'reports.visits': 'Visite',
  'reports.days': 'gg.',
  'reports.hrs': 'ore',
  'reports.min': 'min',
  'reports.avgCheck': 'Scontrino medio',
  'reports.avgDuration': 'Durata media',
  'reports.totalClients': 'Clienti totali',
  'reports.totalHours': 'Ore totali',
  'reports.servicesSold': 'Servizi erogati',
  'reports.withDiscount': 'Con sconto',
  'reports.utilization': 'Utilizzo',
  'reports.worked': 'Lavorato',
  'reports.workingHours': 'Ore lavorative',
  'reports.noVisitDays': 'Giorni senza visita',
  'reports.forOrder': 'Per ordine',
  'reports.mainRegister': 'Cassa principale',
  'reports.settlementAccount': 'Conto corrente',
  'reports.other': 'Altro',
  'reports.incoming': 'Entrate',
  'reports.incomingQty': 'Qt\u00e0 entrate',
  'reports.incomingSum': 'Importo entrate',
  'reports.incomings': 'Entrate',
  'reports.writeoff': 'Scarico',
  'reports.writeoffsExpenses': 'Scarichi/spese',
  'reports.writtenOff': 'Scaricato',
  'reports.writtenOffQty': 'Qt\u00e0 scarichi',
  'reports.writtenOffSum': 'Importo scarichi',
  'reports.remainQty': 'Qt\u00e0 rimanenza',
  'reports.remainSum': 'Importo rimanenza',
  'reports.transferMove': 'Trasferimento',
  'reports.together': 'Insieme',
  'reports.exportExcel': 'Esporta in Excel',
  'reports.exportPdf': 'Stampa / PDF',
  'reports.print': 'Stampa',
  'reports.noService': 'Senza servizio',
  'reports.noDataForPeriod': 'Nessun dato per il periodo selezionato',
  'reports.noCompletedForPeriod': 'Nessun appuntamento completato per il periodo selezionato',
  'reports.noRecordsForPeriod': 'Nessun record per il periodo selezionato',
  'reports.noInventoryForPeriod': 'Nessun dato di magazzino per il periodo selezionato',
  'reports.segment_all': 'Tutti',
  'reports.segment_no30': 'Assenti 30+ giorni',
  'reports.segment_new': 'Nuovi',
  'reports.segment_vip': 'VIP',
  'reports.segment_once': 'Una sola volta',
  'reports.segment_services_only': 'Solo servizi',
  'reports.segment_products_only': 'Solo prodotti',
  'reports.productContactsCol': 'Ord. prod.',
  'reports.serviceContactsCol': 'Ord. serv.',
  'reports.servicesIncome': 'Servizi ₴',
  'reports.productsIncome': 'Prodotti ₴',
  'reports.lastContact': 'Ult. contatto',
  'reports.operations': 'Operazioni',
  'reports.noClientsInSegment': 'Nessun cliente in questo segmento',
  'reports.tryChangeDateOrStaff': 'Prova a cambiare la data o il dipendente',
  'reports.tryChangeDateOrFilters': 'Prova a cambiare la data o i filtri',
  'reports.tryChangeDateOrClient': 'Prova a cambiare la data o il cliente',
  'reports.servicesRevenue': 'Ricavi dei servizi',
  'reports.productSales': 'Vendite di prodotti',
  'reports.totalRevenue': 'Ricavo totale',
  'reports.share': 'Quota',
  'reports.materialCosts': 'Costi dei materiali',
  'reports.margin': 'Margine',
  'reports.abcClass': 'Classe',
  'reports.abcLeaders': 'leader',
  'reports.abcMiddle': 'medi',
  'reports.abcSlow': 'bassa rotazione',
  'reports.avgPerDay': 'Media giornaliera',
  'reports.discountCount': 'Numero di sconti',
  'reports.discountSum': 'Importo sconti',
  'reports.discountShare': 'Quota sconti',
  'reports.noDiscountsForPeriod': 'Nessuno sconto per il periodo selezionato',
  'reports.grossPrice': 'Prezzo lordo',
  'reports.avgDiscount': 'Sconto medio',
  'reports.supplier': 'Fornitore',
  'reports.allSuppliers': 'Tutti i fornitori',
  'reports.suppliersCount': 'Fornitori',
  'reports.invoices': 'Fatture',
  'reports.avgPrice': 'Prezzo medio',
  'reports.noPurchasesForPeriod': 'Nessun acquisto per il periodo selezionato',
  'reports.productUnits': 'Unità di prodotto',
  'reports.invoiceCount': 'N. fatture',
  'reports.netto': 'Netto',
  'reports.peakDay': 'Picco',
  'reports.purchases': 'Acquisti',
  'reports.categories': 'Categorie',
  'reports.remainder': 'Rimanenza',
  'reports.ordered': 'Ordinato',
  'reports.returned': 'Restituito',
  'reports.received': 'Ricevuto',
  'reports.productsCompared': 'Prodotti confrontati',
  'reports.noPriceComparison': 'Nessun dato di confronto disponibile',
  'reports.needMultipleSuppliers': 'Servono acquisti di un prodotto da diversi fornitori',
  'reports.turnoverRatio': 'Rotazione',
  'reports.turnoverStatus': 'Stato',
  'reports.highTurnover': 'Alta',
  'reports.medTurnover': 'Media',
  'reports.lowTurnover': 'Bassa',

  // ── Financial result page ──
  'finResult.month_jan': 'Gennaio', 'finResult.month_feb': 'Febbraio', 'finResult.month_mar': 'Marzo',
  'finResult.month_apr': 'Aprile', 'finResult.month_may': 'Maggio', 'finResult.month_jun': 'Giugno',
  'finResult.month_jul': 'Luglio', 'finResult.month_aug': 'Agosto', 'finResult.month_sep': 'Settembre',
  'finResult.month_oct': 'Ottobre', 'finResult.month_nov': 'Novembre', 'finResult.month_dec': 'Dicembre',
  'finResult.sourceDeleted': 'Questo documento è stato rimosso dal sistema',
  'finResult.title': 'Risultato finanziario',
  'finResult.subtitle': 'Analisi di ricavi e spese',
  'finResult.allLocations': 'Tutte le sedi',
  'finResult.income': 'Ricavo',
  'finResult.incomes': 'Ricavi',
  'finResult.expenses': 'Spese',
  'finResult.financialResult': 'Risultato finanziario',
  'finResult.profitability': 'Redditivit\u00e0',
  'finResult.sales': 'Vendite',
  'finResult.servicesCompleted': 'Servizi erogati',
  'finResult.productSales': 'Vendita prodotti',
  'finResult.orderProductSales': 'Vendita prodotti (spedizioni)',
  'finResult.posProductSales': 'Vendita prodotti (POS / negozio)',
  'finResult.aptProductSales': 'Vendita prodotti nei servizi',
  'finResult.subscriptions': 'Abbonamenti',
  'finResult.refunds': 'rimborsi',
  'finResult.cogsOrders': 'Costo — spedizioni',
  'finResult.cogsAppointments': 'Costo — servizi',
  'finResult.cogsPos': 'Costo — negozio',
  'finResult.cogsWriteoffs': 'Costo altre uscite',
  'finResult.orders': 'Ordini',
  'finResult.visits': 'Visite',
  'finResult.salaries': 'Stipendi',
  'finResult.addExpense': 'Aggiungi spesa',
  'finResult.otherIncome': 'Altri ricavi',
  'finResult.addOtherIncome': 'Aggiungi altro ricavo',
  'finResult.incomeName': 'Nome del ricavo',
  'finResult.deleteIncomeConfirm': 'Eliminare questo ricavo?',
  'finResult.exportExcel': 'Esporta in Excel',
  'finResult.add': 'Aggiungi',
  'finResult.cancel': 'Annulla',
  'finResult.delete': 'Elimina',
  'finResult.expenseName': 'Nome spesa',
  'finResult.expenseSum': 'Importo',
  'finResult.monthly': 'Mensile',
  'finResult.monthlyOption': 'Mensile',
  'finResult.oneTime': 'Una tantum',
  'finResult.oneTimeOption': 'Una tantum',
  'finResult.deleteExpenseTitle': 'Eliminare la spesa?',
  'finResult.deleteExpenseConfirm': 'Sei sicuro di voler eliminare questa spesa?',
  'finResult.notCalculated': 'Non calcolato',
  'finResult.print': 'Stampa',
  'finResult.printPdf': 'Stampa PDF',
  'finResult.dynamics6months': 'Dinamica ultimi 6 mesi',
  'finResult.expenseStructure': 'Struttura delle spese',
  'finResult.incomeStructure': 'Struttura dei ricavi',
  'finResult.donutServices': 'Servizi',
  'finResult.donutProducts': 'Prodotti',
  'finResult.noIncomeYet': 'Nessun ricavo questo mese',
  'finResult.salaryFundTitle': 'Struttura del fondo stipendi',
  'finResult.salaryNotCalculated': 'Gli stipendi per questo mese non sono ancora calcolati',
  'finResult.salaryNoData': 'Nessun dato da mostrare',
  'finResult.fundSalary': 'Stipendio fisso',
  'finResult.fundPercent': 'Percentuale',
  'finResult.fundHybrid': 'Per azione',
  'finResult.vsPrev': 'vs prec.',
  'finResult.cashFlowTitle': 'Flusso di cassa (giornaliero)',
  'finResult.cashFlowEmpty': 'Nessuna transazione questo mese',
  'finResult.cashFlowReceipts': 'Incassi',
  'finResult.cashFlowRefunds': 'Rimborsi',
  'finResult.cashFlowNet': 'Flusso netto',
  'finResult.groupCogsProducts': 'Costo dei beni',
  'finResult.groupSalaries': 'Stipendi',
  'finResult.groupFixed': 'Spese fisse',
  'finResult.groupOther': 'Storni e altro',
  'finResult.noExpensesYet': 'Nessuna spesa questo mese',
  'finResult.effectiveFrom': 'In vigore dal',
  'finResult.edit': 'Modifica',
  'finResult.save': 'Salva',
  'finResult.applyForwardOnly': 'Applica solo dal mese scelto in poi (mantieni l\'importo precedente per i mesi passati)',
  'finResult.total': 'Totale',
  'finResult.hintAddNew': 'La spesa sarà applicata da {month} in poi (finché non la modifichi).',
  'finResult.hintMutateSingle': 'L\'importo sarà aggiornato per: {month}',
  'finResult.hintMutateRange': 'L\'importo sarà aggiornato per: {from} — {to}',
  'finResult.hintMutateForward': 'L\'importo sarà aggiornato per: {month} e tutti i mesi successivi',
  'finResult.hintSplit': 'Sarà creata una nuova versione da {newMonth}. I mesi precedenti ({oldFrom} — {oldTo}) manterranno {oldAmount} ₴.',

  // ── Inventory products page ──
  'invProd.title': 'Prodotti',
  'invProd.subtitle': 'Gestione prodotti, categorie e magazzini',
  'invProd.tabProducts': 'Prodotti',
  'invProd.tabCategories': 'Categorie',
  'invProd.tabWarehouses': 'Magazzini',
  'invProd.statProducts': 'Prodotti',
  'invProd.statCategories': 'Categorie',
  'invProd.statWarehouses': 'Magazzini',
  'invProd.productsCount': 'Prodotti',
  'invProd.positionsCount': 'Posizioni',
  'invProd.searchPlaceholder': 'Cerca per nome, codice articolo...',
  'invProd.allCategories': 'Tutte le categorie',
  'invProd.addProduct': 'Aggiungi prodotto',
  'invProd.newProduct': 'Nuovo prodotto',
  'invProd.editProduct': 'Modifica prodotto',
  'invProd.emptyProducts': 'Nessun prodotto ancora',
  'invProd.emptyProductsHint': 'Aggiungi il primo prodotto',
  'invProd.emptyCategories': 'Crea la tua prima categoria di prodotti',
  'invProd.emptyCategoriesHint': 'Le categorie aiutano a organizzare i prodotti e trovare rapidamente ciò che serve',
  'invProd.emptyWarehouses': 'Aggiungi il tuo primo magazzino',
  'invProd.emptyWarehousesHint': 'I magazzini servono per monitorare le scorte ed effettuare gli acquisti',
  'invProd.colName': 'Nome',
  'invProd.colSku': 'Codice',
  'invProd.colCategory': 'Categoria',
  'invProd.colUnit': 'Unit\u00e0',
  'invProd.colStock': 'Giacenza',
  'invProd.colMin': 'Min.',
  'invProd.colSellPrice': 'Prezzo di vendita',
  'invProd.labelName': 'Nome',
  'invProd.labelSku': 'Codice articolo',
  'invProd.labelCategory': 'Categoria',
  'invProd.labelUnit': 'Unit\u00e0 di misura',
  'invProd.labelMinStock': 'Giacenza min.',
  'invProd.labelSellPrice': 'Prezzo di vendita',
  'invProd.labelImageUrl': "URL dell'immagine",
  'invProd.labelImage': 'Foto del prodotto',
  'invProd.uploadImage': 'Carica foto',
  'invProd.maxSize': 'fino a 200 KB',
  'invProd.pasteUrl': 'O incolla URL',
  'invProd.noCategory': 'Senza categoria',
  'invProd.unitPcs': 'pz',
  'invProd.unitG': 'g',
  'invProd.unitKg': 'kg',
  'invProd.unitMl': 'ml',
  'invProd.unitL': 'l',
  'invProd.unitPack': 'conf',
  'invProd.save': 'Salva',
  'invProd.cancel': 'Annulla',
  'invProd.publishOnOlx': 'Pubblica su OLX',
  'invProd.olxPublished': 'OLX: annuncio creato',
  'olxPublish.title': 'Pubblicazione su OLX',
  'olxPublish.fieldTitle': 'Titolo dell\'annuncio',
  'olxPublish.fieldDescription': 'Descrizione',
  'olxPublish.descriptionHint': 'OLX richiede solitamente ~80+ caratteri. Descrivi il prodotto, condizione, dettagli.',
  'olxPublish.fieldCategory': 'Categoria',
  'olxPublish.suggesting': 'Cerco categoria dal titolo…',
  'olxPublish.noCategorySuggestions': 'Impossibile suggerire una categoria. Precisa il titolo o inserisci l\'ID sotto.',
  'olxPublish.orManualCategoryId': 'oppure inserisci l\'ID categoria OLX',
  'olxPublish.fieldCity': 'Città',
  'olxPublish.cityPlaceholder': 'Inizia a digitare, es. «Kyiv»',
  'olxPublish.searching': 'Ricerca…',
  'olxPublish.fieldPrice': 'Prezzo',
  'olxPublish.fieldPhotoUrl': 'URL della foto',
  'olxPublish.fieldContactName': 'Nome contatto',
  'olxPublish.contactNamePlaceholder': 'Come firmare l\'annuncio',
  'olxPublish.fieldContactPhone': 'Telefono',
  'olxPublish.errorTitle': 'OLX ha restituito un errore:',
  'olxPublish.showRawError': 'Mostra risposta completa OLX',
  'olxPublish.categoryAttrsTitle': 'OLX richiede campi aggiuntivi per questa categoria:',
  'olxPublish.loadingAttrs': 'Caricamento campi della categoria…',
  'olxPublish.choose': 'scegli',
  'olxPublish.fieldDistrict': 'Distretto',
  'olxPublish.loadingDistricts': 'Caricamento distretti della città…',
  'olxPublish.success': 'Annuncio creato, inviato in moderazione OLX',
  'olxPublish.cancel': 'Annulla',
  'olxPublish.publish': 'Pubblica',
  'invProd.add': 'Aggiungi',
  'invProd.delete': 'Elimina',
  'invProd.deleteProduct': 'Elimina prodotto',
  'invProd.deleteCategory': 'Elimina categoria',
  'invProd.deleteWarehouse': 'Elimina magazzino',
  'invProd.deleteConfirmMsg': 'Sei sicuro di voler eliminare?',
  'invProd.cannotDelete': 'Impossibile eliminare',
  'invProd.errName': 'Inserisci il nome',
  'invProd.nameDuplicate': 'Un prodotto con questo nome esiste già',
  'invProd.catDuplicate': 'Una categoria con questo nome esiste già',
  'invProd.whDuplicate': 'Un magazzino con questo nome esiste già',
  'invProd.understood': 'Capito',
  'invProd.newCategoryPlaceholder': 'Nome della nuova categoria',
  'invProd.newWarehousePlaceholder': 'Nome del nuovo magazzino',
  'invProd.blockProduct': 'Prodotti',
  'invProd.blockCategory': 'Categorie',
  'invProd.blockWarehouse': 'Magazzini',

  // ── Inventory stock page ──
  'invStock.title': 'Giacenze',
  'invStock.subtitle': 'Controllo giacenze nei magazzini',
  'invStock.statProducts': 'Prodotti',
  'invStock.statLow': 'Giacenza bassa',
  'invStock.searchPlaceholder': 'Cerca per nome...',
  'invStock.allCategories': 'Tutte le categorie',
  'invStock.allWarehouses': 'Tutti i magazzini',
  'invStock.lowStockOnly': 'Solo giacenza bassa',
  'invStock.emptyTitle': 'Nessun dato',
  'invStock.emptyHint': 'Aggiungi prodotti nella sezione "Prodotti"',
  'invStock.colProduct': 'Prodotto',
  'invStock.colCategory': 'Categoria',
  'invStock.colUnit': 'Unit\u00e0',
  'invStock.colTotal': 'Giacenza',
  'invStock.colMin': 'Min.',
  'invStock.colStatus': 'Stato',
  'invStock.statusLow': 'Basso',
  'invStock.statusEmpty': 'Esaurito',
  'invStock.available': 'Disponibile',
  'invStock.transfer': 'Trasferimento',
  'invStock.transferTitle': 'Trasferimento prodotto',
  'invStock.transferBtn': 'Trasferisci',
  'invStock.labelProduct': 'Prodotto',
  'invStock.labelFromWarehouse': 'Dal magazzino',
  'invStock.labelToWarehouse': 'Al magazzino',
  'invStock.labelQuantity': 'Quantit\u00e0',
  'invStock.cancel': 'Annulla',

  // ── Inventory purchases page ──
  'invPurch.title': 'Acquisti',
  'invPurch.subtitle': 'Contabilit\u00e0 acquisti prodotti',
  'invPurch.statPurchases': 'Acquisti',
  'invPurch.searchPlaceholder': 'Cerca per fornitore...',
  'invPurch.newPurchase': 'Nuovo acquisto',
  'invPurch.emptyTitle': 'Nessun acquisto ancora',
  'invPurch.emptyHint': 'Crea il primo acquisto',
  'invPurch.colDate': 'Data',
  'invPurch.colSupplier': 'Fornitore',
  'invPurch.colWarehouse': 'Magazzino',
  'invPurch.colItems': 'Articoli',
  'invPurch.colTotal': 'Totale',
  'invPurch.modalTitle': 'Nuovo acquisto',
  'invPurch.labelSupplier': 'Fornitore',
  'invPurch.supplierPlaceholder': 'Inserisci il nome del fornitore...',
  'invPurch.labelDestWarehouse': 'Magazzino di destinazione',
  'invPurch.sectionProducts': 'Prodotti',
  'invPurch.selectProduct': 'Seleziona prodotto',
  'invPurch.searchProduct': 'Cerca prodotto...',
  'invPurch.noProducts': 'Nessun prodotto trovato',
  'invPurch.addItem': 'Aggiungi prodotto',
  'invPurch.qty': 'Qt\u00e0',
  'invPurch.pricePerUnit': 'Prezzo unitario',
  'invPurch.totalSum': 'Importo totale',
  'invPurch.pos': 'posizioni',
  'invPurch.units': 'unit\u00e0',
  'invPurch.receive': 'Registra',
  'invPurch.cancel': 'Annulla',
  'invPurch.errWarehouse': 'Seleziona un magazzino',
  'invPurch.errItems': 'Aggiungi almeno un prodotto',
  'invPurch.errNegPrice': 'Il prezzo non può essere negativo',
  'invPurch.errZeroPrice': 'Inserire il prezzo di acquisto per ogni prodotto',
  'invPurch.periodWeek': 'Settimana',
  'invPurch.periodMonth': 'Mese',
  'invPurch.periodYear': 'Anno',
  'invPurch.periodAll': 'Tutto il periodo',
  'invPurch.periodCustom': 'Personalizzato',
  'invPurch.returnToSupplier': 'Restituire al fornitore',
  'invPurch.returnTitle': 'Reso al fornitore',
  'invPurch.returnHint': 'Indicare le quantità da restituire',
  'invPurch.returnAmount': 'Importo del reso',
  'invPurch.confirmReturn': 'Restituire',
  'invPurch.returnSuccess': 'Reso completato',
  'invPurch.allReturned': 'Tutti gli articoli già restituiti o esauriti',
  'invPurch.deletePurchase': 'Elimina acquisto',
  'invPurch.deleteTitle': 'Elimina acquisto',
  'invPurch.deleteWarning': 'Sei sicuro? I seguenti articoli verranno rimossi dallo stock:',
  'invPurch.deleteStockNote': 'Le quantità in stock verranno ridotte di conseguenza.',
  'invPurch.deleteConfirm': 'Elimina',
  'invPurch.deleteBlockedTitle': 'Eliminazione non possibile',
  'invPurch.deleteBlockedText': 'Questo acquisto non può essere eliminato perché ci sono movimenti successivi per questi prodotti:',
  'invPurch.deleteBlockedHint': 'Prima elimina o annulla le operazioni successive, poi riprova.',
  'invPurch.understood': 'Capito',

  // ── Tabs ──
  'invPurch.tabPurchases': 'Ricevimento merci',
  'invPurch.tabSuppliers': 'Fornitori',
  'invPurch.selectSupplier': 'Seleziona fornitore',

  // ── Suppliers ──
  'invPurch.searchSupplier': 'Cerca fornitore...',
  'invPurch.newSupplier': 'Nuovo fornitore',
  'invPurch.editSupplier': 'Modifica fornitore',
  'invPurch.statSuppliers': 'fornitori',
  'invPurch.emptySuppliersTitle': 'Nessun fornitore',
  'invPurch.emptySuppliersHint': 'Aggiungi fornitori per un monitoraggio comodo degli acquisti',
  'invPurch.colSupplierName': 'Nome',
  'invPurch.colContact': 'Persona di contatto',
  'invPurch.colPhone': 'Telefono',
  'invPurch.colEdrpou': 'P.IVA',
    'invPurch.supplierDuplicate': 'A supplier with this name already exists',
'invPurch.supplierName': 'Nome',
  'invPurch.supplierNamePh': 'S.r.l. "Fornitore"',
  'invPurch.contactPerson': 'Persona di contatto',
  'invPurch.contactPersonPh': 'Cognome Nome',
  'invPurch.phone': 'Telefono',
  'invPurch.email': 'Email',
  'invPurch.bankDetails': 'Coordinate bancarie',
  'invPurch.edrpou': 'P.IVA',
  'invPurch.mfo': 'Codice banca',
  'invPurch.iban': 'IBAN / Numero di conto',
  'invPurch.supplierNotes': 'Note',
  'invPurch.supplierNotesPh': 'Informazioni aggiuntive sul fornitore...',
  'invPurch.create': 'Crea',
  'invPurch.deleteSupplierTitle': 'Eliminare il fornitore?',
  'invPurch.deleteSupplierWarning': 'Sei sicuro di voler eliminare il fornitore',

  // ── Inventory movements page ──
  'invMov.title': 'Movimenti di magazzino',
  'invMov.subtitle': 'Storico movimenti prodotti nei magazzini',
  'invMov.statOperations': 'Operazioni',
  'invMov.filterType': 'Tipo',
  'invMov.filterAll': 'Tutti',
  'invMov.filterPurchase': 'Acquisto',
  'invMov.filterWriteoff': 'Scarico',
  'invMov.filterTransfer': 'Trasferimento',
  'invMov.filterAppointment': 'Appuntamento',
  'invMov.filterOrder': 'Ordine',
  'invMov.filterReturn': 'Reso',
  'invMov.filterAllProducts': 'Tutti i prodotti',
  'invMov.emptyTitle': 'Nessuna operazione',
  'invMov.emptyHint': 'Qui verranno mostrate tutte le operazioni sui prodotti',
  'invMov.colDate': 'Data',
  'invMov.colType': 'Tipo',
  'invMov.colProduct': 'Prodotto',
  'invMov.colQty': 'Qt\u00e0',
  'invMov.colCost': 'Costo',
  'invMov.colWarehouse': 'Magazzino',
  'invMov.colAuthor': 'Autore',
  'invMov.colDetails': 'Dettagli',
  'invMov.typePurchase': 'Acquisto',
  'invMov.typeWriteoff': 'Scarico',
  'invMov.typeTransfer': 'Trasferimento',
  'invMov.typeAppointment': 'Appuntamento',
  'invMov.typeSale': 'Vendita',
  'invMov.typeOrder': 'Ordine',
  'invMov.typeOrderCancel': 'Annullamento ordine',
  'invMov.typeSaleCancel': 'Annullamento vendita',
  'invMov.typeAppointmentCancel': 'Annullamento appuntamento',
  'invMov.typeReturn': 'Reso',
  'invMov.supplier': 'Fornitore',
  'invMov.writeoffTitle': 'Scarico prodotto',
  'invMov.writeoffBtn': 'Scarica',
  'invMov.writeoffConfirm': 'Conferma scarico',
  'invMov.labelProduct': 'Prodotto',
  'invMov.labelQuantity': 'Quantit\u00e0',
  'invMov.labelWarehouse': 'Magazzino',
  'invMov.labelReason': 'Motivo',
  'invMov.labelNote': 'Nota',
  'invMov.available': 'Disponibile',
  'invMov.cancel': 'Annulla',
  'invMov.reasonExpired': 'Scaduto',
  'invMov.reasonDamaged': 'Danneggiato',
  'invMov.reasonLost': 'Perso',
  'invMov.reasonUsed': 'Utilizzato',
  'invMov.reasonOther': 'Altro',

  // ── Salary calculation page ──
  'salCalc.month_jan': 'Gennaio', 'salCalc.month_feb': 'Febbraio', 'salCalc.month_mar': 'Marzo',
  'salCalc.month_apr': 'Aprile', 'salCalc.month_may': 'Maggio', 'salCalc.month_jun': 'Giugno',
  'salCalc.month_jul': 'Luglio', 'salCalc.month_aug': 'Agosto', 'salCalc.month_sep': 'Settembre',
  'salCalc.month_oct': 'Ottobre', 'salCalc.month_nov': 'Novembre', 'salCalc.month_dec': 'Dicembre',
  'salCalc.title': 'Calcolo stipendi',
  'salCalc.subtitle': 'Calcolo delle retribuzioni',
  'salCalc.selectMonthHint': 'Seleziona il mese per il calcolo',
  'salCalc.calculate': 'Calcola',
  'salCalc.save': 'Salva',
  'salCalc.loadSaved': 'Carica salvato',
  'salCalc.exportExcel': 'Esporta Excel',
  'salCalc.staffCount': 'Dipendenti',
  'salCalc.staffWithSchemes': 'Con schemi',
  'salCalc.allStaff': 'Tutti',
  'salCalc.noDataTitle': 'Nessun dato',
  'salCalc.noDataDesc': 'Seleziona il mese e clicca "Calcola"',
  'salCalc.noStaffTitle': 'Nessun dipendente',
  'salCalc.noStaffDesc': 'Aggiungi dipendenti nella sezione "Personale"',
  'salCalc.totalByRules': 'Per regole',
  'salCalc.manualAdjustments': 'Rettifiche',
  'salCalc.totalLabel': 'Totale',
  'salCalc.grandTotal': 'Importo totale',
  'salCalc.adjustments': 'Rettifiche',
  'salCalc.addAdjustment': 'Aggiungi rettifica',
  'salCalc.adjDescPlaceholder': 'Descrizione...',
  'salCalc.adjAmountPlaceholder': 'Importo',
  'salCalc.edit': 'Modifica',
  'salCalc.back': 'Indietro',
  'salCalc.cancel': 'Annulla',
  'salCalc.saved': 'Salvato',
  'salCalc.savedNotice': 'Calcolo salvato',
  'salCalc.overwriteTitle': 'Sovrascrivere?',
  'salCalc.overwriteDesc': 'Per questo mese esiste gi\u00e0 un calcolo salvato. Sovrascrivere?',
  'salCalc.overwrite': 'Sovrascrivi',
  'salCalc.hourlyRate': 'Tariffa oraria',
  'salCalc.monthlySalary': 'Stipendio mensile',
  'salCalc.monthlyFixed': 'fisso al mese',
  'salCalc.tiered': 'scaglioni',
  'salCalc.dailyRate': 'Tariffa giornaliera',
  'salCalc.fixedPerAppointment': 'Fisso per appuntamento',
  'salCalc.percentOwnServices': '% dai propri servizi',
  'salCalc.percentTotalRevenue': '% dai ricavi totali',
  'salCalc.percentOwnProductSales': '% own product sales',
  'salCalc.percentAllProductSales': '% all product sales',
  'salCalc.percentCreatedAppointments': '% created appointments',
  'salCalc.fixedPerCreatedAppointment': 'Fixed per created apt',
  'salCalc.percentOwnMaterials': '% materials',
  'salCalc.percentAllServices': '% of all location services',
  'salCalc.hours': 'ore',
  'salCalc.days': 'gg',
  'salCalc.appts': 'app.',
  'salCalc.services': 'serv.',
  'salCalc.individual': 'individuale',
  'salCalc.otherService': 'altro',
  'salCalc.exFileName': 'Stipendi',
  'salCalc.exStaff': 'Dipendente',
  'salCalc.exScheme': 'Schema',
  'salCalc.exByRules': 'Per regole',
  'salCalc.exAdjustments': 'Rettifiche',
  'salCalc.exTotal': 'Totale',

  // ── Salary schemes page ──
  'salSchemes.title': 'Schemi di motivazione',
  'salSchemes.subtitle': 'Regole di calcolo delle retribuzioni',
  'salSchemes.schemesCount': 'Schemi',
  'salSchemes.newScheme': 'Nuovo schema',
  'salSchemes.emptyTitle': 'Nessuno schema ancora',
  'salSchemes.emptyDesc': 'Crea il primo schema retributivo',
  'salSchemes.newSchemeTitle': 'Nuovo schema',
  'salSchemes.editScheme': 'Modifica schema',
  'salSchemes.schemeName': 'Nome schema',
  'salSchemes.nameDuplicate': 'Uno schema con questo nome esiste già',
  'salSchemes.schemeNamePlaceholder': 'Inserisci il nome...',
  'salSchemes.rulesSection': 'Regole di calcolo',
  'salSchemes.groupBase': 'Base',
  'salSchemes.groupServices': 'Services',
  'salSchemes.groupProducts': 'Products',
  'salSchemes.groupGeneral': 'General',
  'salSchemes.groupAdmin': 'Admin',
  'salSchemes.noRules': 'Nessuna regola ancora',
  'salSchemes.hourlyRate': 'Tariffa oraria',
  'salSchemes.dailyRate': 'Tariffa giornaliera',
  'salSchemes.fixedPerAppointment': 'Fisso per servizio svolto',
  'salSchemes.percentOwnServices': '% dai propri servizi',
  'salSchemes.percentTotalRevenue': '% dai ricavi totali',
  'salSchemes.hintHourlyRate': 'UAH/ora',
  'salSchemes.hintDailyRate': 'UAH/giorno',
  'salSchemes.hintFixedPer': 'UAH/appuntamento',
  'salSchemes.hintPercentOwn': '% dai propri',
  'salSchemes.hintPercentTotal': '% dal totale',
  'salSchemes.percentOwnProductSales': '% own product sales',
  'salSchemes.hintPercentOwnProducts': '% of products sold by employee',
  'salSchemes.percentAllProductSales': '% all product sales',
  'salSchemes.hintPercentAllProducts': '% of total product sales',
  'salSchemes.percentCreatedAppointments': '% created appointments',
  'salSchemes.hintPercentCreated': '% from appointments created by employee',
  'salSchemes.fixedPerCreatedAppointment': 'Fixed per created appointment',
  'salSchemes.hintFixedCreated': 'Fixed amount per created appointment',
  'salSchemes.percentOwnMaterials': '% materials',
  'salSchemes.hintPercentMaterials': '% of materials in appointments',
  'salSchemes.percentAllServices': '% of all location services',
  'salSchemes.hintPercentAllServices': 'Percentage of total service and subscription revenue at location',
  'salSchemes.subscriptionLabel': 'Subscription services',
  'salSchemes.subModeVisitPrice': 'At subscription price',
  'salSchemes.subModeFullPrice': 'At list price',
  'salSchemes.subModeSkip': 'Do not count',
  'salSchemes.unitHour': 'UAH/ora',
  'salSchemes.unitDay': 'UAH/giorno',
  'salSchemes.unitRecord': 'UAH/appuntamento',
  'salSchemes.unitService': 'UAH/serv.',
  'salSchemes.useOverrides': 'Tariffe per servizio',
  'salSchemes.overrideService': 'Servizio',
  'salSchemes.overrideRate': 'Tariffa',
  'salSchemes.overrideAdd': 'Aggiungi eccezione',
  'salSchemes.overrideRemove': 'Rimuovi eccezione',
  'salSchemes.overridesShort': 'eccezioni',
  'salSchemes.staffShort': 'dip.',
  'salSchemes.save': 'Salva',
  'salSchemes.create': 'Crea',
  'salSchemes.cancel': 'Annulla',
  'salSchemes.editBtn': 'Modifica',
  'salSchemes.deleteBtn': 'Elimina',
  'salSchemes.delete': 'Elimina',
  'salSchemes.deleteTitle': 'Eliminare lo schema?',
  'salSchemes.deleteConfirmText': 'Sei sicuro di voler eliminare questo schema?',
  'salSchemes.deleteAssigned': 'Questo schema \u00e8 assegnato a dipendenti e non pu\u00f2 essere eliminato',
  'salSchemes.understood': 'Capito',
  'salSchemes.monthlySalary': 'Stipendio mensile',
  'salSchemes.hintMonthlySalary': 'Importo fisso al mese indipendente dall\'orario',
  'salSchemes.unitMonth': '₴/mese',
  'salSchemes.useBrackets': 'Scaglioni',
  'salSchemes.bracketModeProgressive': 'Progressivo (per scaglione)',
  'salSchemes.bracketModeFlat': 'Piatto (totale allo scaglione raggiunto)',
  'salSchemes.bracketFrom': 'Da',
  'salSchemes.bracketTo': 'A',
  'salSchemes.bracketAdd': 'Aggiungi scaglione',
  'salSchemes.bracketRemove': 'Rimuovi scaglione',

  // ── Checkbox settings page ──
  'checkbox.title': 'Checkbox POS',
  'checkbox.subtitle': 'Configurazione connessione a Checkbox',
  'checkbox.licenseKey': 'Chiave di licenza',
  'checkbox.licenseKeyHint': 'Chiave dal pannello personale Checkbox',
  'checkbox.licenseKeyPlaceholder': 'Inserisci la chiave di licenza...',
  'checkbox.pinCode': 'PIN cassiere',
  'checkbox.pinCodeHint': 'PIN del cassiere da Checkbox',
  'checkbox.pinPlaceholder': 'Inserisci il PIN...',
  'checkbox.save': 'Salva',
  'checkbox.saving': 'Salvataggio...',
  'checkbox.settingsSaved': 'Impostazioni salvate',
  'checkbox.testConnection': 'Verifica connessione',
  'checkbox.testing': 'Verifica...',
  'checkbox.connectionSuccess': 'Connessione riuscita',
  'checkbox.connectionSuccessToast': 'Checkbox connesso con successo',
  'checkbox.shiftOpen': 'Turno aperto',
  'checkbox.shiftClosed': 'Turno chiuso',
  'checkbox.guideTitle': 'Come funziona l\'integrazione',
  'checkbox.guideStep1': 'Registrati su checkbox.ua e crea un registratore di cassa. Copia la chiave di licenza dal tuo cabinet.',
  'checkbox.guideStep2': 'Crea un cassiere e annota il codice PIN. Incolla la chiave e il PIN sopra, clicca "Testa connessione".',
  'checkbox.guideStep3': 'Fatto! Ora durante l\'elaborazione dei pagamenti di ordini o appuntamenti, il sistema creerà automaticamente ricevute fiscali.',
  'checkbox.guideCapabilities': 'Funzionalità:',
  'checkbox.guideCap1': 'Fiscalizzazione automatica nei pagamenti di ordini e appuntamenti',
  'checkbox.guideCap2': 'Apertura e chiusura dei turni di cassa',
  'checkbox.guideCap3': 'Supporto per pagamenti in contanti e con carta',
  'checkbox.guideCap4': 'Report X e report Z per il controllo di cassa',
  'checkbox.taxGroup': 'Gruppo fiscale',
  'checkbox.taxGroupHint': 'Seleziona le aliquote fiscali da includere in ogni ricevuta. Clicca "Testa connessione" per caricare le aliquote disponibili.',
  'checkbox.noTax': 'Senza tassa',

  // ── Nova Poshta settings page ──
  'np.title': 'Nova Poshta',
  'np.subtitle': 'Impostazioni integrazione Nova Poshta',
  'np.apiKey': 'Chiave API',
  'np.apiKeyPlaceholder': 'Inserisci la chiave API Nova Poshta...',
  'np.apiKeyHint': 'Chiave da my.novaposhta.ua → Impostazioni → Sicurezza',
  'np.save': 'Salva',
  'np.saving': 'Salvataggio...',
  'np.settingsSaved': 'Impostazioni Nova Poshta salvate',
  'np.error': 'Errore: ',
  'np.testConnection': 'Testa connessione',
  'np.testing': 'Test in corso...',
  'np.connectionSuccess': 'Connesso! Mittenti trovati: {count}',
  'np.connectionSuccessToast': 'Nova Poshta connesso con successo',
  'np.connectionFailed': 'Connessione fallita. Controlla la chiave API.',
  'np.senderSection': 'Dati del mittente',
  'np.sender': 'Mittente (controparte)',
  'np.contactPerson': 'Persona di contatto',
  'np.senderPhone': 'Telefono del mittente',
  'np.senderAddress': 'Indirizzo di spedizione',
  'np.senderAddressHint': 'Filiale Nova Poshta da cui spedisci i pacchi',
  'np.loadingSenders': 'Caricamento dati del mittente...',
  'np.senderWarehouse': 'Filiale del mittente',
  'np.senderWarehouseHint': 'Il tuo account NP non ha indirizzi registrati. Seleziona la filiale da cui spedisci.',
  'np.senderCity': 'Città del mittente',
  'np.senderCityPlaceholder': 'Inserisci il nome della città...',
  'np.senderWarehouseSelect': 'Filiale',
  'np.noWarehouses': 'Nessuna filiale trovata',
  'np.clearSelection': 'Cancella',
  'np.guideTitle': 'Come funziona l\'integrazione',
  'np.guideStep1': 'Accedi a my.novaposhta.ua → Impostazioni → Sicurezza → copia la chiave API.',
  'np.guideStep2': 'Incolla la chiave sopra, clicca "Testa connessione". Seleziona mittente, contatto e indirizzo.',
  'np.guideStep3': 'Fatto! Ora seleziona "Nova Poshta" come metodo di spedizione quando crei ordini.',
  'np.guideCapabilities': 'Funzionalità:',
  'np.guideCap1': 'Crea TTN con un clic dalla pagina ordine (stato "Imballato")',
  'np.guideCap2': 'Sincronizzazione automatica dello stato di consegna ogni 10 minuti',
  'np.guideCap3': 'Tracciamento pacchi in tempo reale',
  'np.guideCap4': 'Stampa etichette di spedizione',
  'np.guideCap5': 'Calcolo automatico del costo di consegna alla selezione della filiale',

  // ── Meest Express settings page ──
  'meest.title': 'Meest Express',
  'meest.subtitle': 'Impostazioni di integrazione',
  'meest.apiToken': 'Token API',
  'meest.apiTokenPlaceholder': 'Incolla il token API dal gabinetto Meest',
  'meest.apiTokenHint': 'Trovalo su 24.meest.com → Impostazioni → Integrazione API',
  'meest.contractId': 'Contract ID',
  'meest.contractIdPlaceholder': 'Es. b0004cad-27a3-...',
  'meest.contractIdHint': 'Trovalo nel gabinetto Meest accanto al token API',
  'meest.save': 'Salva',
  'meest.saving': 'Salvataggio...',
  'meest.settingsSaved': 'Impostazioni Meest Express salvate',
  'meest.error': 'Errore: ',
  'meest.testConnection': 'Testa connessione',
  'meest.testing': 'Test...',
  'meest.testingConnection': 'Test di connessione a Meest Express...',
  'meest.connectionSuccess': 'Meest Express connesso con successo',
  'meest.connectionSuccessToast': 'Meest Express connesso',
  'meest.connectionFailed': 'Connessione fallita. Verifica token e Contract ID.',
  'meest.senderSection': 'Dati mittente',
  'meest.senderName': 'Nome completo mittente',
  'meest.senderNamePlaceholder': 'Cognome Nome',
  'meest.senderPhone': 'Telefono mittente',
  'meest.senderCity': 'Città mittente',
  'meest.senderCityPlaceholder': 'Inizia a digitare il nome della città',
  'meest.senderBranch': 'Filiale mittente',
  'meest.branchPlaceholder': 'Cerca filiale',
  'meest.noBranches': 'Nessuna filiale trovata',
  'meest.clearSelection': 'Cancella',
  'meest.guideTitle': 'Come funziona l\'integrazione',
  'meest.guideStep1': 'Registrati su 24.meest.com e firma il contratto. In Impostazioni → Integrazione API copia il token e il Contract ID.',
  'meest.guideStep2': 'Incollali sopra, clicca "Testa connessione". I dati del mittente verranno compilati automaticamente.',
  'meest.guideStep3': 'Fatto! Ora seleziona "Meest Express" come metodo di spedizione quando crei ordini.',
  'meest.guideCapabilities': 'Funzionalità:',
  'meest.guideCap1': 'Crea spedizione con un clic dalla pagina ordine (stato "Imballato")',
  'meest.guideCap2': 'Sincronizzazione automatica dello stato di consegna ogni 10 minuti',
  'meest.guideCap3': 'Tracciamento pacchi in tempo reale',
  'meest.guideCap4': 'Stampa etichetta per il pacco',

  // ── Telegram settings page ──
  'telegram.title': 'Promemoria Telegram',
  'telegram.subtitle': 'Configurazione del bot per i promemoria ai clienti',
  'telegram.botToken': 'Bot Token',
  'telegram.botTokenHint': 'Token del bot da @BotFather',
  'telegram.saveAndConnect': 'Salva e connetti',
  'telegram.connecting': 'Connessione...',
  'telegram.checkingBot': 'Verifica del bot...',
  'telegram.settingWebhook': 'Configurazione webhook...',
  'telegram.botConnected': 'Bot connesso',
  'telegram.botReady': 'Il bot \u00e8 pronto',
  'telegram.invalidToken': 'Token non valido',
  'telegram.webhookError': 'Errore webhook',
  'telegram.webhookFailed': 'Impossibile configurare il webhook',
  'telegram.error': 'Errore',
  'telegram.howItWorks': 'Come funziona',
  'telegram.step1': '1. Crea un bot tramite @BotFather in Telegram',
  'telegram.step2': '2. Copia il token del bot',
  'telegram.step3': '3. Incolla il token sopra e clicca "Salva e connetti"',
  'telegram.step4': '4. I clienti potranno connettersi tramite il link',
  'telegram.guideCapabilities': 'Funzionalità:',
  'telegram.guideCap1': 'Promemoria automatici degli appuntamenti per i clienti',
  'telegram.guideCap2': 'I clienti possono visualizzare i prossimi appuntamenti',
  'telegram.guideCap3': 'Confermare o annullare appuntamenti tramite il bot',
  'telegram.guideCap4': 'Link personale per ogni cliente',

  // ── SMS settings page ──
  'sms.title': 'Invio SMS',
  'sms.subtitle': 'Configurazione gateway SMS',
  'sms.provider': 'Provider',
  'sms.apiKey': 'Chiave API',
  'sms.apiKeyPlaceholder': 'Inserisci la chiave API...',
  'sms.senderName': 'Nome mittente',
  'sms.senderNameHint': 'Nome che il destinatario vedr\u00e0 (max 11 caratteri)',
  'sms.save': 'Salva',
  'sms.settingsSaved': 'Impostazioni salvate',
  'sms.testConnection': 'Verifica connessione',
  'sms.testing': 'Verifica...',
  'sms.checkingConnection': 'Verifica della connessione...',
  'sms.connectionSuccess': 'Connessione riuscita',
  'sms.connectionError': 'Errore di connessione',
  'sms.gatewayWorks': 'Il gateway SMS funziona',
  'sms.error': 'Errore',
  'sms.unknown': 'Errore sconosciuto',
  'sms.howItWorks': 'Come funziona',
  'sms.step1': '1. Registrati presso un provider SMS',
  'sms.step2': '2. Ottieni la chiave API',
  'sms.step3': '3. Incolla la chiave sopra e salva',
  'sms.step4': '4. Ora puoi inviare SMS ai clienti',
  'sms.howToConnect': 'Come collegare {name}',
  'sms.openSite': 'Apri il sito di {name}',
  'sms.apiKeyLocation': 'La chiave API si trova qui: {path}',
  'sms.recommended': 'Consigliato',
  'sms.tagline_turbosms': 'Il più popolare in Ucraina. Dashboard solida, API semplice.',
  'sms.tagline_smsclub': 'Tariffe flessibili, alpha-name supportato.',
  'sms.tagline_alphasms': 'Prezzi trasparenti, registrazione veloce.',
  'sms.guide_turbosms.step1': 'Registrati su TurboSMS e ricarica il saldo.',
  'sms.guide_turbosms.step2': 'Ordina un alpha-name (nome mittente) dalla dashboard. Approvazione di solito in giornata.',
  'sms.guide_turbosms.step3': 'Vai in Profilo → API e copia la chiave API.',
  'sms.guide_turbosms.step4': 'Incolla la chiave + alpha-name qui sotto e clicca "Verifica connessione".',
  'sms.guide_smsclub.step1': 'Crea un account SMSClub e ricarica il saldo.',
  'sms.guide_smsclub.step2': 'Ordina un alpha-name dalla dashboard (moderazione ~1 giorno lavorativo).',
  'sms.guide_smsclub.step3': 'Apri Impostazioni / Profilo → trova il token API.',
  'sms.guide_smsclub.step4': 'Incolla il token + alpha-name qui sotto e clicca "Verifica connessione".',
  'sms.guide_alphasms.step1': 'Registrati su AlphaSMS e ricarica il saldo.',
  'sms.guide_alphasms.step2': 'Ordina un alpha-name (moderazione di solito poche ore).',
  'sms.guide_alphasms.step3': 'Dashboard: Impostazioni → API → copia la chiave API.',
  'sms.guide_alphasms.step4': 'Incolla la chiave + alpha-name qui sotto e clicca "Verifica connessione".',

  // ── Email settings page ──
  'emailSet.title': 'Invio Email',
  'emailSet.subtitle': 'Configurazione invio email',
  'emailSet.gmailAddress': 'Indirizzo Gmail',
  'emailSet.gmailHint': 'Indirizzo Gmail da cui verranno inviate le email',
  'emailSet.appPassword': 'Password app',
  'emailSet.appPasswordHint': 'Password app di Google (non la password principale)',
  'emailSet.fromName': 'Nome mittente',
  'emailSet.fromNameHint': 'Nome che il destinatario vedr\u00e0',
  'emailSet.save': 'Salva',
  'emailSet.settingsSaved': 'Impostazioni salvate',
  'emailSet.sendTestEmail': 'Invia email di prova',
  'emailSet.sendingTest': 'Invio...',
  'emailSet.testing': 'Test...',
  'emailSet.testSent': 'Email di prova inviata',
  'emailSet.testSubject': 'Email di prova',
  'emailSet.testBody': 'Questa \u00e8 un\'email di prova da Systemic CRM',
  'emailSet.emailWorks': 'Email funziona',
  'emailSet.sendError': 'Errore di invio',
  'emailSet.error': 'Errore',
  'emailSet.unknown': 'Errore sconosciuto',
  'emailSet.howToGetAppPassword': 'Come ottenere la password app',
  'emailSet.important': 'Importante',
  'emailSet.importantText': 'Usa la password app, non la password principale di Gmail',
  'emailSet.step1': '1. Accedi al tuo account Google',
  'emailSet.step2': '2. Vai su Sicurezza \u2192 Verifica in due passaggi',
  'emailSet.step2direct': '2. Abilita la verifica in due passaggi',
  'emailSet.step3': '3. Vai su Password per le app',
  'emailSet.step4': '4. Crea una nuova password per le app',
  'emailSet.step5': '5. Copia la password generata',

  // ── Locations settings page ──
  'locations.title': 'Sedi',
  'locations.subtitle': 'Gestione delle sedi della tua attivit\u00e0',
  'locations.locationsLabel': 'Sedi',
  'locations.staffCount': 'Dipendenti',
  'locations.warehousesCount': 'Magazzini',
  'locations.addLocation': 'Aggiungi sede',
  'locations.tabMain': 'Generale',
  'locations.tabBooking': 'Prenotazione online',
  'locations.tabCompany': 'Dati azienda',
  'locations.photo': 'Foto della sede',
  'locations.uploadPhoto': 'Carica foto',
  'locations.changePhoto': 'Cambia foto',
  'locations.photoHint': 'Foto interni o facciata — mostrata sulla pagina di prenotazione',
  'locations.scheduleLabel': 'Orario di lavoro',
  'locations.dayOff': 'Chiuso',
  'locations.mon': 'Lun', 'locations.tue': 'Mar', 'locations.wed': 'Mer',
  'locations.thu': 'Gio', 'locations.fri': 'Ven', 'locations.sat': 'Sab', 'locations.sun': 'Dom',
  'locations.workingHoursLabel': 'Orario di lavoro',
  'locations.workingHoursPlaceholder': 'Lun-Ven 9:00-18:00, Sab 10:00-15:00',
  'locations.hasLinkedData': 'Impossibile eliminare — la sede ha personale o magazzini collegati.',
  'locations.limitReached': 'Limite sedi raggiunto. Aggiorna il tuo piano.',
  'locations.newLocation': 'Nuova sede',
  'locations.editLocation': 'Modifica sede',
  'locations.nameLabel': 'Nome',
  'locations.namePlaceholder': 'Inserisci il nome...',
  'locations.nameDuplicate': 'Una sede con questo nome esiste già',
  'locations.addressLabel': 'Indirizzo',
  'locations.addressPlaceholder': 'Via Roma 1',
  'locations.cityLabel': 'Città',
  'locations.cityPlaceholder': 'Roma',
  'locations.phoneLabel': 'Telefono',
  'locations.colorLabel': 'Colore',
  'locations.save': 'Salva',
  'locations.cancel': 'Annulla',
  'locations.add': 'Aggiungi',
  'locations.edit': 'Modifica',
  'locations.delete': 'Elimina',
  'locations.cannotDelete': 'Impossibile eliminare',
  'locations.ordersCount': 'Ordini',
  'locations.needAtLeastOne': 'Serve almeno una sede',
  'locations.added': 'Sede aggiunta',
  'locations.updated': 'Sede aggiornata',
  'locations.deleted': 'Sede eliminata',
  'locations.deleteTitle': 'Elimina sede',
  'locations.deleteMessage': 'Sei sicuro? Questa azione non può essere annullata.',
  'locations.companyDetailsHint': 'Dati aziendali (per fatture e documenti)',
  'locations.officialNameLabel': 'Ragione sociale',
  'locations.officialNamePlaceholder': 'SRL "Nome" / Ditta individuale',
  'locations.edrpouLabel': 'P.IVA / Cod. Fiscale',
  'locations.edrpouShort': 'P.IVA',
  'locations.bankAccountLabel': 'Conto bancario (IBAN)',
  'locations.bankNameLabel': 'Nome banca',
  'locations.bankNamePlaceholder': 'Nome della banca',

  // ── Users page ──
  'users.title': 'Utenti',
  'users.subtitle': 'Gestione utenti del sistema',
  'users.usersCount': 'Utenti',
  'users.addUser': 'Aggiungi utente',
  'users.limitReached': 'Limite utenti raggiunto. Aggiorna il tuo piano.',
  'users.newUser': 'Nuovo utente',
  'users.editUser': 'Modifica utente',
  'users.noUsers': 'Nessun utente ancora',
  'users.thName': 'Nome',
  'users.thEmail': 'Email',
  'users.thRole': 'Ruolo',
  'users.thStaff': 'Dipendente',
  'users.thActions': 'Azioni',
  'users.nameLabel': 'Nome',
  'users.namePlaceholder': 'Inserisci il nome...',
  'users.emailLabel': 'Email',
  'users.passwordLabel': 'Password',
  'users.passwordPlaceholder': 'Almeno 6 caratteri',
  'users.passwordMin': 'La password deve avere almeno 6 caratteri',
  'users.roleLabel': 'Ruolo',
  'users.selectRole': 'Seleziona ruolo',
  'users.selectRoleOption': '\u2014 Seleziona ruolo \u2014',
  'users.showPassword': 'Mostra password',
  'users.hidePassword': 'Nascondi password',
  'users.enterName': 'Inserisci il nome',
  'users.enterEmail': 'Inserisci email',
  'users.emailAlreadyUsed': 'Questa email \u00e8 gi\u00e0 in uso',
  'users.error': 'Errore',
  'users.edit': 'Modifica',
  'users.delete': 'Elimina',
  'users.confirmDelete': 'Sei sicuro di voler eliminare questo utente?',
  'users.yes': 'S\u00ec',
  'users.no': 'No',
  'users.staffBinding': 'Associazione al dipendente',
  'users.noStaffBinding': '— Nessuna —',
  'users.noPosition': 'senza posizione',
  'users.staffBindingHint': 'Link user to employee for salary calculation and work schedule',
  'users.viewScope': 'Data visibility',
  'users.viewScopeAll': 'Show all records and orders',
  'users.viewScopeOwn': 'Show only own',
  'users.viewScopeHint': '"Own only" — user will see only their appointments, orders and sales',
  'users.createWarning': 'Attenzione: dopo la creazione dell\'utente potresti essere disconnesso. Effettua nuovamente l\'accesso.',

  // ── Ruoli ──
  'roles.title': 'Ruoli',
  'roles.subtitle': 'Gestione dei ruoli e dei permessi di accesso',
  'roles.rolesCount': 'Ruoli',
  'roles.addRole': 'Aggiungi ruolo',
  'roles.noRoles': 'Nessun ruolo ancora.',
  'roles.systemBadge': 'Di sistema',
  'roles.permsOf': 'permessi',
  'roles.newRole': 'Nuovo ruolo',
  'roles.editRole': 'Modifica ruolo',
  'roles.roleName': 'Nome del ruolo',
  'roles.roleNamePlaceholder': 'Ad esempio: Amministratore, Manager, Professionista',
  'roles.nameDuplicate': 'Un ruolo con questo nome esiste già',
  'roles.permissions': 'Permessi di accesso',
  'roles.confirmDelete': 'Eliminare?',
  'roles.cannotDelete': 'Impossibile eliminare il ruolo',
  'roles.usersAssigned': 'utenti con questo ruolo',
  'roles.groupClients': 'Clienti',
  'roles.groupStaff': 'Personale',
  'roles.groupCalendar': 'Calendario',
  'roles.groupSales': 'Vendite',
  'roles.groupInventory': 'Magazzino',
  'roles.groupLoyalty': 'Fedeltà',
  'roles.groupSalary': 'Stipendi',
  'roles.groupFinances': 'Finanze e analisi',
  'roles.groupCommunication': 'Comunicazioni',
  'roles.groupSettings': 'Impostazioni',
  'roles.groupSystem': 'Sistema',
  'roles.permClientsView': 'Visualizza clienti',
  'roles.permClientsEdit': 'Modifica clienti',
  'roles.permClientsDelete': 'Elimina clienti',
  'roles.permClientsCategories': 'Categorie clienti',
  'roles.permClientsDocuments': 'Documenti clienti',
  'roles.permStaffView': 'Visualizza personale',
  'roles.permStaffEdit': 'Modifica personale',
  'roles.permScheduleView': 'Orario di lavoro',
  'roles.permScheduleEdit': 'Modelli di orario',
  'roles.permServicesView': 'Visualizza servizi',
  'roles.permServicesEdit': 'Modifica servizi',
  'roles.permCalendarView': 'Visualizza calendario',
  'roles.permCalendarCreate': 'Crea appuntamenti',
  'roles.permCalendarEdit': 'Modifica appuntamenti',
  'roles.permPosSell': 'Negozio (POS)',
  'roles.permOrdersView': 'Ordini (visualizza)',
  'roles.permOrdersCreate': 'Ordini (crea)',
  'roles.permOrdersEdit': 'Ordini (modifica)',
  'roles.permInvView': 'Prodotti e scorte',
  'roles.permInvPurchases': 'Acquisti',
  'roles.permInvMovements': 'Movimenti di magazzino',
  'roles.permProductionView': 'Visualizza produzione',
  'roles.permProductionCreate': 'Crea produzione',
  'roles.permLoyaltyView': 'Visualizza programmi fedeltà',
  'roles.permLoyaltyEdit': 'Modifica programmi fedeltà',
  'roles.permSalaryView': 'Calcolo stipendi',
  'roles.permSalaryEdit': 'Schemi di motivazione',
  'roles.permFinancesView': 'Visualizza finanze',
  'roles.permCashRegister': 'Cassa (Checkbox)',
  'roles.permReportsView': 'Report',
  'roles.permFinancialResult': 'Risultato finanziario',
  'roles.permBusinessMonitor': 'Monitor aziendale',
  'roles.permCommunicationView': 'Messaggi',
  'roles.permCommSettingsEdit': 'Impostazioni comunicazioni',
  'roles.permSettingsLocations': 'Sedi',
  'roles.permSettingsBooking': 'Prenotazioni online',
  'roles.permSettingsIntegrations': 'Integrazioni',
  'roles.permSettingsTariffs': 'Piani tariffari',
  'roles.permManageUsers': 'Utenti',
  'roles.permManageRoles': 'Ruoli',
  'roles.permAuditLog': 'Log di audit',

  // ── Comunicazione ──
  'comm.title': 'Comunicazione',
  'comm.subtitle': 'Messaggi e contatti con i clienti',
  'comm.searchPlaceholder': 'Cerca cliente...',
  'comm.allClients': 'Tutti i clienti',
  'comm.nothingFound': 'Nessun risultato',
  'comm.noConnectedClients': 'Nessun cliente connesso',
  'comm.you': 'Tu: ',
  'comm.noMessages': 'Nessun messaggio',
  'comm.noHistory': 'Nessuna cronologia',
  'comm.selectChat': 'Seleziona una chat',
  'comm.selectChatHint': 'Seleziona un cliente a sinistra per iniziare la comunicazione',
  'comm.telegramNotConnected': 'Telegram non connesso',
  'comm.smsNotConfigured': 'Gateway SMS non configurato',
  'comm.clientNoPhone': 'Il cliente non ha un numero di telefono',
  'comm.noPhone': 'Nessun telefono',
  'comm.emailNotConfigured': 'Email non configurata',
  'comm.clientNoEmail': 'Il cliente non ha un indirizzo email',
  'comm.noEmail': 'Nessuna email',
  'comm.defaultSubject': 'Messaggio',
  'comm.emailSent': 'Email inviata',
  'comm.smsSent': 'SMS inviato',
  'comm.messageSent': 'Messaggio inviato',
  'comm.error': 'Errore: ',
  'comm.linkCopied': 'Link copiato',
  'comm.yesterday': 'Ieri',
  'comm.clientNoTelegram': 'Il cliente non ha ancora connesso Telegram',
  'comm.sendBotLink': 'Invia questo link al cliente:',
  'comm.copy': 'Copia',
  'comm.sendSmsInstead': 'Invia SMS invece',
  'comm.botNotConfigured': 'Bot Telegram non configurato',
  'comm.configureTelegram': 'Configura in Sistema → Promemoria Telegram',
  'comm.configureSms': 'Configura in Sistema → Invio SMS',
  'comm.addPhoneToCard': 'Aggiungi il numero di telefono alla scheda cliente',
  'comm.configureEmail': 'Configura in Sistema → Invio Email',
  'comm.addEmailToCard': 'Aggiungi l\'email alla scheda cliente',
  'comm.noMessagesYet': 'Nessun messaggio ancora. Scrivi per primo!',
  'comm.openAttachment': 'Apri allegato',
  'comm.attachHintWeb': 'La conversazione passerà alla scheda cliente con la cronologia; anche i prossimi messaggi di questa chat finiranno sulla scheda.',
  'comm.createCardFromVisitor': 'Crea scheda dai dati del visitatore',
  'comm.cardCreated': 'Scheda creata',
  'comm.showOlder': 'Mostra precedenti',
  'comm.emailSubjectPlaceholder': 'Oggetto dell\'email...',
  'comm.emailPlaceholder': 'Testo dell\'email...',
  'comm.smsPlaceholder': 'Scrivi un SMS...',
  'comm.sendingVia': 'Canale attuale: {channel}',
  'comm.messagePlaceholder': 'Scrivi un messaggio...',
  'comm.sendEnter': 'Invia (Invio)',

  // ── Orders ──
  'orders.title': 'Ordini',
  'orders.subtitle': 'Vendita prodotti',
  'orders.statTotal': 'Totale',
  'orders.statusNew': 'Nuovi',
  'orders.statusPaid': 'Pagati',
  'orders.searchPlaceholder': 'Cerca per cliente o prodotto...',
  'orders.filterAll': 'Tutti',
  'orders.status_new': 'Nuovo',
  'orders.status_confirmed': 'Confermato',
  'orders.status_packed': 'Imballato',
  'orders.status_shipped': 'Spedito',
  'orders.status_delivered': 'Ricevuto',
  'orders.status_cancelled': 'Annullato',
  'orders.periodAll': 'Tutti',
  'orders.periodWeek': 'Settimana',
  'orders.periodMonth': 'Mese',
  'orders.periodYear': 'Anno',
  'orders.periodCustom': 'Personalizzato',
  'orders.newOrder': 'Nuovo ordine',
  'orders.editOrder': 'Modifica ordine',
  'orders.emptyTitle': 'Nessun ordine',
  'orders.emptyHint': 'Crea il tuo primo ordine di vendita prodotti',
  'orders.pos': 'pos.',
  'orders.discount': 'Sconto',
  'orders.total': 'Totale',
  'orders.pay_unpaid': 'Non pagato',
  'orders.pay_partial': 'Parziale',
  'orders.pay_paid': 'Pagato',
  'orders.pay_refunded': 'Rimborsato',
  'orders.refund': 'Rimborsa',
  'orders.refunded': 'Pagamento rimborsato',
  'orders.refundTitle': 'Rimborso',
  'orders.refundMessage': 'Rimborsare {amount} ₴ al cliente?',
  'orders.refundWarning': 'Verrà creata una transazione di rimborso',
  'orders.refundDescription': 'Rimborso ordine',
  'orders.confirmRefund': 'Conferma rimborso',
  'orders.refundAmountLabel': 'Importo del rimborso',
  'orders.paidOf': 'Pagato {paid} di {total} ₴',
  'orders.payRemaining': 'Paga il resto',
  'orders.payAmountLabel': 'Importo del pagamento',
  'orders.fullAmount': 'importo totale',
  'orders.returnProducts': 'Restituire prodotti',
  'orders.returnTitle': 'Reso prodotti',
  'orders.returnHint': 'Indica le quantità da restituire a magazzino',
  'orders.confirmReturn': 'Conferma reso',
  'orders.returnFrom': 'Reso da ordine',
  'orders.fullyReturned': 'Prodotti restituiti',
  'orders.partiallyReturned': 'Reso parziale',
  'orders.action_confirmed': 'Conferma',
  'orders.action_packed': 'Imballa',
  'orders.action_shipped': 'Spedisci',
  'orders.action_delivered': 'Ricevuto',
  'orders.action_cancelled': 'Annulla',
  'orders.markPaid': 'Segna pagato',
  'orders.payBtn': 'Paga',
  'orders.cashGiven': 'Il cliente ha dato',
  'orders.change': 'Resto',
  'orders.notEnough': 'Non sufficiente',
  'orders.confirmPayment': 'Conferma pagamento',
  'orders.back': 'Indietro',
  'orders.edit': 'Modifica',
  'orders.errCustomerName': 'Inserisci il nome del cliente',
  'orders.errItems': 'Aggiungi almeno un prodotto',
  'orders.errWarehouse': 'Seleziona un magazzino',
  'orders.errStockInsufficient': 'Scorte insufficienti',
  'orders.errNegPrice': 'Il prezzo non può essere negativo',
  'orders.errQuantity': 'Indica la quantità per i prodotti selezionati',
  'orders.inStock': 'Disponibile',
  'orders.available': 'disponibile',
  'orders.needed': 'necessario',
  'orders.paymentDescription': 'Vendita prodotti',
  'orders.sectionCustomer': 'Cliente',
  'orders.sectionProducts': 'Prodotti',
  'orders.sectionPayment': 'Pagamento',
  'orders.labelName': 'Nome',
  'orders.namePlaceholder': 'Nome del cliente',
  'orders.labelPhone': 'Telefono',
  'orders.labelTariff': 'Piano tariffario',
  'orders.standardPrice': 'Prezzo standard',
  'orders.labelEmail': 'Email',
  'orders.labelWarehouse': 'Magazzino',
  'orders.selectWarehouse': 'Seleziona un magazzino',
  'orders.labelPaymentMethod': 'Metodo di pagamento',
  'orders.pm_cash': 'Contanti',
  'orders.pm_terminal': 'Terminale',
  'orders.pm_transfer': 'Bonifico',
  'orders.pm_online': 'Online',
  'orders.selectProduct': 'Seleziona un prodotto',
  'orders.qty': 'Quantità',
  'orders.price': 'Prezzo',
  'orders.addItem': 'Aggiungi prodotto',
  'orders.colProduct': 'Prodotto',
  'orders.colWarehouse': 'Magazzino',
  'orders.colQty': 'Qtà',
  'orders.colPrice': 'Prezzo',
  'orders.colDiscount': 'Sconto',
  'orders.colSum': 'Totale',
  'orders.labelDiscount': 'Sconto (₴)',
  'orders.labelNote': 'Nota',
  'orders.notePlaceholder': 'Commento ordine...',
  'orders.cancel': 'Annulla',
  'orders.save': 'Salva',
  'orders.saving': 'Salvataggio…',
  'orders.searchProduct': 'Cerca prodotto...',
  'orders.noProducts': 'Nessun prodotto trovato',
  'orders.changeProduct': 'Cambia prodotto',
  'orders.noWarehouse': 'Nessun magazzino con scorte',
  'orders.noCategory': 'Senza categoria',
  'orders.printInvoice': 'Fattura',
  'orders.printBill': 'Preventivo',
  'orders.sectionShipping': 'Spedizione',
  'orders.labelShippingMethod': 'Metodo di spedizione',
  'orders.labelShippingAddress': 'Indirizzo di consegna',
  'orders.shippingNone': 'Senza spedizione (ritiro)',
  'orders.shippingNP': 'Nova Poshta',
  'orders.shippingPickup': 'Ritiro',
  'orders.shippingCourier': 'Corriere',
  'orders.shippingOther': 'Altro',
  'orders.shipping_novaposhta': 'Nova Poshta',
  'orders.shipping_pickup': 'Ritiro',
  'orders.shipping_courier': 'Corriere',
  'orders.shipping_other': 'Altra spedizione',
  'orders.npCity': 'Città',
  'orders.npCityPlaceholder': 'Inserisci il nome della città...',
  'orders.npWarehouse': 'Filiale / Punto di ritiro',
  'orders.npWarehousePlaceholder': 'Cerca filiale...',
  'orders.npTTN': 'Numero di tracciamento',
  'orders.npTTNPlaceholder': 'Numero lettera di vettura',
  'orders.npTrack': 'Traccia',
  'orders.npStatus': 'Stato',
  'orders.npFrom': 'Da',
  'orders.npTo': 'A',
  'orders.npDeliveryTo': 'Consegna',
  'orders.npDeliveryDate': 'Data di consegna',
  'orders.npTTNOnlyPacked': 'Il TTN può essere creato solo dallo stato «Imballato»',
  'orders.npSyncTracking': 'Sincronizza tracciamento',
  'orders.npSyncing': 'Sincronizzazione...',
  'orders.npAutoSyncActive': 'Lo stato verrà aggiornato automaticamente tramite Nova Poshta',
  'orders.meestAutoSyncActive': 'Lo stato verrà aggiornato automaticamente tramite Meest Express',
  'orders.meestAll': 'Tutti',
  'orders.meestOffice': 'Uffici',
  'orders.meestParcelLocker': 'Locker pacchi',
  'orders.npCodConfirmTitle': 'Creare lettera di vettura Nova Poshta',
  'orders.meestCodConfirmTitle': 'Creare spedizione Meest',
  'orders.codChoiceMessage': 'L\'ordine non è pagato. È possibile creare la spedizione in Contrassegno.',
  'orders.codWithCod': 'Sì, con Contrassegno',
  'orders.codWithoutCod': 'No, senza Contrassegno',
  'orders.codCancel': 'Annulla creazione spedizione',
  'orders.addressPlaceholder': 'Indirizzo di consegna...',
  'orders.courierAddressPlaceholder': 'Indirizzo per il corriere...',
  'orders.npSettingsRequired': 'Prima configura Nova Poshta in Sistema → Nova Poshta',
  'orders.npResaveSettings': 'Risalva le impostazioni Nova Poshta (Sistema → Nova Poshta → Salva) per aggiornare i dati del mittente.',
  'orders.npMissingFields': 'Dati mancanti per la creazione della lettera di vettura. Vai a Sistema → Nova Poshta e risalva. Campi mancanti',
  'orders.npAddressRequired': 'Indica città e filiale NP nell\'ordine',
  'orders.npRecipientRequired': 'Inserisci nome e telefono del destinatario',
  'orders.npCreateTTN': 'Crea lettera di vettura',
  'orders.npTTNCreated': 'Lettera di vettura creata',
  'orders.npTTNError': 'Errore creazione',
  'orders.npPrintSticker': 'Stampa etichetta',
  'orders.npDeliveryPriceLabel': 'Costo di spedizione stimato',
  'orders.npUAH': 'UAH',
  'orders.npCalcPrice': 'Calcolo del costo',
  'orders.author': 'Autore',
  'invoice.title': 'Bolla di consegna',
  'invoice.date': 'Data',
  'invoice.status': 'Stato',
  'invoice.customer': 'Cliente',
  'invoice.note': 'Nota',
  'invoice.items': 'Articoli',
  'invoice.product': 'Prodotto',
  'invoice.unit': 'Unità',
  'invoice.qty': 'Qtà',
  'invoice.price': 'Prezzo',
  'invoice.discountCol': 'Sconto',
  'invoice.sum': 'Importo',
  'invoice.discount': 'Sconto',
  'invoice.total': 'Totale',
  'invoice.paid': 'Pagato',
  'invoice.remaining': 'Rimanente',
  'invoice.seller': 'Venditore',
  'invoice.bankAccount': 'Conto',
  'invoice.sellerSign': 'Firma venditore',
  'invoice.buyerSign': 'Firma acquirente',
  'invoice.pcs': 'pz',

  // ── Bill ──
  'bill.title': 'Preventivo',
  'bill.amountDue': 'Importo dovuto',
  'bill.payTo': 'Coordinate di pagamento',
  'bill.service': 'servizio',
  'bill.itemName': 'Descrizione',

  // ── Services: default materials ──
  'services.materials': 'Materiali',
  'services.hasMaterials': 'Ha materiali predefiniti',
  'services.defaultMaterials': 'Materiali predefiniti',
  'services.defaultMaterialsHint': 'Questi materiali verranno aggiunti automaticamente selezionando questo servizio',
  'services.addMaterial': 'Aggiungi materiale',
  'services.noProductsAvailable': 'Nessun prodotto disponibile',

  'nav.production': 'Produzione',

  'production.title': 'Produzione',
  'production.subtitle': 'Specifiche e produzione',
  'production.recipesCount': 'Specifiche',
  'production.operationsCount': 'Operazioni',
  'production.tab_recipes': 'Specifiche',
  'production.tab_produce': 'Produrre',
  'production.tab_history': 'Cronologia',
  'production.newRecipe': 'Nuova specifica',
  'production.newProduction': 'Nuova operazione',
  'production.searchRecipes': 'Cerca specifiche...',
  'production.searchHistory': 'Cerca nella cronologia...',
  'production.noRecipes': 'Nessuna specifica ancora',
  'production.noRecipesHint': 'Crea una specifica per produrre prodotti dalle materie prime',
  'production.createRecipeFirst': 'Prima crea una specifica nella scheda "Specifiche"',
  'production.noHistory': 'La cronologia di produzione è vuota',
  'production.output': 'Uscita',
  'production.inputs': 'Ingressi',
  'production.produce': 'Produrre',
  'production.edit': 'Modifica',
  'production.delete': 'Elimina',
  'production.stockOk': 'Disponibile',
  'production.stockLow': 'Insufficiente',
  'production.inputCost': 'Costo materie prime',
  'production.unitCost': 'Costo unitario',
  'production.uah': 'UAH',
  'production.warehouse': 'Magazzino',
  'production.recipeName': 'Nome specifica',
  'production.recipeNamePlaceholder': 'Es. "Crema mani 100ml"',
  'production.selectWarehouse': 'Seleziona magazzino',
  'production.noInputsYet': 'Aggiungi materie prime alla specifica',
  'production.outputSection': 'Prodotto finito',
  'production.outputProduct': 'Prodotto in uscita',
  'production.selectProduct': 'Seleziona prodotto',
  'production.outputQty': 'Quantità',
  'production.inputsSection': 'Materie prime',
  'production.addInput': 'Aggiungi ingresso',
  'production.searchProduct': 'Cerca prodotto...',
  'production.qty': 'Qtà',
  'production.cancel': 'Annulla',
  'production.save': 'Salva',
  'production.create': 'Crea',
  'production.editRecipe': 'Modifica specifica',
  'production.recipeCreated': 'Specifica creata',
  'production.recipeUpdated': 'Specifica aggiornata',
  'production.recipeDeleted': 'Specifica eliminata',
  'production.cannotDeleteRecipe': 'Impossibile eliminare — usata in produzione',
  'production.executeProduction': 'Esegui produzione',
  'production.selectRecipeLabel': 'Specifica',
  'production.selectRecipe': 'Seleziona specifica',
  'production.multiplier': 'Moltiplicatore (lotti)',
  'production.preview': 'Anteprima',
  'production.willConsume': 'Verrà consumato',
  'production.willProduce': 'Verrà prodotto',
  'production.need': 'necessario',
  'production.available': 'disponibile',
  'production.note': 'Nota',
  'production.notePlaceholder': 'Commento sull\'operazione',
  'production.executeProduce': 'Produrre',
  'production.produced': 'Prodotto: {qty} × {name}',
  'production.errNameRequired': 'Nome specifica obbligatorio',
  'production.errOutputRequired': 'Seleziona il prodotto in uscita',
  'production.errInputsRequired': 'Aggiungi almeno una materia prima',
  'production.errOutputInInputs': 'Il prodotto in uscita non può essere tra gli ingressi',
  'production.errSelectRecipe': 'Seleziona una specifica',
  'production.errSelectWarehouse': 'Seleziona un magazzino',
  'production.errMultiplier': 'Il moltiplicatore deve essere >= 1',
  'production.cancelTitle': 'Annullare la produzione',
  'production.cancelMessage': 'Annullare la produzione "{name}" ×{qty}?',
  'production.cancelDescription': 'Il prodotto finito verrà detratto dal magazzino, le materie prime saranno restituite',
  'production.cancelWarning': 'Questa azione non può essere annullata',
  'production.confirmCancel': 'Conferma annullamento',
  'production.cancelledLabel': 'Annullato',
  'production.cancelBtn': 'Annulla',
  'production.alreadyCancelled': 'Questa produzione è già stata annullata',
  'production.cancelNotEnoughStock': 'Impossibile annullare — solo {available} di {needed} unità rimaste in magazzino. Il prodotto è già stato spedito.',
  'production.cancelNote': 'Annullamento produzione',
  'production.cancelledSuccess': 'Produzione annullata',

  'invMov.typeProductionOut': 'Produzione (consumato)',
  'invMov.typeProductionIn': 'Produzione (uscita)',
  'invMov.filterProduction': 'Produzione',

  // ── Navigation: audit log ──
  'nav.auditLog': 'Registro di audit',

  // ── Audit Log ──
  'auditLog.title': 'Registro di audit',
  'auditLog.dateTime': 'Data e ora',
  'auditLog.user': 'Utente',
  'auditLog.action': 'Azione',
  'auditLog.collection': 'Sezione',
  'auditLog.documentId': 'ID documento',
  'auditLog.document': 'Documento',
  'auditLog.details': 'Dettagli',
  'auditLog.actionCreate': 'Creazione',
  'auditLog.actionUpdate': 'Modifica',
  'auditLog.actionDelete': 'Eliminazione',
  'auditLog.filterCollection': 'Sezione',
  'auditLog.filterAction': 'Azione',
  'auditLog.filterFrom': 'Da',
  'auditLog.filterTo': 'A',
  'auditLog.allCollections': 'Tutte le sezioni',
  'auditLog.allActions': 'Tutte le azioni',
  'auditLog.noEntries': 'Nessuna voce trovata',
  'auditLog.loadMore': 'Carica altro',
  'auditLog.changes': 'Modifiche',
  'auditLog.field': 'Campo',
  'auditLog.oldValue': 'Prima',
  'auditLog.newValue': 'Dopo',
  'auditLog.deletedData': 'Dati eliminati',
  'auditLog.newRecord': 'Nuovo record creato',
  'auditLog.fieldsChanged': 'campi modificati',
  'auditLog.colCustomers': 'Clienti',
  'auditLog.colStaff': 'Personale',
  'auditLog.colAppointments': 'Appuntamenti',
  'auditLog.colTransactions': 'Transazioni',
  'auditLog.colOrders': 'Ordini',
  'auditLog.colProducts': 'Prodotti',
  'auditLog.colStock': 'Scorte',
  'auditLog.colStockMovements': 'Movimenti di magazzino',
  'auditLog.colServices': 'Servizi',
  'auditLog.colCategories': 'Categorie',
  'auditLog.colLocations': 'Sedi',
  'auditLog.colRoles': 'Ruoli',
  'auditLog.colUsers': 'Utenti',
  'auditLog.colSalaryHistory': 'Storico stipendi',
  'auditLog.colSalarySchemes': 'Schemi retributivi',
  'auditLog.colFixedExpenses': 'Spese fisse',
  'auditLog.colWarehouses': 'Magazzini',
  'auditLog.colScheduleTemplates': 'Modelli di orario',
  'auditLog.colCashShifts': 'Turni di cassa',
  'auditLog.colProductions': 'Produzione',
  'auditLog.colTechCards': 'Schede tecniche',

  // ── Loyalty (4 modules) ──
  'nav.loyalty': 'Programmi fedeltà',
  'loyalty.title': 'Programmi fedeltà',
  'loyalty.subtitle': 'Punti, livelli, codici promo e abbonamenti',
  'custModal.tabLoyalty': 'Fedeltà',
  'loyalty.tabPoints': 'Punti',
  'loyalty.tabTiers': 'Livelli',
  'loyalty.tabCoupons': 'Codici Promo',
  'loyalty.tabSubscriptions': 'Abbonamenti',
  'loyalty.tabSettings': 'Impostazioni',
  'loyalty.tabBalances': 'Saldi',
  'loyalty.tabHistory': 'Cronologia',
  'loyalty.tabTierOverview': 'Panoramica clienti',
  'loyalty.tabPlans': 'Piani',
  'loyalty.tabPlansSettings': 'Impostazioni piani',
  'loyalty.tabActiveSubs': 'Abbonamenti attivi',
  'loyalty.statMembers': 'membri',
  'loyalty.statPoints': 'punti attivi',
  'loyalty.saveSettings': 'Salva impostazioni',
  'loyalty.saved': 'Impostazioni salvate',
  'loyalty.searchCustomer': 'Cerca cliente...',
  'loyalty.days': 'giorni',
  'loyalty.pts': 'punti',
  'loyalty.cancel': 'Annulla',
  'loyalty.colCustomer': 'Cliente',
  'loyalty.colTier': 'Livello',
  'loyalty.colBalance': 'Saldo',
  'loyalty.colTotalEarned': 'Accumulati',
  'loyalty.colTotalRedeemed': 'Riscattati',
  'loyalty.colTotalSpent': 'Totale speso',
  'loyalty.colDate': 'Data',
  'loyalty.colType': 'Tipo',
  'loyalty.colPoints': 'Punti',
  'loyalty.colNote': 'Nota',
  'loyalty.colStatus': 'Stato',
  'loyalty.enablePoints': 'Attiva programma punti',
  'loyalty.pointsDisabled': 'Programma punti disattivato',
  'loyalty.sectionEarning': 'Accumulo punti',
  'loyalty.currencyPerPoint': 'Importo per punto',
  'loyalty.currencyPerPointHint': 'Quanto spendere per ottenere punti',
  'loyalty.pointsPerUnit': 'Punti per unità',
  'loyalty.sectionRedemption': 'Riscatto punti',
  'loyalty.pointValue': 'Valore del punto',
  'loyalty.maxRedeemPercent': 'Max. % pagamento con punti',
  'loyalty.sectionAutoBonuses': 'Bonus automatici',
  'loyalty.birthdayBonus': 'Bonus compleanno',
  'loyalty.referralBonus': 'Bonus referral',
  'loyalty.inactivityDays': 'Giorni di inattività',
  'loyalty.inactivityBonus': 'Bonus di ritorno',
  'loyalty.noBalances': 'Nessun membro ancora',
  'loyalty.noBalancesHint': 'I punti verranno accumulati automaticamente al pagamento',
  'loyalty.noHistory': 'Cronologia vuota',
  'loyalty.txEarn': 'Accumulo',
  'loyalty.txRedeem': 'Riscatto',
  'loyalty.txBirthday': 'Compleanno',
  'loyalty.txReferral': 'Referral',
  'loyalty.txInactivity': 'Ritorno',
  'loyalty.txManual': 'Manuale',
  'loyalty.sectionPoints': 'Punti',
  'loyalty.pointsBalance': 'punti',
  'loyalty.earned': 'accumulati',
  'loyalty.redeemed': 'riscattati',
  'loyalty.manualPlaceholder': '±punti',
  'loyalty.manualApply': 'Applica',
  'loyalty.manualAdd': 'Credito manuale',
  'loyalty.manualDeduct': 'Debito manuale',
  'loyalty.history': 'Cronologia punti',
  'loyalty.noTransactions': 'Nessuna operazione ancora',
  'loyalty.enableTiers': 'Attiva programma livelli',
  'loyalty.tiersDisabled': 'Programma livelli disattivato',
  'loyalty.tierPeriod': 'Periodo di calcolo',
  'loyalty.periodAllTime': 'Tutto il tempo',
  'loyalty.periodMonths': 'Ultimi {n} mesi',
  'loyalty.tierPeriodHint': 'Periodo per calcolare le spese e determinare il livello',
  'loyalty.sectionTiers': 'Livelli clienti',
  'loyalty.tiersHint': 'Lo sconto è determinato automaticamente dalla spesa totale del cliente',
  'loyalty.tierName': 'Nome',
  'loyalty.tierMinSpent': 'Spesa min.',
  'loyalty.tierDiscount': 'Sconto',
  'loyalty.tierLoadingBtn': 'Calcolo sconto',
  'loyalty.tierLoadingHint': 'Calcolo dello sconto per livello…',
  'loyalty.addTier': 'Aggiungi livello',
  'loyalty.noTierCustomers': 'Nessun cliente con spese ancora',
  'loyalty.sectionTierStatus': 'Livello del cliente',
  'loyalty.tierDiscountLabel': 'Sconto del livello',
  'loyalty.nextTier': 'Livello successivo',
  'loyalty.enableCoupons': 'Attiva codici promo',
  'loyalty.couponsDisabled': 'Codici promo disattivati',
  'loyalty.searchCoupon': 'Cerca codice promo...',
  'loyalty.addCoupon': 'Crea codice promo',
  'loyalty.newCoupon': 'Nuovo codice promo',
  'loyalty.editCoupon': 'Modifica codice promo',
  'loyalty.saveCoupon': 'Salva codice promo',
  'loyalty.couponCode': 'Codice',
  'loyalty.couponType': 'Tipo di sconto',
  'loyalty.couponPercent': 'Percentuale',
  'loyalty.couponFixed': 'Importo fisso',
  'loyalty.couponValue': 'Valore dello sconto',
  'loyalty.couponMinOrder': 'Ordine minimo',
  'loyalty.couponMaxUses': 'Usi massimi',
  'loyalty.couponMaxUsesHint': '0 = illimitato',
  'loyalty.couponExpiry': 'Valido fino al',
  'loyalty.couponUsed': 'Usato',
  'loyalty.generateCode': 'Genera',
  'loyalty.noCoupons': 'Nessun codice promo ancora',
  'loyalty.statusActive': 'Attivo',
  'loyalty.statusInactive': 'Inattivo',
  'loyalty.statusExpired': 'Scaduto',
  'loyalty.statusMaxed': 'Esaurito',
  'loyalty.enableSubscriptions': 'Attiva abbonamenti',
  'loyalty.subscriptionsDisabled': 'Abbonamenti disattivati',
  'loyalty.disableConfirmTitle': 'Disattivare il programma?',
  'loyalty.disableConfirmMessage': 'Sei sicuro di voler disattivare questo programma fedeltà? Smetterà di funzionare per i clienti.',
  'loyalty.disableConfirm': 'Disattivare',
  'loyalty.addPlan': 'Crea piano',
  'loyalty.newPlan': 'Nuovo piano',
  'loyalty.editPlan': 'Modifica piano',
  'loyalty.savePlan': 'Salva piano',
  'loyalty.planName': 'Nome del piano',
  'loyalty.planType': 'Tipo',
  'loyalty.planTypeVisits': 'Per visite',
  'loyalty.planTypeTime': 'Per durata',
  'loyalty.planTotalVisits': 'Visite totali',
  'loyalty.planValidDays': 'Periodo di validità',
  'loyalty.planPrice': 'Prezzo',
  'loyalty.planServices': 'Servizi',
  'loyalty.planServicesHint': 'Seleziona servizi o lascia vuoto per tutti',
  'loyalty.allServices': 'Tutti i servizi',
  'loyalty.noPlans': 'Nessun piano ancora',
  'loyalty.visits': 'visite',
  'loyalty.noActiveSubs': 'Nessun abbonamento attivo ancora',
  'loyalty.subVisits': 'Visite',
  'loyalty.subExpires': 'Scade',
  'loyalty.consumedVisitsTitle': 'Visite usate',
  'loyalty.noConsumedVisits': 'Nessuna visita usata',
  'loyalty.subStatus_active': 'Attivo',
  'loyalty.subStatus_expired': 'Scaduto',
  'loyalty.subStatus_used_up': 'Esaurito',
  'loyalty.sectionSubscriptions': 'Abbonamenti',
  'loyalty.sellSubscription': 'Vendere abbonamento',
  'loyalty.sellSubTitle': 'Vendita abbonamento',
  'loyalty.selectCustomer': 'Seleziona cliente',
  'loyalty.selectPlan': 'Seleziona piano',
  'loyalty.confirmSell': 'Conferma',
  'loyalty.toPayment': 'Vai al pagamento',
  'loyalty.paymentTitle': 'Pagamento abbonamento',
  'loyalty.subSold': 'Abbonamento venduto con successo',
  'loyalty.refund': 'Rimborso',
  'loyalty.refundConfirm': 'Rimborsare l\'abbonamento "{name}"? Sarà disattivato.',
  'loyalty.subRefunded': 'Rimborsato, abbonamento disattivato',
  'loyalty.subStatus_refunded': 'Rimborsato',
  'loyalty.subPurchased': 'Acquistato',
  'loyalty.subPrice': 'Prezzo',
  'loyalty.noActiveModules': 'Nessun programma fedeltà attivo',

  // ── Loyalty integration (checkout) ──
  'loyalty.usePoints': 'Usa punti',
  'loyalty.balance': 'Saldo',
  'loyalty.max': 'Max.',
  'loyalty.apply': 'Applica',
  'loyalty.enterCoupon': 'Inserisci codice promo',
  'loyalty.couponNotFound': 'Codice promo non trovato',
  'loyalty.couponInvalid': 'Codice promo non valido',
  'loyalty.couponErr_not_found': 'Codice promo non trovato',
  'loyalty.couponErr_inactive': 'Codice promo inattivo',
  'loyalty.couponErr_expired': 'Codice promo scaduto',
  'loyalty.couponErr_maxed': 'Codice promo esaurito',
  'loyalty.couponErr_min_order': 'Importo inferiore al minimo del codice promo',
  'loyalty.payBySubscription': 'Paga con abbonamento',
  'loyalty.subscription': 'Abbonamento',
  'loyalty.pointsRedeemed': 'Punti riscattati al pagamento',
  'presence.editing': 'Questo record è attualmente modificato da',

  // ── Rozetka integration ──
  'rozetka.title': 'Rozetka Marketplace',
  'rozetka.subtitle': 'Integrazione con il marketplace Rozetka per la sincronizzazione degli ordini',
  'rozetka.login': 'Login (email venditore)',
  'rozetka.loginRequired': 'Inserisci il login',
  'rozetka.password': 'Password',
  'rozetka.save': 'Salva',
  'rozetka.saved': 'Impostazioni salvate',
  'rozetka.error': 'Errore: ',
  'rozetka.testConnection': 'Test connessione',
  'rozetka.testSuccess': 'Connessione riuscita',
  'rozetka.testError': 'Connessione fallita',
  'rozetka.ordersCount': 'Ordini',
  'rozetka.help': 'È necessario un account venditore Rozetka. Usa le stesse credenziali di seller.rozetka.com.ua',

  // ── Prom.ua integration ──
  'prom.title': 'Prom.ua',
  'prom.subtitle': 'Integrazione con il marketplace Prom.ua per la sincronizzazione degli ordini',
  'prom.apiToken': 'Token API',
  'prom.tokenRequired': 'Inserisci il token API',
  'prom.save': 'Salva',
  'prom.saved': 'Impostazioni salvate',
  'prom.error': 'Errore: ',
  'prom.testConnection': 'Test connessione',
  'prom.testSuccess': 'Connessione riuscita',
  'prom.testError': 'Connessione fallita',
  'prom.help': 'Per ottenere un token API: Pannello venditore → Impostazioni → Gestione token API. Crea un token con permessi ordini e prodotti.',

  // ── POS (vendita rapida) ──
  'pos.title': 'Negozio',
  'pos.selectWarehouse': 'Seleziona magazzino',
  'pos.noWarehouseHint': 'Seleziona un magazzino per iniziare a vendere',
  'pos.tariffPlan': 'Piano tariffario',
  'pos.standardPrice': 'Prezzo standard',
  'pos.search': 'Cerca prodotto...',
  'pos.allCategories': 'Tutti',
  'pos.outOfStock': 'Esaurito',
  'pos.noProducts': 'Nessun prodotto trovato',
  'pos.cart': 'Carrello',
  'pos.emptyCart': 'Il carrello è vuoto',
  'pos.subtotal': 'Subtotale',
  'pos.discount': 'Sconto',
  'pos.loyaltyPoints': 'Punti fedeltà',
  'pos.available': 'disponibile',
  'pos.total': 'Totale',
  'pos.coupon': 'Coupon',
  'pos.couponPlaceholder': 'Enter coupon code...',
  'pos.applyCoupon': 'Apply',
  'pos.invalidCoupon': 'Coupon is invalid or not found',
  'pos.cash': 'Contanti',
  'pos.card': 'Carta',
  'pos.transfer': 'Bonifico',
  'pos.cashGiven': 'Ricevuto',
  'pos.change': 'Resto',
  'pos.confirm': 'Conferma',
  'pos.saleComplete': 'Vendita completata!',
  'pos.returnTitle': 'Reso prodotto',
  'pos.returnHint': 'Indica le quantità da restituire',
  'pos.returnAmount': 'Importo del reso',
  'pos.confirmReturn': 'Restituire',
  'pos.tabSale': 'Vendita',
  'pos.tabHistory': 'Cronologia',
  'pos.historyEmpty': 'Nessuna vendita ancora',
  'pos.historyDate': 'Data',
  'pos.historyItems': 'Articoli',
  'pos.historyTotal': 'Totale',
  'pos.historyMethod': 'Metodo',
  'pos.historyAuthor': 'Autore',
  'pos.historyCancel': 'Annulla',
  'pos.historyCancelConfirm': 'Annullare questa vendita? Gli articoli torneranno in magazzino.',
  'pos.historyCancelled': 'Vendita annullata',
  'pos.historyCustomer': 'Cliente',
  'pos.historyReturn': 'Reso',
  'pos.historyReturned': 'Reso',
  'pos.partialReturn': 'Reso parziale',
  'pos.warehouse': 'Magazzino',
  'pos.customer': 'Cliente',
  'pos.selectCustomer': 'Cerca cliente...',
  'bizMonitor.title': 'Monitor Aziendale',
  'bizMonitor.subtitle': 'Panoramica strategica per il titolare',
  'bizMonitor.revenue': 'Fatturato', 'bizMonitor.profit': 'Profitto', 'bizMonitor.profitability': 'Redditività',
  'bizMonitor.activeClients': 'Clienti attivi', 'bizMonitor.retention': 'Retention',
  'bizMonitor.services': 'Servizi', 'bizMonitor.goods': 'Prodotti',
  'bizMonitor.new': 'Nuovi', 'bizMonitor.returning': 'Ricorrenti', 'bizMonitor.prevMonth': 'Mese prec.',
  'bizMonitor.revenueTrend': 'Tendenza fatturato', 'bizMonitor.clientHealth': 'Salute clienti',
  'bizMonitor.viewDetails': 'Dettagli', 'bizMonitor.newClients': 'Nuovi', 'bizMonitor.returningClients': 'Ricorrenti',
  'bizMonitor.sleeping': 'Inattivi (30g+)', 'bizMonitor.avgCheckServices': 'Scontrino medio servizi',
  'bizMonitor.avgCheckProducts': 'Scontrino medio prodotti', 'bizMonitor.channels': 'Canali di vendita',
  'bizMonitor.channelAppts': 'Appuntamenti', 'bizMonitor.channelOrders': 'Ordini', 'bizMonitor.channelPos': 'POS',
  'bizMonitor.topStaff': 'Top dipendenti', 'bizMonitor.topServices': 'Top servizi', 'bizMonitor.topProducts': 'Top prodotti',
  'bizMonitor.appointments': 'appuntamenti', 'bizMonitor.times': 'volte', 'bizMonitor.pcs': 'pz', 'bizMonitor.margin': 'Margine',
  'bizMonitor.stockAnalytics': 'Magazzino', 'bizMonitor.stockValue': 'Valore stock', 'bizMonitor.positions': 'articoli',
  'bizMonitor.lowStockCount': 'Stock basso', 'bizMonitor.noMovementCount': 'Senza movimento 30g+',
  'bizMonitor.alerts': 'Richiede attenzione', 'bizMonitor.alertFinance': 'Finanze', 'bizMonitor.alertClients': 'Clienti',
  'bizMonitor.alertStock': 'Prodotti/Magazzino', 'bizMonitor.alertStaff': 'Personale', 'bizMonitor.noData': 'Nessun dato',
  'sidebar.businessMonitor': 'Monitor Aziendale',

  // ── Comunicazione: chiavi mancanti rispetto a uk (2026-09-25) ──
  'nav.instagram': 'Instagram',
  'nav.messenger': 'Messenger',
  'instagram.tagline': 'I messaggi diretti del tuo account Instagram Business — nel CRM',
  'instagram.connected': 'Connesso',
  'instagram.notConnected': 'Non connesso',
  'instagram.connectIntro': 'Collega il tuo account Instagram Business tramite OAuth per ricevere i messaggi diretti dei clienti direttamente nel CRM.',
  'instagram.connectBtn': 'Collega Instagram',
  'instagram.tabOpened': 'Instagram si è aperto in una nuova scheda. Accedi e torna qui.',
  'instagram.connectFailed': 'Errore di connessione:',
  'instagram.confirmDisconnect': 'Scollegare l’integrazione Instagram?',
  'instagram.disconnected': 'Instagram scollegato',
  'instagram.disconnectBtn': 'Scollega',
  'instagram.testBtn': 'Verifica connessione',
  'instagram.testOk': 'La connessione funziona:',
  'instagram.testFailed': 'Test non riuscito',
  'instagram.account': 'Account',
  'instagram.userId': 'IG User ID',
  'instagram.scope': 'Permessi',
  'instagram.connectedAt': 'Collegato il',
  'instagram.expiresAt': 'Valido fino al',
  'instagram.reconnectRequired': 'Serve una nuova autorizzazione',
  'instagram.reconnectExplain': 'Non è stato possibile rinnovare il token a lunga durata (di solito dopo più di 60 giorni di inattività o un cambio della password Instagram). Premi «Collega Instagram» per continuare a ricevere i messaggi.',
  'instagram.howItWorks': 'Come funziona',
  'instagram.step1': 'Premi «Collega Instagram»: l’autorizzazione Instagram si aprirà in una nuova scheda.',
  'instagram.step2': 'Accedi al tuo account Instagram Business (account professionale collegato a una Pagina Facebook) e consenti all’app l’accesso ai messaggi diretti.',
  'instagram.step3': 'Torna su questa scheda: lo stato si aggiorna da solo; verifica con «Verifica connessione».',
  'instagram.capabilities': 'Cosa offre il collegamento',
  'instagram.capInboxTitle': 'Messaggi diretti — nel CRM',
  'instagram.capInboxText': 'Tutti i messaggi di Instagram Direct arrivano in Comunicazione in tempo reale tramite i webhook Meta, accanto a Telegram, SMS ed e-mail.',
  'instagram.capOutboundTitle': 'Rispondi dal CRM direttamente su Instagram',
  'instagram.capOutboundText': 'Apri la conversazione in Comunicazione e scegli il canale «Instagram»: il messaggio arriva nel Direct del cliente.',
  'instagram.limitations': 'Limitazioni',
  'instagram.limitationsText': 'Funziona solo con account professionali Instagram (Business o Creator) collegati a una Pagina Facebook. Meta non supporta gli account personali nella Messaging API.',
  'instagram.resubscribed': 'Iscrizione ai webhook rinnovata. Premi «Verifica connessione» per vedere il nuovo stato.',
  'instagram.resubscribeFailed': 'Impossibile rinnovare l’iscrizione:',
  'instagram.errorPrefix': 'Errore:',
  'custModal.subscriptionPurchase': 'Acquisto abbonamento',
  'custModal.subscriptionRefund': 'Rimborso abbonamento',
  'custModal.methodOnline': 'Online',
  'custModal.methodSubscription': 'Abbonamento',
  'custModal.servicesLabel': 'Servizi',
  'custModal.messageSent': 'Inviato',
  'emailSet.provider': 'Servizio di posta',
  'emailSet.presetGmail': 'Gmail / Google Workspace',
  'emailSet.presetOutlook': 'Outlook / Microsoft 365',
  'emailSet.presetUkrnet': 'Ukr.net',
  'emailSet.presetMeta': 'Meta.ua',
  'emailSet.presetCustom': 'SMTP personalizzato',
  'emailSet.hintGmail': 'Serve una password per le app da myaccount.google.com/apppasswords (prima attiva la verifica in due passaggi)',
  'emailSet.hintOutlook': 'Il login è l’indirizzo completo (you@outlook.com). Con la verifica in due passaggi può servire una password per le app',
  'emailSet.hintUkrnet': 'In Ukr.net: Impostazioni → Posta → Consenti l’accesso ai client di posta esterni',
  'emailSet.hintMeta': 'In Meta.ua: Impostazioni → IMAP/SMTP → Attiva',
  'emailSet.hintCustom': 'Inserisci manualmente host, porta e credenziali del tuo server di posta',
  'emailSet.host': 'Server SMTP',
  'emailSet.port': 'Porta',
  'emailSet.secure': 'TLS/SSL',
  'emailSet.smtpUser': 'Login SMTP',
  'emailSet.smtpUserHint': 'Di solito l’indirizzo e-mail completo',
  'emailSet.password': 'Password SMTP',
  'emailSet.passwordHint': 'Per Gmail/Outlook: password per le app, non quella principale',
  'emailSet.fromEmail': 'Indirizzo del mittente',
  'emailSet.fromEmailHint': 'Se vuoto, viene usato il login SMTP',
  'emailSet.invalidEmail': 'Indirizzo e-mail non valido (serve user@domain.com)',
  'emailSet.sectionProvider': 'Servizio di posta e server',
  'emailSet.sectionCredentials': 'Credenziali',
  'emailSet.sectionFrom': 'Mittente',
  'emailSet.howToConnect': 'Come collegare {provider}',
  'emailSet.instrGmail': '<ol><li>Attiva la verifica in due passaggi sul tuo account Google: <a href="https://myaccount.google.com/security" target="_blank">myaccount.google.com/security</a> → <strong>Verifica in due passaggi</strong> → <strong>Attiva</strong>.</li><li>Vai su <a href="https://myaccount.google.com/apppasswords" target="_blank">myaccount.google.com/apppasswords</a>.</li><li>Crea una password per le app: tipo <strong>Mail</strong> (oppure <strong>Altro</strong> con il nome <code>Systemic CRM</code>).</li><li>Copia la password di 16 caratteri (ha la forma <code>abcd efgh ijkl mnop</code>).</li><li>Incollala nel campo <strong>Password SMTP</strong> qui sopra e premi <strong>Invia e-mail di prova</strong>.</li></ol>',
  'emailSet.instrOutlook': '<ol><li>Accedi a <a href="https://account.microsoft.com/security" target="_blank">account.microsoft.com/security</a>.</li><li>Apri <strong>Opzioni di sicurezza avanzate</strong>.</li><li>In <strong>Password per le app</strong> premi <strong>Crea una nuova password</strong>.</li><li>Copia la password generata e incollala in <strong>Password SMTP</strong>.</li><li><em>Se l’opzione «Password per le app» non c’è, attiva prima la verifica in due passaggi.</em></li></ol>',
  'emailSet.instrUkrnet': '<ol><li>Accedi alla posta Ukr.net.</li><li>Vai in <strong>Impostazioni → Tutte le impostazioni → Programmi di posta</strong>.</li><li>Attiva l’<strong>accesso IMAP/SMTP</strong>.</li><li>Nel campo <strong>Password SMTP</strong> inserisci la password principale della posta Ukr.net.</li><li><em>Se hai la verifica in due passaggi attiva, crea una password per le app separata nelle impostazioni di sicurezza.</em></li></ol>',
  'emailSet.instrMeta': '<ol><li>Accedi alla posta Meta.ua.</li><li>Vai in <strong>Impostazioni → IMAP/SMTP</strong>.</li><li>Attiva il protocollo SMTP.</li><li>Inserisci la password principale della posta nel campo <strong>Password SMTP</strong>.</li></ol>',
  'emailSet.instrCustom': '<ol><li>Chiedi all’amministratore di sistema o al provider di hosting i parametri SMTP del tuo server di posta.</li><li>Di solito servono: <strong>host</strong> (smtp.tuo-dominio.com), <strong>porta</strong> (587 o 465), <strong>TLS/SSL</strong> (per 465: attivo).</li><li>Il login è l’indirizzo e-mail completo.</li><li>La password è quella con cui accedi alla posta (o una password SMTP separata se il provider la fornisce).</li></ol>',
  'notifAuto.title': 'Impostazioni comunicazione',
  'notifAuto.subtitle': 'Priorità dei canali, messaggi automatici e promemoria',
  'notifAuto.navItem': 'Impostazioni comunicazione',
  'notifAuto.sectionDefaultPriority': 'Priorità predefinita per i messaggi manuali',
  'notifAuto.defaultPriorityHint': 'Quando l’amministratore scrive a un cliente in Comunicazione per la prima volta, viene scelto il primo canale disponibile di questa lista; in seguito resta il canale usato l’ultima volta con quel cliente. Trascina per riordinare, disattiva quelli che non usi.',
  'notifAuto.sectionBooking': 'Messaggio alla creazione di un appuntamento',
  'notifAuto.sectionOrder': 'Messaggio alla creazione di un ordine di prodotti',
  'notifAuto.enable': 'Attiva',
  'notifAuto.mode': 'Modalità di invio',
  'notifAuto.modePriority': 'Priorità (primo canale disponibile)',
  'notifAuto.modeAll': 'Tutti i canali insieme',
  'notifAuto.channelsOrder': 'Priorità dei canali (trascina per riordinare)',
  'notifAuto.channelsEmpty': 'Nessun canale attivo: attivane almeno uno qui sotto',
  'notifAuto.otherChannels': 'Altri canali',
  'notifAuto.dragHint': 'Trascina per cambiare l’ordine',
  'notifAuto.channelNotConfigured': 'Il canale non è configurato nella sua sezione: il messaggio non verrà inviato',
  'notifAuto.channelTelegram': 'Telegram',
  'notifAuto.channelSms': 'SMS',
  'notifAuto.channelEmail': 'E-mail',
  'notifAuto.channelWeb': 'Chat del sito',
  'notifAuto.template': 'Modello del messaggio',
  'notifAuto.templateHint': 'Variabili disponibili: {clientName}, {date}, {time}, {serviceName}, {staffName}, {locationName}, {phone}, {orderNumber}, {total}, {items}',
  'notifAuto.templateHtmlNote': 'Supporta HTML per Telegram/E-mail; per gli SMS viene convertito automaticamente in testo semplice',
  'notifAuto.preview': 'Anteprima',
  'notifAuto.previewHint': 'Esempio con dati di prova',
  'notifAuto.save': 'Salva',
  'notifAuto.saved': 'Impostazioni salvate',
  'notifAuto.moveUp': 'Su',
  'notifAuto.moveDown': 'Giù',
  'notifAuto.defaultBookingTemplate': 'Ciao {clientName}! Il tuo appuntamento è confermato per il {date} alle {time}. Servizio: {serviceName}, specialista: {staffName}. Ti aspettiamo!',
  'notifAuto.defaultOrderTemplate': 'Grazie per l’ordine n. {orderNumber} di {total} ₴. Ti contatteremo per confermare la consegna.',
  'notifAuto.sectionReminders': 'Promemoria prima della visita',
  'notifAuto.remindersHint': 'Puoi aggiungere più regole con intervalli diversi (ad esempio 24 ore e 2 ore prima). Minimo: 1 ora.',
  'notifAuto.noReminders': 'Nessun promemoria configurato',
  'notifAuto.addReminder': 'Aggiungi promemoria',
  'notifAuto.removeReminder': 'Elimina promemoria',
  'notifAuto.hoursBefore': 'Quanto prima della visita',
  'notifAuto.hoursBeforeUnit': 'ore',
  'notifAuto.defaultReminderTemplate': 'Promemoria: la tua visita è il {date} alle {time}. Servizio: {serviceName}, specialista: {staffName}. Ti aspettiamo!',
  'comm.filterAll': 'Tutti',
  'comm.channelWeb': 'Chat del sito',
  'comm.noChannelsForClient': 'Il cliente non ha canali di contatto collegati',
  'comm.addContactToCard': 'Aggiungi un telefono o un’e-mail nella scheda cliente, oppure inviagli il link al bot Telegram',
  'sms.testText': 'Systemic CRM: messaggio di prova.',
  'sms.testSent': 'Inviato: controlla il telefono',
  'sms.testNotSent': 'Non inviato',
  'sms.senderRule1': 'Massimo 11 caratteri latini, senza spazi: è il limite dello standard GSM. Il nome deve essere',
  'sms.senderRuleStrong': 'registrato nel pannello del provider',
  'sms.senderRule2': 'e coincidere carattere per carattere, maiuscole comprese.',
  'sms.lastFailed': 'L’ultimo invio non è riuscito',
  'sms.lastOk': 'Ultimo invio riuscito',
  'sms.testLabel': 'Prova con un SMS reale',
  'telegram.statusChecking': 'Verifica dello stato del bot…',
  'telegram.statusRecheck': 'Verifica',
  'telegram.statusLastError': 'Ultimo errore:',
  'telegram.statusBot': 'Bot',
  'telegram.statusWebhook': 'Webhook',
  'telegram.statusWebhookNone': 'non impostato',
  'telegram.statusWebhookExpected': 'atteso',
  'telegram.statusQueue': 'In coda',
  'telegram.statusSubscribers': 'Iscritti',
  'telegram.statusSubscribersSub': 'clienti che hanno premuto «Avvia»',
  'telegram.verdictOk': 'Il bot è collegato e funziona',
  'telegram.verdictNoToken': 'Il bot non è configurato',
  'telegram.verdictNoTokenHint': 'Incolla il token di @BotFather e premi «Salva e collega».',
  'telegram.verdictBadToken': 'Token non valido',
  'telegram.verdictBadTokenHint': 'Il bot è stato eliminato o il token è stato rigenerato in @BotFather. Incolla quello nuovo.',
  'telegram.verdictNoWebhook': 'Webhook non impostato',
  'telegram.verdictNoWebhookHint': 'Telegram non sa dove inviare gli aggiornamenti. Premi «Salva e collega».',
  'telegram.verdictHostMismatch': 'Il webhook punta a un altro indirizzo',
  'telegram.verdictHostMismatchHint': 'Succede di solito quando il bot è stato collegato da un link di prova. Premi «Salva e collega» a questo indirizzo.',
  'telegram.verdictWebhookError': 'Telegram non riesce a raggiungerci',
  'telegram.verdictPending': 'Aggiornamenti bloccati in coda',
  'telegram.verdictPendingHint': 'Telegram ha accumulato aggiornamenti che non è riuscito a consegnare.',
  'telegram.verdictNoSubscribers': 'Il bot funziona, ma non ha iscritti',
  'telegram.verdictNoSubscribersHint': 'Nessun cliente ha ancora premuto «Avvia» nel bot. Il link personale è nella scheda cliente.',
  'telegram.verdictUnreachable': 'Impossibile verificare lo stato',
  'telegram.statusForward': 'Inoltro',
  'telegram.statusForwardOk': 'funziona',
  'telegram.statusForwardError': 'errore',
  'telegram.statusForwardPending': 'ancora nessun aggiornamento',
  'telegram.fwdTitle': 'Bot esterno: menu e flussi',
  'telegram.fwdIntro': 'Se questo bot ha un server separato per i menu (pulsanti, flussi), Systemic resta proprietario del webhook e gli inoltra una copia di ogni aggiornamento. Conversazioni e risposte degli operatori restano qui, come prima.',
  'telegram.fwdUrl': 'Indirizzo di inoltro (https)',
  'telegram.fwdUrlHint': 'Lascia vuoto per disattivare l’inoltro.',
  'telegram.fwdSecret': 'Password di inoltro',
  'telegram.fwdSecretHint': 'Una stringa a tua scelta. Systemic la invia nell’header X-Systemic-Secret e una firma del corpo in X-Systemic-Signature, così il server esterno verifica che la richiesta arriva da noi.',
  'telegram.fwdSecretStored': 'La password è salvata sul server e non viene rimandata al browser. Inseriscine una nuova per sostituirla.',
  'telegram.fwdSave': 'Salva inoltro',
  'telegram.fwdSaved': 'Inoltro salvato',
  'telegram.fwdInvalidUrl': 'L’indirizzo deve iniziare con https://',
  'telegram.fwdHowTitle': 'Come funziona e cosa tenere presente',
  'telegram.fwdHow1': 'Il webhook del bot resta a Systemic. Il server esterno non deve cambiarlo: la scheda di stato mostrerebbe «Il webhook punta a un altro indirizzo» e «Salva e collega» lo riprenderebbe.',
  'telegram.fwdHow2': 'Systemic elabora ogni aggiornamento (conversazioni, collegamento del cliente, telefono) e in parallelo inoltra una copia all’indirizzo indicato, comprese le pressioni dei pulsanti, che Systemic ignora.',
  'telegram.fwdHow3': 'Il server esterno mostra i menu tramite il token del bot. È interfaccia, non conversazione: non arriva in Comunicazione. Ai clienti rispondono gli operatori da Systemic.',
  'telegram.fwdHow4': 'Costruisci i menu con pulsanti inline (sotto il messaggio). La tastiera in basso invia le pressioni come testo e la conversazione dell’operatore si riempie di «Servizi», «Indietro».',
  'telegram.fwdHow5': 'Systemic risponde già a /start: saluta e chiede il numero per trovare il cliente. Mostra il menu dopo oppure con un comando a parte, altrimenti il cliente riceve due messaggi di fila.',
  'telegram.fwdHow6': 'Il server deve rispondere 200 entro 4 secondi. Nessun nuovo tentativo; lo stato dell’ultimo inoltro è nella scheda di stato qui sopra.',
  'messengerSet.tagline': 'I messaggi della tua Pagina Facebook — nel CRM',
  'messengerSet.tabOpened': 'Facebook si è aperto in una nuova scheda. Accedi e torna qui.',
  'messengerSet.connectFailed': 'Errore di connessione:',
  'messengerSet.confirmDisconnect': 'Scollegare l’integrazione Messenger?',
  'messengerSet.disconnected': 'Messenger scollegato',
  'messengerSet.pageActivated': 'Pagina «{name}» attivata',
  'messengerSet.subscribeFailed': 'Pagina attivata, ma l’iscrizione al webhook non è riuscita: {error}. Premi «Rinnova iscrizione ai webhook».',
  'messengerSet.activateFailed': 'Impossibile attivare la pagina',
  'messengerSet.errorPrefix': 'Errore:',
  'messengerSet.pagesRefreshed': 'Elenco pagine aggiornato',
  'messengerSet.resubscribed': 'Iscrizione ai webhook rinnovata. Premi «Verifica connessione».',
  'messengerSet.resubscribeFailed': 'Impossibile rinnovare l’iscrizione:',
  'messengerSet.needsReconnect': 'Serve una nuova autorizzazione',
  'messengerSet.reconnectHint': 'Facebook ha revocato il token. Premi «Collega» per continuare.',
  'messengerSet.howTitle': 'Come funziona',
  'messengerSet.how1': 'Premi «Collega Messenger»: Facebook aprirà l’autorizzazione in una nuova scheda.',
  'messengerSet.how2': 'Consenti all’app di gestire i messaggi delle tue pagine.',
  'messengerSet.how3': 'Torna qui: vedrai l’elenco delle tue Pagine Facebook. Scegline una per il CRM.',
  'messengerSet.how4': 'Fatto. I messaggi di quella pagina arrivano automaticamente in Comunicazione.',
  'messengerSet.givesTitle': 'Cosa offre il collegamento',
  'messengerSet.capInboxTitle': 'Messaggi della Pagina Facebook — nel CRM',
  'messengerSet.capInboxText': 'Tutti i messaggi alla tua pagina arrivano in Comunicazione in tempo reale, accanto a Telegram, SMS ed e-mail.',
  'messengerSet.capReplyTitle': 'Rispondi dal CRM direttamente su Messenger',
  'messengerSet.capReplyText': 'Apri la conversazione in Comunicazione e scegli il canale «Messenger»: la risposta arriva al cliente. Meta consente di rispondere entro 24 ore dal suo messaggio.',
  'messengerSet.limitsLabel': 'Limitazioni:',
  'messengerSet.limitsText': 'Funziona solo con le Pagine aziendali Facebook, non con i profili personali.',
  'messengerSet.statusOff': 'Non connesso',
  'messengerSet.statusPending': 'In attesa della scelta della pagina',
  'messengerSet.statusOn': 'Connesso',
  'messengerSet.connectIntro': 'Collega il tuo account Facebook e scegli la Pagina i cui messaggi arriveranno nel CRM.',
  'messengerSet.connectBtn': 'Collega Messenger',
  'messengerSet.noPages': 'Nessuna Pagina Facebook trovata su questo account. Creane una su facebook.com → Pages, poi aggiorna l’elenco.',
  'messengerSet.refreshPages': 'Aggiorna elenco pagine',
  'messengerSet.disconnectBtn': 'Scollega',
  'messengerSet.pickIntro': 'Scegli la Pagina Facebook da cui il CRM riceverà i messaggi:',
  'messengerSet.pageActive': 'Attiva',
  'messengerSet.pageUse': 'Usa',
  'messengerSet.refreshList': 'Aggiorna elenco',
  'messengerSet.fbAccount': 'Account Facebook:',
  'messengerSet.activePage': 'Pagina attiva:',
  'messengerSet.connectedAt': 'Collegato il:',
  'messengerSet.userTokenUntil': 'Token utente valido fino al:',
  'messengerSet.unknown': '(sconosciuto)',
  'messengerSet.testBtn': 'Verifica connessione',
  'messengerSet.resubscribeBtn': 'Rinnova iscrizione ai webhook',
  'messengerSet.switchPage': 'Cambia pagina',
  'messengerSet.patOk': '✓ Il token della pagina è valido:',
  'messengerSet.patFailed': '✗ Il token della pagina non ha superato la verifica:',
  'messengerSet.subsTitle': 'Iscrizioni ai webhook:',
  'messengerSet.noApps': 'Nessuna app è iscritta a questa pagina. Premi «Rinnova iscrizione ai webhook».',
  'messengerSet.subscribedFields': 'Campi iscritti:',
  'messengerSet.noMessagesField': '⚠ Manca il campo «messages»: Meta non consegnerà i messaggi. Premi «Rinnova iscrizione ai webhook».',
  'messengerSet.subsFailed': '✗ La verifica delle iscrizioni non è riuscita:',
};

export default it;
